function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useInfiniteQuery, useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import mutator from "../utils/mutator.js";
const getHealth = (options, signal)=>mutator({
        url: "/health",
        method: 'GET',
        signal
    }, options);
const getGetHealthInfiniteQueryKey = ()=>[
        'infinite',
        "/health"
    ];
const getGetHealthQueryKey = ()=>[
        "/health"
    ];
const getGetHealthInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealth(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthInfinite(options, queryClient) {
    const queryOptions = getGetHealthInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetHealthQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealth(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealth(options, queryClient) {
    const queryOptions = getGetHealthQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetHealthSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealth(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthSuspense(options, queryClient) {
    const queryOptions = getGetHealthSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getHealthLiveness = (options, signal)=>mutator({
        url: "/health/liveness",
        method: 'GET',
        signal
    }, options);
const getGetHealthLivenessInfiniteQueryKey = ()=>[
        'infinite',
        "/health/liveness"
    ];
const getGetHealthLivenessQueryKey = ()=>[
        "/health/liveness"
    ];
const getGetHealthLivenessInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthLivenessInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealthLiveness(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthLivenessInfinite(options, queryClient) {
    const queryOptions = getGetHealthLivenessInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetHealthLivenessQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthLivenessQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealthLiveness(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthLiveness(options, queryClient) {
    const queryOptions = getGetHealthLivenessQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetHealthLivenessSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthLivenessQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealthLiveness(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthLivenessSuspense(options, queryClient) {
    const queryOptions = getGetHealthLivenessSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getHealthReadiness = (options, signal)=>mutator({
        url: "/health/readiness",
        method: 'GET',
        signal
    }, options);
const getGetHealthReadinessInfiniteQueryKey = ()=>[
        'infinite',
        "/health/readiness"
    ];
const getGetHealthReadinessQueryKey = ()=>[
        "/health/readiness"
    ];
const getGetHealthReadinessInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthReadinessInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealthReadiness(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthReadinessInfinite(options, queryClient) {
    const queryOptions = getGetHealthReadinessInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetHealthReadinessQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthReadinessQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealthReadiness(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthReadiness(options, queryClient) {
    const queryOptions = getGetHealthReadinessQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetHealthReadinessSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetHealthReadinessQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getHealthReadiness(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetHealthReadinessSuspense(options, queryClient) {
    const queryOptions = getGetHealthReadinessSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getRoot = (options, signal)=>mutator({
        url: "/",
        method: 'GET',
        signal
    }, options);
const getGetRootInfiniteQueryKey = ()=>[
        'infinite',
        "/"
    ];
const getGetRootQueryKey = ()=>[
        "/"
    ];
const getGetRootInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetRootInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getRoot(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetRootInfinite(options, queryClient) {
    const queryOptions = getGetRootInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetRootQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetRootQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getRoot(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetRoot(options, queryClient) {
    const queryOptions = getGetRootQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetRootSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetRootQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getRoot(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetRootSuspense(options, queryClient) {
    const queryOptions = getGetRootSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationSummary = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/summary"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationSummaryInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/summary")
    ];
};
const getGetApplicationSummaryQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/summary")
    ];
};
const getGetApplicationSummaryInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSummaryInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSummary({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationSummaryInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationSummaryInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationSummaryQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSummaryQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSummary({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationSummary(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationSummaryQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationSummarySuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSummaryQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSummary({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationSummarySuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationSummarySuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationOverview = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/overview"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationOverviewInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/overview")
    ];
};
const getGetApplicationOverviewQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/overview")
    ];
};
const getGetApplicationOverviewInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationOverviewInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationOverview({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationOverviewInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationOverviewInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationOverviewQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationOverviewQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationOverview({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationOverview(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationOverviewQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationOverviewSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationOverviewQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationOverview({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationOverviewSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationOverviewSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationConsumers = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/consumers"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationConsumersInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/consumers"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationConsumersQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/consumers"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationConsumersInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConsumersInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConsumers({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationConsumersInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationConsumersInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationConsumersQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConsumersQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConsumers({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationConsumers(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationConsumersQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationConsumersSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConsumersQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConsumers({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationConsumersSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationConsumersSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationUmlSidebar = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/uml-sidebar"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationUmlSidebarInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/uml-sidebar"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationUmlSidebarQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/uml-sidebar"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationUmlSidebarInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationUmlSidebarInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationUmlSidebar({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationUmlSidebarInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationUmlSidebarInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationUmlSidebarQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationUmlSidebarQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationUmlSidebar({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationUmlSidebar(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationUmlSidebarQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationUmlSidebarSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationUmlSidebarQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationUmlSidebar({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationUmlSidebarSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationUmlSidebarSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectApplicationListByProjectName = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetProjectApplicationListByProjectNameInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectApplicationListByProjectNameQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectApplicationListByProjectNameInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationListByProjectNameInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationListByProjectName({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectApplicationListByProjectNameInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationListByProjectNameInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectApplicationListByProjectNameQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationListByProjectNameQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationListByProjectName({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectApplicationListByProjectName(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationListByProjectNameQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectApplicationListByProjectNameSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationListByProjectNameQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationListByProjectName({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectApplicationListByProjectNameSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationListByProjectNameSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationSidebarList = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/sidebar"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationSidebarListInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/sidebar")
    ];
};
const getGetApplicationSidebarListQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/sidebar")
    ];
};
const getGetApplicationSidebarListInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSidebarListInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSidebarList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetApplicationSidebarListInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetApplicationSidebarListInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationSidebarListQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSidebarListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSidebarList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetApplicationSidebarList(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetApplicationSidebarListQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationSidebarListSuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSidebarListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSidebarList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationSidebarListSuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetApplicationSidebarListSuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectApplicationSidebarList = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/side-bar-list"),
        method: 'GET',
        signal
    }, options);
};
const getGetProjectApplicationSidebarListInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/side-bar-list")
    ];
};
const getGetProjectApplicationSidebarListQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/side-bar-list")
    ];
};
const getGetProjectApplicationSidebarListInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationSidebarListInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationSidebarList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectApplicationSidebarListInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationSidebarListInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectApplicationSidebarListQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationSidebarListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationSidebarList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectApplicationSidebarList(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationSidebarListQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectApplicationSidebarListSuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationSidebarListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationSidebarList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectApplicationSidebarListSuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationSidebarListSuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationListByProject = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project))),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationListByProjectInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationListByProjectQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationListByProjectInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationListByProjectInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationListByProject({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetApplicationListByProjectInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetApplicationListByProjectInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationListByProjectQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationListByProjectQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationListByProject({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetApplicationListByProject(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetApplicationListByProjectQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationListByProjectSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationListByProjectQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationListByProject({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationListByProjectSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetApplicationListByProjectSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationSettings = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/settings"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationSettingsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/settings")
    ];
};
const getGetApplicationSettingsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/settings")
    ];
};
const getGetApplicationSettingsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSettingsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSettings({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationSettingsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationSettingsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationSettingsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSettingsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSettings({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationSettings(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationSettingsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationSettingsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationSettingsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationSettings({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationSettingsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationSettingsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateApplicationSettings = (param, updateApplicationSettingsBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/settings"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateApplicationSettingsBody,
        signal
    }, options);
};
const getUpdateApplicationSettingsMutationOptions = (options)=>{
    const mutationKey = [
        'updateApplicationSettings'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateApplicationSettings(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateApplicationSettings = (options, queryClient)=>useMutation(getUpdateApplicationSettingsMutationOptions(options), queryClient);
const getApplication = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/details"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/details")
    ];
};
const getGetApplicationQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/details")
    ];
};
const getGetApplicationInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplication({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplication({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplication(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplication({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationModule = (param, options, signal)=>{
    let { organization, project, application, moduleName } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/module/").concat(encodeURIComponent(String(moduleName))),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationModuleInfiniteQueryKey = (param)=>{
    let { organization, project, application, moduleName } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/module/").concat(moduleName)
    ];
};
const getGetApplicationModuleQueryKey = (param)=>{
    let { organization, project, application, moduleName } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/module/").concat(moduleName)
    ];
};
const getGetApplicationModuleInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, moduleName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationModuleInfiniteQueryKey({
        organization,
        project,
        application,
        moduleName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationModule({
            organization,
            project,
            application,
            moduleName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && moduleName)
    }, queryOptions);
};
function useGetApplicationModuleInfinite(param, options, queryClient) {
    let { organization, project, application, moduleName } = param;
    const queryOptions = getGetApplicationModuleInfiniteQueryOptions({
        organization,
        project,
        application,
        moduleName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationModuleQueryOptions = (param, options)=>{
    let { organization, project, application, moduleName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationModuleQueryKey({
        organization,
        project,
        application,
        moduleName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationModule({
            organization,
            project,
            application,
            moduleName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && moduleName)
    }, queryOptions);
};
function useGetApplicationModule(param, options, queryClient) {
    let { organization, project, application, moduleName } = param;
    const queryOptions = getGetApplicationModuleQueryOptions({
        organization,
        project,
        application,
        moduleName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationModuleSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, moduleName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationModuleQueryKey({
        organization,
        project,
        application,
        moduleName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationModule({
            organization,
            project,
            application,
            moduleName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationModuleSuspense(param, options, queryClient) {
    let { organization, project, application, moduleName } = param;
    const queryOptions = getGetApplicationModuleSuspenseQueryOptions({
        organization,
        project,
        application,
        moduleName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationContributors = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/contributors"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationContributorsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/contributors")
    ];
};
const getGetApplicationContributorsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/contributors")
    ];
};
const getGetApplicationContributorsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationContributorsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationContributors({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationContributorsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationContributorsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationContributorsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationContributorsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationContributors({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationContributors(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationContributorsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationContributorsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationContributorsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationContributors({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationContributorsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationContributorsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationContributorsWithVersionCount = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/contributors/versions"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationContributorsWithVersionCountInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/contributors/versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationContributorsWithVersionCountQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/contributors/versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationContributorsWithVersionCountInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationContributorsWithVersionCountInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationContributorsWithVersionCount({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationContributorsWithVersionCountInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationContributorsWithVersionCountInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationContributorsWithVersionCountQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationContributorsWithVersionCountQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationContributorsWithVersionCount({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationContributorsWithVersionCount(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationContributorsWithVersionCountQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationContributorsWithVersionCountSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationContributorsWithVersionCountQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationContributorsWithVersionCount({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationContributorsWithVersionCountSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationContributorsWithVersionCountSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationActivityOverTime = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/activity"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationActivityOverTimeInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/activity"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationActivityOverTimeQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/activity"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationActivityOverTimeInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationActivityOverTimeInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationActivityOverTime({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationActivityOverTimeInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationActivityOverTimeInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationActivityOverTimeQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationActivityOverTimeQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationActivityOverTime({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationActivityOverTime(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationActivityOverTimeQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationActivityOverTimeSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationActivityOverTimeQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationActivityOverTime({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationActivityOverTimeSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationActivityOverTimeSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const createApplication = (param, createApplicationRequest, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/project/").concat(encodeURIComponent(String(project)), "/application"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createApplicationRequest,
        signal
    }, options);
};
const getCreateApplicationMutationOptions = (options)=>{
    const mutationKey = [
        'createApplication'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return createApplication(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateApplication = (options, queryClient)=>useMutation(getCreateApplicationMutationOptions(options), queryClient);
const updateApplication = (param, updateApplicationRequest, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application))),
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateApplicationRequest,
        signal
    }, options);
};
const getUpdateApplicationMutationOptions = (options)=>{
    const mutationKey = [
        'updateApplication'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateApplication(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateApplication = (options, queryClient)=>useMutation(getUpdateApplicationMutationOptions(options), queryClient);
const deleteApplicationSingular = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteApplicationSingularMutationOptions = (options)=>{
    const mutationKey = [
        'deleteApplicationSingular'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteApplicationSingular(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteApplicationSingular = (options, queryClient)=>useMutation(getDeleteApplicationSingularMutationOptions(options), queryClient);
const updateApplicationName = (param, updateApplicationNameBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/name"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateApplicationNameBody,
        signal
    }, options);
};
const getUpdateApplicationNameMutationOptions = (options)=>{
    const mutationKey = [
        'updateApplicationName'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateApplicationName(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateApplicationName = (options, queryClient)=>useMutation(getUpdateApplicationNameMutationOptions(options), queryClient);
const getApplicationAuditLogAuthors = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/audit-log/authors"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationAuditLogAuthorsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/audit-log/authors")
    ];
};
const getGetApplicationAuditLogAuthorsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/audit-log/authors")
    ];
};
const getGetApplicationAuditLogAuthorsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationAuditLogAuthorsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationAuditLogAuthors({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationAuditLogAuthorsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationAuditLogAuthorsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationAuditLogAuthorsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationAuditLogAuthorsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationAuditLogAuthors({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationAuditLogAuthors(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationAuditLogAuthorsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationAuditLogAuthorsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationAuditLogAuthorsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationAuditLogAuthors({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationAuditLogAuthorsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationAuditLogAuthorsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationAuditLog = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/audit-log"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationAuditLogInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/audit-log"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationAuditLogQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/audit-log"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationAuditLogInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationAuditLogInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationAuditLog({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationAuditLogInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationAuditLogInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationAuditLogQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationAuditLogQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationAuditLog({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationAuditLog(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationAuditLogQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationAuditLogSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationAuditLogQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationAuditLog({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationAuditLogSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationAuditLogSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationVersionList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationVersionListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationVersionListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationVersionListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationVersionListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationVersionList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationVersionListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationVersionDetail = (param, options, signal)=>{
    let { organization, project, application, version } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions/").concat(encodeURIComponent(String(version))),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationVersionDetailInfiniteQueryKey = (param)=>{
    let { organization, project, application, version } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/versions/").concat(version)
    ];
};
const getGetApplicationVersionDetailQueryKey = (param)=>{
    let { organization, project, application, version } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/versions/").concat(version)
    ];
};
const getGetApplicationVersionDetailInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, version } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionDetailInfiniteQueryKey({
        organization,
        project,
        application,
        version
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionDetail({
            organization,
            project,
            application,
            version
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && version)
    }, queryOptions);
};
function useGetApplicationVersionDetailInfinite(param, options, queryClient) {
    let { organization, project, application, version } = param;
    const queryOptions = getGetApplicationVersionDetailInfiniteQueryOptions({
        organization,
        project,
        application,
        version
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionDetailQueryOptions = (param, options)=>{
    let { organization, project, application, version } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionDetailQueryKey({
        organization,
        project,
        application,
        version
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionDetail({
            organization,
            project,
            application,
            version
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && version)
    }, queryOptions);
};
function useGetApplicationVersionDetail(param, options, queryClient) {
    let { organization, project, application, version } = param;
    const queryOptions = getGetApplicationVersionDetailQueryOptions({
        organization,
        project,
        application,
        version
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionDetailSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, version } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionDetailQueryKey({
        organization,
        project,
        application,
        version
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionDetail({
            organization,
            project,
            application,
            version
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationVersionDetailSuspense(param, options, queryClient) {
    let { organization, project, application, version } = param;
    const queryOptions = getGetApplicationVersionDetailSuspenseQueryOptions({
        organization,
        project,
        application,
        version
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationCounters = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/counters"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationCountersInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/counters")
    ];
};
const getGetApplicationCountersQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/counters")
    ];
};
const getGetApplicationCountersInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationCountersInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationCounters({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationCountersInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationCountersInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationCountersQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationCountersQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationCounters({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationCounters(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationCountersQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationCountersSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationCountersQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationCounters({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationCountersSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationCountersSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationVersionDeployTargetList = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/version-deploy-targets"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationVersionDeployTargetListInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/version-deploy-targets")
    ];
};
const getGetApplicationVersionDeployTargetListQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/version-deploy-targets")
    ];
};
const getGetApplicationVersionDeployTargetListInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionDeployTargetListInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionDeployTargetList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationVersionDeployTargetListInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionDeployTargetListInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionDeployTargetListQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionDeployTargetListQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionDeployTargetList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationVersionDeployTargetList(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionDeployTargetListQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionDeployTargetListSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionDeployTargetListQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionDeployTargetList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationVersionDeployTargetListSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionDeployTargetListSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getDeployApplicationVersionList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions-deployed"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetDeployApplicationVersionListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/versions-deployed"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetDeployApplicationVersionListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/versions-deployed"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetDeployApplicationVersionListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployApplicationVersionListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployApplicationVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetDeployApplicationVersionListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployApplicationVersionListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployApplicationVersionListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployApplicationVersionListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployApplicationVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetDeployApplicationVersionList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployApplicationVersionListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployApplicationVersionListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployApplicationVersionListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployApplicationVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetDeployApplicationVersionListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployApplicationVersionListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const deployApplicationVersion = (param, deployVersionBody, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/version-deploy"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deployVersionBody,
        params,
        signal
    }, options);
};
const getDeployApplicationVersionMutationOptions = (options)=>{
    const mutationKey = [
        'deployApplicationVersion'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data, params } = props !== null && props !== void 0 ? props : {};
        return deployApplicationVersion(pathParams, data, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeployApplicationVersion = (options, queryClient)=>useMutation(getDeployApplicationVersionMutationOptions(options), queryClient);
const getApplicationVersionQueryOpts = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/version-query-opts"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationVersionQueryOptsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/version-query-opts")
    ];
};
const getGetApplicationVersionQueryOptsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/version-query-opts")
    ];
};
const getGetApplicationVersionQueryOptsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionQueryOptsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionQueryOpts({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationVersionQueryOptsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionQueryOptsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionQueryOptsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionQueryOptsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionQueryOpts({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationVersionQueryOpts(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionQueryOptsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationVersionQueryOptsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationVersionQueryOptsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationVersionQueryOpts({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationVersionQueryOptsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationVersionQueryOptsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const setApplicationVersionDeprecated = (param, setVersionDeprecatedBody, options, signal)=>{
    let { organization, project, application, version } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions/").concat(encodeURIComponent(String(version)), "/deprecated"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: setVersionDeprecatedBody,
        signal
    }, options);
};
const getSetApplicationVersionDeprecatedMutationOptions = (options)=>{
    const mutationKey = [
        'setApplicationVersionDeprecated'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return setApplicationVersionDeprecated(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetApplicationVersionDeprecated = (options, queryClient)=>useMutation(getSetApplicationVersionDeprecatedMutationOptions(options), queryClient);
const setApplicationVersionUnavailable = (param, setVersionUnavailableBody, options, signal)=>{
    let { organization, project, application, version } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions/").concat(encodeURIComponent(String(version)), "/unavailable"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: setVersionUnavailableBody,
        signal
    }, options);
};
const getSetApplicationVersionUnavailableMutationOptions = (options)=>{
    const mutationKey = [
        'setApplicationVersionUnavailable'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return setApplicationVersionUnavailable(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetApplicationVersionUnavailable = (options, queryClient)=>useMutation(getSetApplicationVersionUnavailableMutationOptions(options), queryClient);
const setApplicationVersionFailed = (param, setVersionFailedBody, options, signal)=>{
    let { organization, project, application, version } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions/").concat(encodeURIComponent(String(version)), "/failed"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: setVersionFailedBody,
        signal
    }, options);
};
const getSetApplicationVersionFailedMutationOptions = (options)=>{
    const mutationKey = [
        'setApplicationVersionFailed'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return setApplicationVersionFailed(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetApplicationVersionFailed = (options, queryClient)=>useMutation(getSetApplicationVersionFailedMutationOptions(options), queryClient);
const setApplicationVersionAvailable = (param, options, signal)=>{
    let { organization, project, application, version } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions/").concat(encodeURIComponent(String(version)), "/available"),
        method: 'POST',
        signal
    }, options);
};
const getSetApplicationVersionAvailableMutationOptions = (options)=>{
    const mutationKey = [
        'setApplicationVersionAvailable'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setApplicationVersionAvailable(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetApplicationVersionAvailable = (options, queryClient)=>useMutation(getSetApplicationVersionAvailableMutationOptions(options), queryClient);
const getApplicationGraph = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application-version/graph/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application))),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationGraphInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application-version/graph/".concat(organization, "/").concat(project, "/").concat(application),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationGraphQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application-version/graph/".concat(organization, "/").concat(project, "/").concat(application),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationGraphInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationGraphInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationGraph({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationGraphInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationGraphInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationGraphQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationGraphQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationGraph({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationGraph(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationGraphQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationGraphSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationGraphQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationGraph({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationGraphSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationGraphSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getNodeDetails = (param, options, signal)=>{
    let { versionId } = param;
    return mutator({
        url: "/v2/application-version/node-details/".concat(encodeURIComponent(String(versionId))),
        method: 'GET',
        signal
    }, options);
};
const getGetNodeDetailsInfiniteQueryKey = (param)=>{
    let { versionId } = param;
    return [
        'infinite',
        "/v2/application-version/node-details/".concat(versionId)
    ];
};
const getGetNodeDetailsQueryKey = (param)=>{
    let { versionId } = param;
    return [
        "/v2/application-version/node-details/".concat(versionId)
    ];
};
const getGetNodeDetailsInfiniteQueryOptions = (param, options)=>{
    let { versionId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetNodeDetailsInfiniteQueryKey({
        versionId
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getNodeDetails({
            versionId
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!versionId
    }, queryOptions);
};
function useGetNodeDetailsInfinite(param, options, queryClient) {
    let { versionId } = param;
    const queryOptions = getGetNodeDetailsInfiniteQueryOptions({
        versionId
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetNodeDetailsQueryOptions = (param, options)=>{
    let { versionId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetNodeDetailsQueryKey({
        versionId
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getNodeDetails({
            versionId
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!versionId
    }, queryOptions);
};
function useGetNodeDetails(param, options, queryClient) {
    let { versionId } = param;
    const queryOptions = getGetNodeDetailsQueryOptions({
        versionId
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetNodeDetailsSuspenseQueryOptions = (param, options)=>{
    let { versionId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetNodeDetailsQueryKey({
        versionId
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getNodeDetails({
            versionId
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetNodeDetailsSuspense(param, options, queryClient) {
    let { versionId } = param;
    const queryOptions = getGetNodeDetailsSuspenseQueryOptions({
        versionId
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const setApplicationVersionProblematic = (param, setVersionProblematicBody, options, signal)=>{
    let { organization, project, application, versionId } = param;
    return mutator({
        url: "/v2/application-version/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(versionId)), "/problematic"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: setVersionProblematicBody,
        signal
    }, options);
};
const getSetApplicationVersionProblematicMutationOptions = (options)=>{
    const mutationKey = [
        'setApplicationVersionProblematic'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return setApplicationVersionProblematic(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetApplicationVersionProblematic = (options, queryClient)=>useMutation(getSetApplicationVersionProblematicMutationOptions(options), queryClient);
const removeApplicationVersionProblematic = (param, removeVersionProblematicBody, options, signal)=>{
    let { organization, project, application, versionId } = param;
    return mutator({
        url: "/v2/application-version/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(versionId)), "/problematic"),
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: removeVersionProblematicBody,
        signal
    }, options);
};
const getRemoveApplicationVersionProblematicMutationOptions = (options)=>{
    const mutationKey = [
        'removeApplicationVersionProblematic'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return removeApplicationVersionProblematic(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveApplicationVersionProblematic = (options, queryClient)=>useMutation(getRemoveApplicationVersionProblematicMutationOptions(options), queryClient);
const createApplicationTag = (param, createApplicationTagBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createApplicationTagBody,
        signal
    }, options);
};
const getCreateApplicationTagMutationOptions = (options)=>{
    const mutationKey = [
        'createApplicationTag'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return createApplicationTag(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateApplicationTag = (options, queryClient)=>useMutation(getCreateApplicationTagMutationOptions(options), queryClient);
const getTagList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetTagListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTagListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTagListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTagListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal, pageParam } = param;
        return getTagList({
            organization,
            project,
            application
        }, _object_spread_props(_object_spread({}, params), {
            page: pageParam || (params === null || params === void 0 ? void 0 : params['page'])
        }), requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetTagListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetTagListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTagListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTagListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTagList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetTagList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetTagListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTagListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTagListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTagList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetTagListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetTagListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationTag = (param, options, signal)=>{
    let { organization, project, application, tag } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags/").concat(encodeURIComponent(String(tag))),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationTagInfiniteQueryKey = (param)=>{
    let { organization, project, application, tag } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags/").concat(tag)
    ];
};
const getGetApplicationTagQueryKey = (param)=>{
    let { organization, project, application, tag } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags/").concat(tag)
    ];
};
const getGetApplicationTagInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, tag } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagInfiniteQueryKey({
        organization,
        project,
        application,
        tag
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTag({
            organization,
            project,
            application,
            tag
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && tag)
    }, queryOptions);
};
function useGetApplicationTagInfinite(param, options, queryClient) {
    let { organization, project, application, tag } = param;
    const queryOptions = getGetApplicationTagInfiniteQueryOptions({
        organization,
        project,
        application,
        tag
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagQueryOptions = (param, options)=>{
    let { organization, project, application, tag } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagQueryKey({
        organization,
        project,
        application,
        tag
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTag({
            organization,
            project,
            application,
            tag
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && tag)
    }, queryOptions);
};
function useGetApplicationTag(param, options, queryClient) {
    let { organization, project, application, tag } = param;
    const queryOptions = getGetApplicationTagQueryOptions({
        organization,
        project,
        application,
        tag
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, tag } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagQueryKey({
        organization,
        project,
        application,
        tag
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTag({
            organization,
            project,
            application,
            tag
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationTagSuspense(param, options, queryClient) {
    let { organization, project, application, tag } = param;
    const queryOptions = getGetApplicationTagSuspenseQueryOptions({
        organization,
        project,
        application,
        tag
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateApplicationTag = (param, updateApplicationTagBody, options, signal)=>{
    let { organization, project, application, tag } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags/").concat(encodeURIComponent(String(tag))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateApplicationTagBody,
        signal
    }, options);
};
const getUpdateApplicationTagMutationOptions = (options)=>{
    const mutationKey = [
        'updateApplicationTag'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateApplicationTag(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateApplicationTag = (options, queryClient)=>useMutation(getUpdateApplicationTagMutationOptions(options), queryClient);
const deleteApplicationTag = (param, options, signal)=>{
    let { organization, project, application, tag } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags/").concat(encodeURIComponent(String(tag))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteApplicationTagMutationOptions = (options)=>{
    const mutationKey = [
        'deleteApplicationTag'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteApplicationTag(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteApplicationTag = (options, queryClient)=>useMutation(getDeleteApplicationTagMutationOptions(options), queryClient);
const getApplicationTagConditionOptions = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags-condition-options"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationTagConditionOptionsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-options")
    ];
};
const getGetApplicationTagConditionOptionsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-options")
    ];
};
const getGetApplicationTagConditionOptionsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionOptionsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionOptions(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionOptionsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationTagConditionOptionsUsers = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags-condition-options/users"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationTagConditionOptionsUsersInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-options/users")
    ];
};
const getGetApplicationTagConditionOptionsUsersQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-options/users")
    ];
};
const getGetApplicationTagConditionOptionsUsersInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsUsersInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptionsUsers({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsUsersInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsUsersInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionOptionsUsersQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsUsersQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptionsUsers({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsUsers(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsUsersQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionOptionsUsersSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsUsersQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptionsUsers({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsUsersSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsUsersSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationTagConditionOptionsVersions = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags-condition-options/versions"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationTagConditionOptionsVersionsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-options/versions")
    ];
};
const getGetApplicationTagConditionOptionsVersionsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-options/versions")
    ];
};
const getGetApplicationTagConditionOptionsVersionsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsVersionsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptionsVersions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsVersionsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsVersionsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionOptionsVersionsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsVersionsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptionsVersions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsVersions(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsVersionsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionOptionsVersionsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionOptionsVersionsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionOptionsVersions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationTagConditionOptionsVersionsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionOptionsVersionsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationTagConditionVersion = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags-condition-version"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetApplicationTagConditionVersionInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-version"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationTagConditionVersionQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags-condition-version"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetApplicationTagConditionVersionInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionVersionInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionVersion({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionVersionInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionVersionInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionVersionQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionVersionQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionVersion({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationTagConditionVersion(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionVersionQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagConditionVersionSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagConditionVersionQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagConditionVersion({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationTagConditionVersionSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationTagConditionVersionSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const renameApplicationTag = (param, renameApplicationTagBody, options, signal)=>{
    let { organization, project, application, tag } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags/").concat(encodeURIComponent(String(tag)), "/rename"),
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: renameApplicationTagBody,
        signal
    }, options);
};
const getRenameApplicationTagMutationOptions = (options)=>{
    const mutationKey = [
        'renameApplicationTag'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return renameApplicationTag(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRenameApplicationTag = (options, queryClient)=>useMutation(getRenameApplicationTagMutationOptions(options), queryClient);
const getApplicationTagQueryOpts = (param, options, signal)=>{
    let { organization, project, application, tag } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tags/").concat(encodeURIComponent(String(tag)), "/query-opts"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationTagQueryOptsInfiniteQueryKey = (param)=>{
    let { organization, project, application, tag } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags/").concat(tag, "/query-opts")
    ];
};
const getGetApplicationTagQueryOptsQueryKey = (param)=>{
    let { organization, project, application, tag } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/tags/").concat(tag, "/query-opts")
    ];
};
const getGetApplicationTagQueryOptsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, tag } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagQueryOptsInfiniteQueryKey({
        organization,
        project,
        application,
        tag
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagQueryOpts({
            organization,
            project,
            application,
            tag
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && tag)
    }, queryOptions);
};
function useGetApplicationTagQueryOptsInfinite(param, options, queryClient) {
    let { organization, project, application, tag } = param;
    const queryOptions = getGetApplicationTagQueryOptsInfiniteQueryOptions({
        organization,
        project,
        application,
        tag
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagQueryOptsQueryOptions = (param, options)=>{
    let { organization, project, application, tag } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagQueryOptsQueryKey({
        organization,
        project,
        application,
        tag
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagQueryOpts({
            organization,
            project,
            application,
            tag
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && tag)
    }, queryOptions);
};
function useGetApplicationTagQueryOpts(param, options, queryClient) {
    let { organization, project, application, tag } = param;
    const queryOptions = getGetApplicationTagQueryOptsQueryOptions({
        organization,
        project,
        application,
        tag
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationTagQueryOptsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, tag } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationTagQueryOptsQueryKey({
        organization,
        project,
        application,
        tag
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationTagQueryOpts({
            organization,
            project,
            application,
            tag
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationTagQueryOptsSuspense(param, options, queryClient) {
    let { organization, project, application, tag } = param;
    const queryOptions = getGetApplicationTagQueryOptsSuspenseQueryOptions({
        organization,
        project,
        application,
        tag
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const createApplicationEnvironment = (param, createApplicationEnvironmentBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createApplicationEnvironmentBody,
        signal
    }, options);
};
const getCreateApplicationEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'createApplicationEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return createApplicationEnvironment(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateApplicationEnvironment = (options, queryClient)=>useMutation(getCreateApplicationEnvironmentMutationOptions(options), queryClient);
const getEnvironmentList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetEnvironmentListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetEnvironmentListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetEnvironmentList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEnvironmentConditionOptions = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/condition/options"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnvironmentConditionOptionsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/condition/options")
    ];
};
const getGetEnvironmentConditionOptionsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/condition/options")
    ];
};
const getGetEnvironmentConditionOptionsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentConditionOptionsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentConditionOptions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetEnvironmentConditionOptionsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentConditionOptionsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentConditionOptionsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentConditionOptionsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentConditionOptions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetEnvironmentConditionOptions(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentConditionOptionsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentConditionOptionsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentConditionOptionsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentConditionOptions({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentConditionOptionsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentConditionOptionsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEnvironmentConditionVersion = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/condition/version"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetEnvironmentConditionVersionInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/condition/version"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentConditionVersionQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/condition/version"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentConditionVersionInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentConditionVersionInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentConditionVersion({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetEnvironmentConditionVersionInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentConditionVersionInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentConditionVersionQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentConditionVersionQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentConditionVersion({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetEnvironmentConditionVersion(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentConditionVersionQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentConditionVersionSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentConditionVersionQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentConditionVersion({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentConditionVersionSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetEnvironmentConditionVersionSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationEnvironment = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment))),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationEnvironmentInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/").concat(environment)
    ];
};
const getGetApplicationEnvironmentQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/").concat(environment)
    ];
};
const getGetApplicationEnvironmentInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationEnvironmentInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationEnvironment({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetApplicationEnvironmentInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetApplicationEnvironmentInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationEnvironmentQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationEnvironmentQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationEnvironment({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetApplicationEnvironment(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetApplicationEnvironmentQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationEnvironmentSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationEnvironmentQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationEnvironment({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationEnvironmentSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetApplicationEnvironmentSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateApplicationEnvironment = (param, updateApplicationEnvironmentBody, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateApplicationEnvironmentBody,
        signal
    }, options);
};
const getUpdateApplicationEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'updateApplicationEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateApplicationEnvironment(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateApplicationEnvironment = (options, queryClient)=>useMutation(getUpdateApplicationEnvironmentMutationOptions(options), queryClient);
const deleteApplicationEnvironment = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteApplicationEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'deleteApplicationEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteApplicationEnvironment(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteApplicationEnvironment = (options, queryClient)=>useMutation(getDeleteApplicationEnvironmentMutationOptions(options), queryClient);
const renameApplicationEnvironment = (param, renameApplicationEnvironmentBody, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment)), "/rename"),
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: renameApplicationEnvironmentBody,
        signal
    }, options);
};
const getRenameApplicationEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'renameApplicationEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return renameApplicationEnvironment(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRenameApplicationEnvironment = (options, queryClient)=>useMutation(getRenameApplicationEnvironmentMutationOptions(options), queryClient);
const addEnvironmentCustomDomain = (param, modifyCustomDomainBody, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment)), "/custom-domain"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: modifyCustomDomainBody,
        signal
    }, options);
};
const getAddEnvironmentCustomDomainMutationOptions = (options)=>{
    const mutationKey = [
        'addEnvironmentCustomDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return addEnvironmentCustomDomain(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAddEnvironmentCustomDomain = (options, queryClient)=>useMutation(getAddEnvironmentCustomDomainMutationOptions(options), queryClient);
const removeEnvironmentCustomDomain = (param, options, signal)=>{
    let { organization, project, application, environment, customDomain } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment)), "/custom-domain/").concat(encodeURIComponent(String(customDomain))),
        method: 'DELETE',
        signal
    }, options);
};
const getRemoveEnvironmentCustomDomainMutationOptions = (options)=>{
    const mutationKey = [
        'removeEnvironmentCustomDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return removeEnvironmentCustomDomain(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveEnvironmentCustomDomain = (options, queryClient)=>useMutation(getRemoveEnvironmentCustomDomainMutationOptions(options), queryClient);
const updateEnvironmentEnvVarSet = (param, updateEnvVarSetBody, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment)), "/env-vars"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateEnvVarSetBody,
        signal
    }, options);
};
const getUpdateEnvironmentEnvVarSetMutationOptions = (options)=>{
    const mutationKey = [
        'updateEnvironmentEnvVarSet'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateEnvironmentEnvVarSet(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateEnvironmentEnvVarSet = (options, queryClient)=>useMutation(getUpdateEnvironmentEnvVarSetMutationOptions(options), queryClient);
const getEnvironmentEnvVarSet = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment)), "/env-vars"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnvironmentEnvVarSetInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/").concat(environment, "/env-vars")
    ];
};
const getGetEnvironmentEnvVarSetQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/").concat(environment, "/env-vars")
    ];
};
const getGetEnvironmentEnvVarSetInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentEnvVarSetInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentEnvVarSet({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentEnvVarSetInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentEnvVarSetInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentEnvVarSetQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentEnvVarSetQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentEnvVarSet({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentEnvVarSet(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentEnvVarSetQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentEnvVarSetSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentEnvVarSetQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentEnvVarSet({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentEnvVarSetSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentEnvVarSetSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const validateEnvVarPromotion = (param, params, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment/").concat(encodeURIComponent(String(environment)), "/validate-env-vars"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getValidateEnvVarPromotionInfiniteQueryKey = (param, params)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/").concat(environment, "/validate-env-vars"),
        ...params ? [
            params
        ] : []
    ];
};
const getValidateEnvVarPromotionQueryKey = (param, params)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environment/").concat(environment, "/validate-env-vars"),
        ...params ? [
            params
        ] : []
    ];
};
const getValidateEnvVarPromotionInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getValidateEnvVarPromotionInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return validateEnvVarPromotion({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useValidateEnvVarPromotionInfinite(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getValidateEnvVarPromotionInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getValidateEnvVarPromotionQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getValidateEnvVarPromotionQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return validateEnvVarPromotion({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useValidateEnvVarPromotion(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getValidateEnvVarPromotionQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getValidateEnvVarPromotionSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getValidateEnvVarPromotionQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return validateEnvVarPromotion({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useValidateEnvVarPromotionSuspense(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getValidateEnvVarPromotionSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEnvironmentDependencies = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environments/").concat(encodeURIComponent(String(environment)), "/dependencies"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnvironmentDependenciesInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environments/").concat(environment, "/dependencies")
    ];
};
const getGetEnvironmentDependenciesQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environments/").concat(environment, "/dependencies")
    ];
};
const getGetEnvironmentDependenciesInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDependenciesInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDependencies({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentDependenciesInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDependenciesInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentDependenciesQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDependenciesQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDependencies({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentDependencies(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDependenciesQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentDependenciesSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDependenciesQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDependencies({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentDependenciesSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDependenciesSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateEnvironmentDependencies = (param, zephyrDependencies, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environments/").concat(encodeURIComponent(String(environment)), "/dependencies"),
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: zephyrDependencies,
        signal
    }, options);
};
const getUpdateEnvironmentDependenciesMutationOptions = (options)=>{
    const mutationKey = [
        'updateEnvironmentDependencies'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateEnvironmentDependencies(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateEnvironmentDependencies = (options, queryClient)=>useMutation(getUpdateEnvironmentDependenciesMutationOptions(options), queryClient);
const addEnvironmentMembers = (param, addEnvironmentMembersBody, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environments/").concat(encodeURIComponent(String(environment)), "/members"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: addEnvironmentMembersBody,
        signal
    }, options);
};
const getAddEnvironmentMembersMutationOptions = (options)=>{
    const mutationKey = [
        'addEnvironmentMembers'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return addEnvironmentMembers(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAddEnvironmentMembers = (options, queryClient)=>useMutation(getAddEnvironmentMembersMutationOptions(options), queryClient);
const getEnvironmentMembers = (param, params, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environments/").concat(encodeURIComponent(String(environment)), "/members"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetEnvironmentMembersInfiniteQueryKey = (param, params)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environments/").concat(environment, "/members"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentMembersQueryKey = (param, params)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environments/").concat(environment, "/members"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentMembersInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentMembersInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentMembers({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentMembersInfinite(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentMembersInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentMembersQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentMembersQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentMembers({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentMembers(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentMembersQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentMembersSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentMembersQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentMembers({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentMembersSuspense(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentMembersSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAddEnvironmentMemberOptions = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environments/").concat(encodeURIComponent(String(environment)), "/members/add-options"),
        method: 'GET',
        signal
    }, options);
};
const getGetAddEnvironmentMemberOptionsInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environments/").concat(environment, "/members/add-options")
    ];
};
const getGetAddEnvironmentMemberOptionsQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/environments/").concat(environment, "/members/add-options")
    ];
};
const getGetAddEnvironmentMemberOptionsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAddEnvironmentMemberOptionsInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getAddEnvironmentMemberOptions({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetAddEnvironmentMemberOptionsInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetAddEnvironmentMemberOptionsInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAddEnvironmentMemberOptionsQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAddEnvironmentMemberOptionsQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getAddEnvironmentMemberOptions({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetAddEnvironmentMemberOptions(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetAddEnvironmentMemberOptionsQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAddEnvironmentMemberOptionsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAddEnvironmentMemberOptionsQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getAddEnvironmentMemberOptions({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAddEnvironmentMemberOptionsSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetAddEnvironmentMemberOptionsSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const removeEnvironmentMember = (param, options, signal)=>{
    let { organization, project, application, environment, memberId } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environments/").concat(encodeURIComponent(String(environment)), "/members/").concat(encodeURIComponent(String(memberId))),
        method: 'DELETE',
        signal
    }, options);
};
const getRemoveEnvironmentMemberMutationOptions = (options)=>{
    const mutationKey = [
        'removeEnvironmentMember'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return removeEnvironmentMember(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveEnvironmentMember = (options, queryClient)=>useMutation(getRemoveEnvironmentMemberMutationOptions(options), queryClient);
const listOrganizations = (params, options, signal)=>mutator({
        url: "/v2/organization",
        method: 'GET',
        params,
        signal
    }, options);
const getListOrganizationsInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/organization",
        ...params ? [
            params
        ] : []
    ];
const getListOrganizationsQueryKey = (params)=>[
        "/v2/organization",
        ...params ? [
            params
        ] : []
    ];
const getListOrganizationsInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationsInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizations(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListOrganizationsInfinite(params, options, queryClient) {
    const queryOptions = getListOrganizationsInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListOrganizationsQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizations(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListOrganizations(params, options, queryClient) {
    const queryOptions = getListOrganizationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListOrganizationsSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizations(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListOrganizationsSuspense(params, options, queryClient) {
    const queryOptions = getListOrganizationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_createOrganization = (createOrganization, options, signal)=>mutator({
        url: "/v2/organization",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createOrganization,
        signal
    }, options);
const getCreateOrganizationMutationOptions = (options)=>{
    const mutationKey = [
        'createOrganization'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return zephyr_createOrganization(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateOrganization = (options, queryClient)=>useMutation(getCreateOrganizationMutationOptions(options), queryClient);
const getOrganization = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization))),
        method: 'GET',
        signal
    }, options);
};
const getGetOrganizationInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization)
    ];
};
const getGetOrganizationQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization)
    ];
};
const getGetOrganizationInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganization({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganizationInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganization({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganization(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganization({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetOrganizationSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const deleteOrganization = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteOrganizationMutationOptions = (options)=>{
    const mutationKey = [
        'deleteOrganization'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteOrganization(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteOrganization = (options, queryClient)=>useMutation(getDeleteOrganizationMutationOptions(options), queryClient);
const updateOrganizationSettings = (param, organizationPublicSettings, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/settings"),
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: organizationPublicSettings,
        signal
    }, options);
};
const getUpdateOrganizationSettingsMutationOptions = (options)=>{
    const mutationKey = [
        'updateOrganizationSettings'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateOrganizationSettings(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateOrganizationSettings = (options, queryClient)=>useMutation(getUpdateOrganizationSettingsMutationOptions(options), queryClient);
const getOrganizationMembershipDomains = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/membership-domains"),
        method: 'GET',
        signal
    }, options);
};
const getGetOrganizationMembershipDomainsInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/membership-domains")
    ];
};
const getGetOrganizationMembershipDomainsQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/membership-domains")
    ];
};
const getGetOrganizationMembershipDomainsInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationMembershipDomainsInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationMembershipDomains({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganizationMembershipDomainsInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationMembershipDomainsInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationMembershipDomainsQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationMembershipDomainsQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationMembershipDomains({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganizationMembershipDomains(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationMembershipDomainsQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationMembershipDomainsSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationMembershipDomainsQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationMembershipDomains({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetOrganizationMembershipDomainsSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationMembershipDomainsSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_upsertOrganizationMembershipDomain = (param, upsertOrganizationMembershipDomain, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/membership-domains"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: upsertOrganizationMembershipDomain,
        signal
    }, options);
};
const getUpsertOrganizationMembershipDomainMutationOptions = (options)=>{
    const mutationKey = [
        'upsertOrganizationMembershipDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_upsertOrganizationMembershipDomain(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpsertOrganizationMembershipDomain = (options, queryClient)=>useMutation(getUpsertOrganizationMembershipDomainMutationOptions(options), queryClient);
const sendOrganizationMembershipDomainCode = (param, options, signal)=>{
    let { organization, domainId } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/membership-domains/").concat(encodeURIComponent(String(domainId)), "/send-code"),
        method: 'POST',
        signal
    }, options);
};
const getSendOrganizationMembershipDomainCodeMutationOptions = (options)=>{
    const mutationKey = [
        'sendOrganizationMembershipDomainCode'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return sendOrganizationMembershipDomainCode(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSendOrganizationMembershipDomainCode = (options, queryClient)=>useMutation(getSendOrganizationMembershipDomainCodeMutationOptions(options), queryClient);
const zephyr_verifyOrganizationMembershipDomain = (param, verifyOrganizationMembershipDomain, options, signal)=>{
    let { organization, domainId } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/membership-domains/").concat(encodeURIComponent(String(domainId)), "/verify"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: verifyOrganizationMembershipDomain,
        signal
    }, options);
};
const getVerifyOrganizationMembershipDomainMutationOptions = (options)=>{
    const mutationKey = [
        'verifyOrganizationMembershipDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_verifyOrganizationMembershipDomain(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useVerifyOrganizationMembershipDomain = (options, queryClient)=>useMutation(getVerifyOrganizationMembershipDomainMutationOptions(options), queryClient);
const deleteOrganizationMembershipDomain = (param, options, signal)=>{
    let { organization, domainId } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/membership-domains/").concat(encodeURIComponent(String(domainId))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteOrganizationMembershipDomainMutationOptions = (options)=>{
    const mutationKey = [
        'deleteOrganizationMembershipDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteOrganizationMembershipDomain(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteOrganizationMembershipDomain = (options, queryClient)=>useMutation(getDeleteOrganizationMembershipDomainMutationOptions(options), queryClient);
const listOrganizationMembers = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/members"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getListOrganizationMembersInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/members"),
        ...params ? [
            params
        ] : []
    ];
};
const getListOrganizationMembersQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/members"),
        ...params ? [
            params
        ] : []
    ];
};
const getListOrganizationMembersInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationMembersInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizationMembers({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useListOrganizationMembersInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getListOrganizationMembersInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListOrganizationMembersQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationMembersQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizationMembers({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useListOrganizationMembers(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getListOrganizationMembersQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListOrganizationMembersSuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationMembersQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizationMembers({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListOrganizationMembersSuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getListOrganizationMembersSuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_updateOrganization = (param, updateOrganization, options, signal)=>{
    let { id } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(id))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateOrganization,
        signal
    }, options);
};
const getUpdateOrganizationMutationOptions = (options)=>{
    const mutationKey = [
        'updateOrganization'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_updateOrganization(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateOrganization = (options, queryClient)=>useMutation(getUpdateOrganizationMutationOptions(options), queryClient);
const getUniqueOrganizationName = (param, options, signal)=>{
    let { displayName } = param;
    return mutator({
        url: "/v2/organization/unique-name/".concat(encodeURIComponent(String(displayName))),
        method: 'GET',
        signal
    }, options);
};
const getGetUniqueOrganizationNameInfiniteQueryKey = (param)=>{
    let { displayName } = param;
    return [
        'infinite',
        "/v2/organization/unique-name/".concat(displayName)
    ];
};
const getGetUniqueOrganizationNameQueryKey = (param)=>{
    let { displayName } = param;
    return [
        "/v2/organization/unique-name/".concat(displayName)
    ];
};
const getGetUniqueOrganizationNameInfiniteQueryOptions = (param, options)=>{
    let { displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueOrganizationNameInfiniteQueryKey({
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueOrganizationName({
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!displayName
    }, queryOptions);
};
function useGetUniqueOrganizationNameInfinite(param, options, queryClient) {
    let { displayName } = param;
    const queryOptions = getGetUniqueOrganizationNameInfiniteQueryOptions({
        displayName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUniqueOrganizationNameQueryOptions = (param, options)=>{
    let { displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueOrganizationNameQueryKey({
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueOrganizationName({
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!displayName
    }, queryOptions);
};
function useGetUniqueOrganizationName(param, options, queryClient) {
    let { displayName } = param;
    const queryOptions = getGetUniqueOrganizationNameQueryOptions({
        displayName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUniqueOrganizationNameSuspenseQueryOptions = (param, options)=>{
    let { displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueOrganizationNameQueryKey({
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueOrganizationName({
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUniqueOrganizationNameSuspense(param, options, queryClient) {
    let { displayName } = param;
    const queryOptions = getGetUniqueOrganizationNameSuspenseQueryOptions({
        displayName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const isUniqueOrganizationName = (param, options, signal)=>{
    let { name } = param;
    return mutator({
        url: "/v2/organization/is-unique-name/".concat(encodeURIComponent(String(name))),
        method: 'GET',
        signal
    }, options);
};
const getIsUniqueOrganizationNameInfiniteQueryKey = (param)=>{
    let { name } = param;
    return [
        'infinite',
        "/v2/organization/is-unique-name/".concat(name)
    ];
};
const getIsUniqueOrganizationNameQueryKey = (param)=>{
    let { name } = param;
    return [
        "/v2/organization/is-unique-name/".concat(name)
    ];
};
const getIsUniqueOrganizationNameInfiniteQueryOptions = (param, options)=>{
    let { name } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUniqueOrganizationNameInfiniteQueryKey({
        name
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUniqueOrganizationName({
            name
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!name
    }, queryOptions);
};
function useIsUniqueOrganizationNameInfinite(param, options, queryClient) {
    let { name } = param;
    const queryOptions = getIsUniqueOrganizationNameInfiniteQueryOptions({
        name
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUniqueOrganizationNameQueryOptions = (param, options)=>{
    let { name } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUniqueOrganizationNameQueryKey({
        name
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUniqueOrganizationName({
            name
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!name
    }, queryOptions);
};
function useIsUniqueOrganizationName(param, options, queryClient) {
    let { name } = param;
    const queryOptions = getIsUniqueOrganizationNameQueryOptions({
        name
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUniqueOrganizationNameSuspenseQueryOptions = (param, options)=>{
    let { name } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUniqueOrganizationNameQueryKey({
        name
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUniqueOrganizationName({
            name
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useIsUniqueOrganizationNameSuspense(param, options, queryClient) {
    let { name } = param;
    const queryOptions = getIsUniqueOrganizationNameSuspenseQueryOptions({
        name
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const searchOrganizations = (params, options, signal)=>mutator({
        url: "/v2/organization/search",
        method: 'GET',
        params,
        signal
    }, options);
const getSearchOrganizationsInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/organization/search",
        ...params ? [
            params
        ] : []
    ];
const getSearchOrganizationsQueryKey = (params)=>[
        "/v2/organization/search",
        ...params ? [
            params
        ] : []
    ];
const getSearchOrganizationsInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getSearchOrganizationsInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return searchOrganizations(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useSearchOrganizationsInfinite(params, options, queryClient) {
    const queryOptions = getSearchOrganizationsInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSearchOrganizationsQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getSearchOrganizationsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return searchOrganizations(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useSearchOrganizations(params, options, queryClient) {
    const queryOptions = getSearchOrganizationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSearchOrganizationsSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getSearchOrganizationsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return searchOrganizations(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useSearchOrganizationsSuspense(params, options, queryClient) {
    const queryOptions = getSearchOrganizationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateOrganizationName = (param, changeOrganizationName, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/name"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: changeOrganizationName,
        signal
    }, options);
};
const getUpdateOrganizationNameMutationOptions = (options)=>{
    const mutationKey = [
        'updateOrganizationName'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateOrganizationName(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateOrganizationName = (options, queryClient)=>useMutation(getUpdateOrganizationNameMutationOptions(options), queryClient);
const getOrganizationCounters = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/counters"),
        method: 'GET',
        signal
    }, options);
};
const getGetOrganizationCountersInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/counters")
    ];
};
const getGetOrganizationCountersQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/counters")
    ];
};
const getGetOrganizationCountersInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationCountersInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationCounters({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganizationCountersInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationCountersInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationCountersQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationCountersQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationCounters({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganizationCounters(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationCountersQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationCountersSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationCountersQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationCounters({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetOrganizationCountersSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationCountersSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getOrganizationApplicationList = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/application-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetOrganizationApplicationListInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/application-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetOrganizationApplicationListQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/application-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetOrganizationApplicationListInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationApplicationListInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationApplicationList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganizationApplicationListInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationApplicationListInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationApplicationListQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationApplicationListQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationApplicationList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetOrganizationApplicationList(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationApplicationListQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrganizationApplicationListSuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrganizationApplicationListQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrganizationApplicationList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetOrganizationApplicationListSuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetOrganizationApplicationListSuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const projectList = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/project-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getProjectListInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/project-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getProjectListQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/project-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getProjectListInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getProjectListInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return projectList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useProjectListInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getProjectListInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectListQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getProjectListQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return projectList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useProjectList(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getProjectListQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectListSuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getProjectListQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return projectList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useProjectListSuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getProjectListSuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const sideBarProjectList = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/side-bar-project-list"),
        method: 'GET',
        signal
    }, options);
};
const getSideBarProjectListInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/side-bar-project-list")
    ];
};
const getSideBarProjectListQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/side-bar-project-list")
    ];
};
const getSideBarProjectListInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getSideBarProjectListInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return sideBarProjectList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useSideBarProjectListInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getSideBarProjectListInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSideBarProjectListQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getSideBarProjectListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return sideBarProjectList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useSideBarProjectList(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getSideBarProjectListQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSideBarProjectListSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getSideBarProjectListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return sideBarProjectList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useSideBarProjectListSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getSideBarProjectListSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectSidebarSearch = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/sidebar-search"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetProjectSidebarSearchInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/sidebar-search"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectSidebarSearchQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/project/".concat(organization, "/sidebar-search"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectSidebarSearchInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSidebarSearchInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSidebarSearch({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetProjectSidebarSearchInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetProjectSidebarSearchInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectSidebarSearchQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSidebarSearchQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSidebarSearch({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetProjectSidebarSearch(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetProjectSidebarSearchQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectSidebarSearchSuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSidebarSearchQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSidebarSearch({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectSidebarSearchSuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetProjectSidebarSearchSuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const listOrganizationProjects = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization))),
        method: 'GET',
        signal
    }, options);
};
const getListOrganizationProjectsInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization)
    ];
};
const getListOrganizationProjectsQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/project/".concat(organization)
    ];
};
const getListOrganizationProjectsInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationProjectsInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizationProjects({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useListOrganizationProjectsInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getListOrganizationProjectsInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListOrganizationProjectsQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationProjectsQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizationProjects({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useListOrganizationProjects(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getListOrganizationProjectsQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListOrganizationProjectsSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListOrganizationProjectsQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listOrganizationProjects({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListOrganizationProjectsSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getListOrganizationProjectsSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const createProject = (param, createProjectBody, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createProjectBody,
        signal
    }, options);
};
const getCreateProjectMutationOptions = (options)=>{
    const mutationKey = [
        'createProject'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return createProject(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateProject = (options, queryClient)=>useMutation(getCreateProjectMutationOptions(options), queryClient);
const getProject = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project))),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetProjectInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProject({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProject({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProject(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProject({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const deleteProject = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteProjectMutationOptions = (options)=>{
    const mutationKey = [
        'deleteProject'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteProject(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteProject = (options, queryClient)=>useMutation(getDeleteProjectMutationOptions(options), queryClient);
const getProjectSettings = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/settings"),
        method: 'GET',
        signal
    }, options);
};
const getGetProjectSettingsInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/settings")
    ];
};
const getGetProjectSettingsQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/settings")
    ];
};
const getGetProjectSettingsInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSettingsInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSettings({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectSettingsInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectSettingsInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectSettingsQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSettingsQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSettings({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectSettings(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectSettingsQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectSettingsSuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSettingsQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSettings({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectSettingsSuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectSettingsSuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateProjectSettings = (param, updateProjectSettingsBody, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/settings"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateProjectSettingsBody,
        signal
    }, options);
};
const getUpdateProjectSettingsMutationOptions = (options)=>{
    const mutationKey = [
        'updateProjectSettings'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateProjectSettings(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateProjectSettings = (options, queryClient)=>useMutation(getUpdateProjectSettingsMutationOptions(options), queryClient);
const listProjectContributors = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/contributors"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getListProjectContributorsInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/contributors"),
        ...params ? [
            params
        ] : []
    ];
};
const getListProjectContributorsQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/contributors"),
        ...params ? [
            params
        ] : []
    ];
};
const getListProjectContributorsInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListProjectContributorsInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listProjectContributors({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useListProjectContributorsInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getListProjectContributorsInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListProjectContributorsQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListProjectContributorsQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listProjectContributors({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useListProjectContributors(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getListProjectContributorsQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListProjectContributorsSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListProjectContributorsQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listProjectContributors({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListProjectContributorsSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getListProjectContributorsSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const listProjectContributorsList = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/contributor/list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getListProjectContributorsListInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/contributor/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getListProjectContributorsListQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/contributor/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getListProjectContributorsListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListProjectContributorsListInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listProjectContributorsList({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useListProjectContributorsListInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getListProjectContributorsListInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListProjectContributorsListQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListProjectContributorsListQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listProjectContributorsList({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useListProjectContributorsList(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getListProjectContributorsListQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListProjectContributorsListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListProjectContributorsListQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listProjectContributorsList({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListProjectContributorsListSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getListProjectContributorsListSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUniqueProjectName = (param, options, signal)=>{
    let { organization, displayName } = param;
    return mutator({
        url: "/v2/project/unique-name/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(displayName))),
        method: 'GET',
        signal
    }, options);
};
const getGetUniqueProjectNameInfiniteQueryKey = (param)=>{
    let { organization, displayName } = param;
    return [
        'infinite',
        "/v2/project/unique-name/".concat(organization, "/").concat(displayName)
    ];
};
const getGetUniqueProjectNameQueryKey = (param)=>{
    let { organization, displayName } = param;
    return [
        "/v2/project/unique-name/".concat(organization, "/").concat(displayName)
    ];
};
const getGetUniqueProjectNameInfiniteQueryOptions = (param, options)=>{
    let { organization, displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueProjectNameInfiniteQueryKey({
        organization,
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueProjectName({
            organization,
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && displayName)
    }, queryOptions);
};
function useGetUniqueProjectNameInfinite(param, options, queryClient) {
    let { organization, displayName } = param;
    const queryOptions = getGetUniqueProjectNameInfiniteQueryOptions({
        organization,
        displayName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUniqueProjectNameQueryOptions = (param, options)=>{
    let { organization, displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueProjectNameQueryKey({
        organization,
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueProjectName({
            organization,
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && displayName)
    }, queryOptions);
};
function useGetUniqueProjectName(param, options, queryClient) {
    let { organization, displayName } = param;
    const queryOptions = getGetUniqueProjectNameQueryOptions({
        organization,
        displayName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUniqueProjectNameSuspenseQueryOptions = (param, options)=>{
    let { organization, displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueProjectNameQueryKey({
        organization,
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueProjectName({
            organization,
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUniqueProjectNameSuspense(param, options, queryClient) {
    let { organization, displayName } = param;
    const queryOptions = getGetUniqueProjectNameSuspenseQueryOptions({
        organization,
        displayName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectSummary = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/summary"),
        method: 'GET',
        signal
    }, options);
};
const getGetProjectSummaryInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/summary")
    ];
};
const getGetProjectSummaryQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/summary")
    ];
};
const getGetProjectSummaryInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSummaryInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSummary({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectSummaryInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectSummaryInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectSummaryQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSummaryQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSummary({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectSummary(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectSummaryQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectSummarySuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectSummaryQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectSummary({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectSummarySuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectSummarySuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectApplicationList = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/application-list"),
        method: 'GET',
        signal
    }, options);
};
const getGetProjectApplicationListInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/application-list")
    ];
};
const getGetProjectApplicationListQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/application-list")
    ];
};
const getGetProjectApplicationListInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationListInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectApplicationListInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationListInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectApplicationListQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectApplicationList(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationListQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectApplicationListSuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectApplicationListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectApplicationList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectApplicationListSuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectApplicationListSuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateProjectName = (param, updateProjectNameBody, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/update-name"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateProjectNameBody,
        signal
    }, options);
};
const getUpdateProjectNameMutationOptions = (options)=>{
    const mutationKey = [
        'updateProjectName'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateProjectName(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateProjectName = (options, queryClient)=>useMutation(getUpdateProjectNameMutationOptions(options), queryClient);
const zephyr_updateProjectById = (param, updateProjectById, options, signal)=>{
    let { projectId } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(projectId))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateProjectById,
        signal
    }, options);
};
const getUpdateProjectByIdMutationOptions = (options)=>{
    const mutationKey = [
        'updateProjectById'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_updateProjectById(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateProjectById = (options, queryClient)=>useMutation(getUpdateProjectByIdMutationOptions(options), queryClient);
const deleteProjectById = (param, options, signal)=>{
    let { projectId } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(projectId))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteProjectByIdMutationOptions = (options)=>{
    const mutationKey = [
        'deleteProjectById'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteProjectById(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteProjectById = (options, queryClient)=>useMutation(getDeleteProjectByIdMutationOptions(options), queryClient);
const restoreProject = (param, options, signal)=>{
    let { projectId } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(projectId)), "/restore"),
        method: 'POST',
        signal
    }, options);
};
const getRestoreProjectMutationOptions = (options)=>{
    const mutationKey = [
        'restoreProject'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return restoreProject(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRestoreProject = (options, queryClient)=>useMutation(getRestoreProjectMutationOptions(options), queryClient);
const addProjectContributors = (param, newProjectContributor, options, signal)=>{
    let { projectId } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(projectId)), "/contributor/add"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: newProjectContributor,
        signal
    }, options);
};
const getAddProjectContributorsMutationOptions = (options)=>{
    const mutationKey = [
        'addProjectContributors'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return addProjectContributors(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAddProjectContributors = (options, queryClient)=>useMutation(getAddProjectContributorsMutationOptions(options), queryClient);
const updateProjectContributorRole = (param, updateProjectContributor, options, signal)=>{
    let { projectId, contributorId } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(projectId)), "/").concat(encodeURIComponent(String(contributorId)), "/update/role"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateProjectContributor,
        signal
    }, options);
};
const getUpdateProjectContributorRoleMutationOptions = (options)=>{
    const mutationKey = [
        'updateProjectContributorRole'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateProjectContributorRole(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateProjectContributorRole = (options, queryClient)=>useMutation(getUpdateProjectContributorRoleMutationOptions(options), queryClient);
const removeProjectTeam = (param, options, signal)=>{
    let { projectId, contributorId } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(projectId)), "/team/").concat(encodeURIComponent(String(contributorId)), "/remove"),
        method: 'DELETE',
        signal
    }, options);
};
const getRemoveProjectTeamMutationOptions = (options)=>{
    const mutationKey = [
        'removeProjectTeam'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return removeProjectTeam(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveProjectTeam = (options, queryClient)=>useMutation(getRemoveProjectTeamMutationOptions(options), queryClient);
const removeProjectMember = (param, options, signal)=>{
    let { projectId, contributorId } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(projectId)), "/member/").concat(encodeURIComponent(String(contributorId)), "/remove"),
        method: 'DELETE',
        signal
    }, options);
};
const getRemoveProjectMemberMutationOptions = (options)=>{
    const mutationKey = [
        'removeProjectMember'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return removeProjectMember(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveProjectMember = (options, queryClient)=>useMutation(getRemoveProjectMemberMutationOptions(options), queryClient);
const getProjectAuditLog = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/audit-log"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetProjectAuditLogInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/audit-log"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectAuditLogQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/audit-log"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjectAuditLogInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectAuditLogInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectAuditLog({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectAuditLogInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectAuditLogInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectAuditLogQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectAuditLogQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectAuditLog({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectAuditLog(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectAuditLogQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectAuditLogSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectAuditLogQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectAuditLog({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectAuditLogSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectAuditLogSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectAuditLogAuthors = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/audit-log/authors"),
        method: 'GET',
        signal
    }, options);
};
const getGetProjectAuditLogAuthorsInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/audit-log/authors")
    ];
};
const getGetProjectAuditLogAuthorsQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/audit-log/authors")
    ];
};
const getGetProjectAuditLogAuthorsInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectAuditLogAuthorsInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectAuditLogAuthors({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectAuditLogAuthorsInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectAuditLogAuthorsInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectAuditLogAuthorsQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectAuditLogAuthorsQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectAuditLogAuthors({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectAuditLogAuthors(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectAuditLogAuthorsQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectAuditLogAuthorsSuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectAuditLogAuthorsQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectAuditLogAuthors({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectAuditLogAuthorsSuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectAuditLogAuthorsSuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCurrentUserProfile = (options, signal)=>mutator({
        url: "/v2/user/profile",
        method: 'GET',
        signal
    }, options);
const getGetCurrentUserProfileInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/user/profile"
    ];
const getGetCurrentUserProfileQueryKey = ()=>[
        "/v2/user/profile"
    ];
const getGetCurrentUserProfileInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserProfileInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUserProfile(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserProfileInfinite(options, queryClient) {
    const queryOptions = getGetCurrentUserProfileInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCurrentUserProfileQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserProfileQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUserProfile(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserProfile(options, queryClient) {
    const queryOptions = getGetCurrentUserProfileQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCurrentUserProfileSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserProfileQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUserProfile(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserProfileSuspense(options, queryClient) {
    const queryOptions = getGetCurrentUserProfileSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateCurrentUserProfile = (updateProfileBody, options, signal)=>mutator({
        url: "/v2/user/profile",
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateProfileBody,
        signal
    }, options);
const getUpdateCurrentUserProfileMutationOptions = (options)=>{
    const mutationKey = [
        'updateCurrentUserProfile'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return updateCurrentUserProfile(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateCurrentUserProfile = (options, queryClient)=>useMutation(getUpdateCurrentUserProfileMutationOptions(options), queryClient);
const updateUser = (updateUserBody, options, signal)=>mutator({
        url: "/v2/user",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateUserBody,
        signal
    }, options);
const getUpdateUserMutationOptions = (options)=>{
    const mutationKey = [
        'updateUser'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return updateUser(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateUser = (options, queryClient)=>useMutation(getUpdateUserMutationOptions(options), queryClient);
const deactivateCurrentUser = (options, signal)=>mutator({
        url: "/v2/user",
        method: 'DELETE',
        signal
    }, options);
const getDeactivateCurrentUserMutationOptions = (options)=>{
    const mutationKey = [
        'deactivateCurrentUser'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = ()=>deactivateCurrentUser(requestOptions);
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeactivateCurrentUser = (options, queryClient)=>useMutation(getDeactivateCurrentUserMutationOptions(options), queryClient);
const getUserOrganizations = (options, signal)=>mutator({
        url: "/v2/user/organizations",
        method: 'GET',
        signal
    }, options);
const getGetUserOrganizationsInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/user/organizations"
    ];
const getGetUserOrganizationsQueryKey = ()=>[
        "/v2/user/organizations"
    ];
const getGetUserOrganizationsInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserOrganizationsInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserOrganizations(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserOrganizationsInfinite(options, queryClient) {
    const queryOptions = getGetUserOrganizationsInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserOrganizationsQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserOrganizationsQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserOrganizations(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserOrganizations(options, queryClient) {
    const queryOptions = getGetUserOrganizationsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserOrganizationsSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserOrganizationsQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserOrganizations(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserOrganizationsSuspense(options, queryClient) {
    const queryOptions = getGetUserOrganizationsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUserPins = (params, options, signal)=>mutator({
        url: "/v2/user-pins",
        method: 'GET',
        params,
        signal
    }, options);
const getGetUserPinsInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/user-pins",
        ...params ? [
            params
        ] : []
    ];
const getGetUserPinsQueryKey = (params)=>[
        "/v2/user-pins",
        ...params ? [
            params
        ] : []
    ];
const getGetUserPinsInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserPinsInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserPins(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserPinsInfinite(params, options, queryClient) {
    const queryOptions = getGetUserPinsInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserPinsQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserPinsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserPins(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserPins(params, options, queryClient) {
    const queryOptions = getGetUserPinsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserPinsSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserPinsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserPins(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserPinsSuspense(params, options, queryClient) {
    const queryOptions = getGetUserPinsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateUserPins = (saveUserPinsBody, options, signal)=>mutator({
        url: "/v2/user-pins",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: saveUserPinsBody,
        signal
    }, options);
const getUpdateUserPinsMutationOptions = (options)=>{
    const mutationKey = [
        'updateUserPins'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return updateUserPins(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateUserPins = (options, queryClient)=>useMutation(getUpdateUserPinsMutationOptions(options), queryClient);
const getCurrentUser = (options, signal)=>mutator({
        url: "/v2/user/me",
        method: 'GET',
        signal
    }, options);
const getGetCurrentUserInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/user/me"
    ];
const getGetCurrentUserQueryKey = ()=>[
        "/v2/user/me"
    ];
const getGetCurrentUserInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUser(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserInfinite(options, queryClient) {
    const queryOptions = getGetCurrentUserInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCurrentUserQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUser(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUser(options, queryClient) {
    const queryOptions = getGetCurrentUserQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCurrentUserSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUser(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserSuspense(options, queryClient) {
    const queryOptions = getGetCurrentUserSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCurrentUserOrganizationList = (params, options, signal)=>mutator({
        url: "/v2/user/organization-list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetCurrentUserOrganizationListInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/user/organization-list",
        ...params ? [
            params
        ] : []
    ];
const getGetCurrentUserOrganizationListQueryKey = (params)=>[
        "/v2/user/organization-list",
        ...params ? [
            params
        ] : []
    ];
const getGetCurrentUserOrganizationListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserOrganizationListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUserOrganizationList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserOrganizationListInfinite(params, options, queryClient) {
    const queryOptions = getGetCurrentUserOrganizationListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCurrentUserOrganizationListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserOrganizationListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUserOrganizationList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserOrganizationList(params, options, queryClient) {
    const queryOptions = getGetCurrentUserOrganizationListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCurrentUserOrganizationListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCurrentUserOrganizationListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getCurrentUserOrganizationList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCurrentUserOrganizationListSuspense(params, options, queryClient) {
    const queryOptions = getGetCurrentUserOrganizationListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUserOrganizationListByEmail = (param, params, options, signal)=>{
    let { userEmail } = param;
    return mutator({
        url: "/v2/user/".concat(encodeURIComponent(String(userEmail)), "/organization-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetUserOrganizationListByEmailInfiniteQueryKey = (param, params)=>{
    let { userEmail } = param;
    return [
        'infinite',
        "/v2/user/".concat(userEmail, "/organization-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetUserOrganizationListByEmailQueryKey = (param, params)=>{
    let { userEmail } = param;
    return [
        "/v2/user/".concat(userEmail, "/organization-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetUserOrganizationListByEmailInfiniteQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserOrganizationListByEmailInfiniteQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserOrganizationListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!userEmail
    }, queryOptions);
};
function useGetUserOrganizationListByEmailInfinite(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserOrganizationListByEmailInfiniteQueryOptions({
        userEmail
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserOrganizationListByEmailQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserOrganizationListByEmailQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserOrganizationListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!userEmail
    }, queryOptions);
};
function useGetUserOrganizationListByEmail(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserOrganizationListByEmailQueryOptions({
        userEmail
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserOrganizationListByEmailSuspenseQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserOrganizationListByEmailQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserOrganizationListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserOrganizationListByEmailSuspense(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserOrganizationListByEmailSuspenseQueryOptions({
        userEmail
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUserProjectListByEmail = (param, params, options, signal)=>{
    let { userEmail } = param;
    return mutator({
        url: "/v2/user/".concat(encodeURIComponent(String(userEmail)), "/project-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetUserProjectListByEmailInfiniteQueryKey = (param, params)=>{
    let { userEmail } = param;
    return [
        'infinite',
        "/v2/user/".concat(userEmail, "/project-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetUserProjectListByEmailQueryKey = (param, params)=>{
    let { userEmail } = param;
    return [
        "/v2/user/".concat(userEmail, "/project-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetUserProjectListByEmailInfiniteQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserProjectListByEmailInfiniteQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserProjectListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!userEmail
    }, queryOptions);
};
function useGetUserProjectListByEmailInfinite(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserProjectListByEmailInfiniteQueryOptions({
        userEmail
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserProjectListByEmailQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserProjectListByEmailQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserProjectListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!userEmail
    }, queryOptions);
};
function useGetUserProjectListByEmail(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserProjectListByEmailQueryOptions({
        userEmail
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserProjectListByEmailSuspenseQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserProjectListByEmailQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserProjectListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserProjectListByEmailSuspense(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserProjectListByEmailSuspenseQueryOptions({
        userEmail
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUserApplicationListByEmail = (param, params, options, signal)=>{
    let { userEmail } = param;
    return mutator({
        url: "/v2/user/".concat(encodeURIComponent(String(userEmail)), "/application-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetUserApplicationListByEmailInfiniteQueryKey = (param, params)=>{
    let { userEmail } = param;
    return [
        'infinite',
        "/v2/user/".concat(userEmail, "/application-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetUserApplicationListByEmailQueryKey = (param, params)=>{
    let { userEmail } = param;
    return [
        "/v2/user/".concat(userEmail, "/application-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetUserApplicationListByEmailInfiniteQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserApplicationListByEmailInfiniteQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserApplicationListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!userEmail
    }, queryOptions);
};
function useGetUserApplicationListByEmailInfinite(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserApplicationListByEmailInfiniteQueryOptions({
        userEmail
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserApplicationListByEmailQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserApplicationListByEmailQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserApplicationListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!userEmail
    }, queryOptions);
};
function useGetUserApplicationListByEmail(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserApplicationListByEmailQueryOptions({
        userEmail
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserApplicationListByEmailSuspenseQueryOptions = (param, params, options)=>{
    let { userEmail } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserApplicationListByEmailQueryKey({
        userEmail
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserApplicationListByEmail({
            userEmail
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserApplicationListByEmailSuspense(param, params, options, queryClient) {
    let { userEmail } = param;
    const queryOptions = getGetUserApplicationListByEmailSuspenseQueryOptions({
        userEmail
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const isUniqueUsername = (param, options, signal)=>{
    let { username } = param;
    return mutator({
        url: "/v2/user/is-unique-username/".concat(encodeURIComponent(String(username))),
        method: 'GET',
        signal
    }, options);
};
const getIsUniqueUsernameInfiniteQueryKey = (param)=>{
    let { username } = param;
    return [
        'infinite',
        "/v2/user/is-unique-username/".concat(username)
    ];
};
const getIsUniqueUsernameQueryKey = (param)=>{
    let { username } = param;
    return [
        "/v2/user/is-unique-username/".concat(username)
    ];
};
const getIsUniqueUsernameInfiniteQueryOptions = (param, options)=>{
    let { username } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUniqueUsernameInfiniteQueryKey({
        username
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUniqueUsername({
            username
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!username
    }, queryOptions);
};
function useIsUniqueUsernameInfinite(param, options, queryClient) {
    let { username } = param;
    const queryOptions = getIsUniqueUsernameInfiniteQueryOptions({
        username
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUniqueUsernameQueryOptions = (param, options)=>{
    let { username } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUniqueUsernameQueryKey({
        username
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUniqueUsername({
            username
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!username
    }, queryOptions);
};
function useIsUniqueUsername(param, options, queryClient) {
    let { username } = param;
    const queryOptions = getIsUniqueUsernameQueryOptions({
        username
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUniqueUsernameSuspenseQueryOptions = (param, options)=>{
    let { username } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUniqueUsernameQueryKey({
        username
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUniqueUsername({
            username
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useIsUniqueUsernameSuspense(param, options, queryClient) {
    let { username } = param;
    const queryOptions = getIsUniqueUsernameSuspenseQueryOptions({
        username
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUserByUsername = (param, options, signal)=>{
    let { username } = param;
    return mutator({
        url: "/v2/user/".concat(encodeURIComponent(String(username))),
        method: 'GET',
        signal
    }, options);
};
const getGetUserByUsernameInfiniteQueryKey = (param)=>{
    let { username } = param;
    return [
        'infinite',
        "/v2/user/".concat(username)
    ];
};
const getGetUserByUsernameQueryKey = (param)=>{
    let { username } = param;
    return [
        "/v2/user/".concat(username)
    ];
};
const getGetUserByUsernameInfiniteQueryOptions = (param, options)=>{
    let { username } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserByUsernameInfiniteQueryKey({
        username
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserByUsername({
            username
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!username
    }, queryOptions);
};
function useGetUserByUsernameInfinite(param, options, queryClient) {
    let { username } = param;
    const queryOptions = getGetUserByUsernameInfiniteQueryOptions({
        username
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserByUsernameQueryOptions = (param, options)=>{
    let { username } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserByUsernameQueryKey({
        username
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserByUsername({
            username
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!username
    }, queryOptions);
};
function useGetUserByUsername(param, options, queryClient) {
    let { username } = param;
    const queryOptions = getGetUserByUsernameQueryOptions({
        username
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserByUsernameSuspenseQueryOptions = (param, options)=>{
    let { username } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserByUsernameQueryKey({
        username
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserByUsername({
            username
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserByUsernameSuspense(param, options, queryClient) {
    let { username } = param;
    const queryOptions = getGetUserByUsernameSuspenseQueryOptions({
        username
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const upsertUser = (options, signal)=>mutator({
        url: "/v2/user/upsert",
        method: 'POST',
        signal
    }, options);
const getUpsertUserMutationOptions = (options)=>{
    const mutationKey = [
        'upsertUser'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = ()=>upsertUser(requestOptions);
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpsertUser = (options, queryClient)=>useMutation(getUpsertUserMutationOptions(options), queryClient);
const getAccountsAssociated = (options, signal)=>mutator({
        url: "/v2/user/me/accounts-associated",
        method: 'GET',
        signal
    }, options);
const getGetAccountsAssociatedInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/user/me/accounts-associated"
    ];
const getGetAccountsAssociatedQueryKey = ()=>[
        "/v2/user/me/accounts-associated"
    ];
const getGetAccountsAssociatedInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAccountsAssociatedInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getAccountsAssociated(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAccountsAssociatedInfinite(options, queryClient) {
    const queryOptions = getGetAccountsAssociatedInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAccountsAssociatedQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAccountsAssociatedQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getAccountsAssociated(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAccountsAssociated(options, queryClient) {
    const queryOptions = getGetAccountsAssociatedQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAccountsAssociatedSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAccountsAssociatedQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getAccountsAssociated(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAccountsAssociatedSuspense(options, queryClient) {
    const queryOptions = getGetAccountsAssociatedSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const setPrimaryAccount = (param, options, signal)=>{
    let { provider, id } = param;
    return mutator({
        url: "/v2/user/me/set-primary-account/".concat(encodeURIComponent(String(provider)), "/").concat(encodeURIComponent(String(id))),
        method: 'POST',
        signal
    }, options);
};
const getSetPrimaryAccountMutationOptions = (options)=>{
    const mutationKey = [
        'setPrimaryAccount'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setPrimaryAccount(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetPrimaryAccount = (options, queryClient)=>useMutation(getSetPrimaryAccountMutationOptions(options), queryClient);
const getUserPinOptions = (params, options, signal)=>mutator({
        url: "/v2/user-pins/options",
        method: 'GET',
        params,
        signal
    }, options);
const getGetUserPinOptionsInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/user-pins/options",
        ...params ? [
            params
        ] : []
    ];
const getGetUserPinOptionsQueryKey = (params)=>[
        "/v2/user-pins/options",
        ...params ? [
            params
        ] : []
    ];
const getGetUserPinOptionsInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserPinOptionsInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserPinOptions(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserPinOptionsInfinite(params, options, queryClient) {
    const queryOptions = getGetUserPinOptionsInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserPinOptionsQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserPinOptionsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserPinOptions(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserPinOptions(params, options, queryClient) {
    const queryOptions = getGetUserPinOptionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserPinOptionsSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserPinOptionsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserPinOptions(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserPinOptionsSuspense(params, options, queryClient) {
    const queryOptions = getGetUserPinOptionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getBuildVersionList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/builds/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetBuildVersionListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetBuildVersionListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetBuildVersionListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetBuildVersionListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getBuildVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetBuildVersionListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetBuildVersionListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetBuildVersionListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetBuildVersionListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getBuildVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetBuildVersionList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetBuildVersionListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetBuildVersionListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetBuildVersionListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getBuildVersionList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetBuildVersionListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetBuildVersionListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getBuildVersionDetail = (param, options, signal)=>{
    let { organization, project, application, version } = param;
    return mutator({
        url: "/v2/builds/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions/").concat(encodeURIComponent(String(version))),
        method: 'GET',
        signal
    }, options);
};
const getGetBuildVersionDetailInfiniteQueryKey = (param)=>{
    let { organization, project, application, version } = param;
    return [
        'infinite',
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/versions/").concat(version)
    ];
};
const getGetBuildVersionDetailQueryKey = (param)=>{
    let { organization, project, application, version } = param;
    return [
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/versions/").concat(version)
    ];
};
const getGetBuildVersionDetailInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, version } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetBuildVersionDetailInfiniteQueryKey({
        organization,
        project,
        application,
        version
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getBuildVersionDetail({
            organization,
            project,
            application,
            version
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && version)
    }, queryOptions);
};
function useGetBuildVersionDetailInfinite(param, options, queryClient) {
    let { organization, project, application, version } = param;
    const queryOptions = getGetBuildVersionDetailInfiniteQueryOptions({
        organization,
        project,
        application,
        version
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetBuildVersionDetailQueryOptions = (param, options)=>{
    let { organization, project, application, version } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetBuildVersionDetailQueryKey({
        organization,
        project,
        application,
        version
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getBuildVersionDetail({
            organization,
            project,
            application,
            version
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && version)
    }, queryOptions);
};
function useGetBuildVersionDetail(param, options, queryClient) {
    let { organization, project, application, version } = param;
    const queryOptions = getGetBuildVersionDetailQueryOptions({
        organization,
        project,
        application,
        version
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetBuildVersionDetailSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, version } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetBuildVersionDetailQueryKey({
        organization,
        project,
        application,
        version
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getBuildVersionDetail({
            organization,
            project,
            application,
            version
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetBuildVersionDetailSuspense(param, options, queryClient) {
    let { organization, project, application, version } = param;
    const queryOptions = getGetBuildVersionDetailSuspenseQueryOptions({
        organization,
        project,
        application,
        version
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getDeployTargets = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/builds/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/deploy-targets"),
        method: 'GET',
        signal
    }, options);
};
const getGetDeployTargetsInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/deploy-targets")
    ];
};
const getGetDeployTargetsQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/deploy-targets")
    ];
};
const getGetDeployTargetsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployTargetsInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployTargets({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetDeployTargetsInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployTargetsInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployTargetsQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployTargetsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployTargets({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetDeployTargets(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployTargetsQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployTargetsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployTargetsQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployTargets({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetDeployTargetsSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployTargetsSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getDeployedVersions = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/builds/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/deployed-versions"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetDeployedVersionsInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/deployed-versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetDeployedVersionsQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/builds/".concat(organization, "/").concat(project, "/").concat(application, "/deployed-versions"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetDeployedVersionsInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployedVersionsInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployedVersions({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetDeployedVersionsInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployedVersionsInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployedVersionsQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployedVersionsQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployedVersions({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetDeployedVersions(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployedVersionsQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployedVersionsSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployedVersionsQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployedVersions({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetDeployedVersionsSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetDeployedVersionsSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const deployVersion = (param, deployVersionBody, params, options, signal)=>{
    let { organization, project, application, version } = param;
    return mutator({
        url: "/v2/builds/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/versions/").concat(encodeURIComponent(String(version)), "/deploy"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deployVersionBody,
        params,
        signal
    }, options);
};
const getDeployVersionMutationOptions = (options)=>{
    const mutationKey = [
        'deployVersion'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data, params } = props !== null && props !== void 0 ? props : {};
        return deployVersion(pathParams, data, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeployVersion = (options, queryClient)=>useMutation(getDeployVersionMutationOptions(options), queryClient);
const checkDevopsFeature = (options, signal)=>mutator({
        url: "/v2/pipeline/check-devops-feature",
        method: 'GET',
        signal
    }, options);
const getCheckDevopsFeatureInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/pipeline/check-devops-feature"
    ];
const getCheckDevopsFeatureQueryKey = ()=>[
        "/v2/pipeline/check-devops-feature"
    ];
const getCheckDevopsFeatureInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCheckDevopsFeatureInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return checkDevopsFeature(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCheckDevopsFeatureInfinite(options, queryClient) {
    const queryOptions = getCheckDevopsFeatureInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCheckDevopsFeatureQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCheckDevopsFeatureQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return checkDevopsFeature(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCheckDevopsFeature(options, queryClient) {
    const queryOptions = getCheckDevopsFeatureQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCheckDevopsFeatureSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCheckDevopsFeatureQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return checkDevopsFeature(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCheckDevopsFeatureSuspense(options, queryClient) {
    const queryOptions = getCheckDevopsFeatureSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getReleasePipelineByOrgList = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetReleasePipelineByOrgListInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineByOrgListQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/pipeline/".concat(organization, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineByOrgListInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByOrgListInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByOrgList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetReleasePipelineByOrgListInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetReleasePipelineByOrgListInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineByOrgListQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByOrgListQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByOrgList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetReleasePipelineByOrgList(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetReleasePipelineByOrgListQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineByOrgListSuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByOrgListQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByOrgList({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetReleasePipelineByOrgListSuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetReleasePipelineByOrgListSuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getReleasePipelineByProjectList = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetReleasePipelineByProjectListInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineByProjectListQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineByProjectListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByProjectListInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByProjectList({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetReleasePipelineByProjectListInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetReleasePipelineByProjectListInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineByProjectListQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByProjectListQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByProjectList({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetReleasePipelineByProjectList(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetReleasePipelineByProjectListQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineByProjectListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByProjectListQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByProjectList({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetReleasePipelineByProjectListSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetReleasePipelineByProjectListSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getReleasePipelineByApplicationList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetReleasePipelineByApplicationListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineByApplicationListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineByApplicationListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByApplicationListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByApplicationList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineByApplicationListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineByApplicationListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineByApplicationListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByApplicationListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByApplicationList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineByApplicationList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineByApplicationListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineByApplicationListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineByApplicationListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineByApplicationList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetReleasePipelineByApplicationListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineByApplicationListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getReleasePipelineTagList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/tag-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetReleasePipelineTagListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/tag-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineTagListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/tag-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineTagListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTagListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTagList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineTagListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTagListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineTagListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTagListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTagList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineTagList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTagListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineTagListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTagListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTagList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetReleasePipelineTagListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTagListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getReleasePipelineEnvironmentList = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/environment-list"),
        method: 'GET',
        signal
    }, options);
};
const getGetReleasePipelineEnvironmentListInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/environment-list")
    ];
};
const getGetReleasePipelineEnvironmentListQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/environment-list")
    ];
};
const getGetReleasePipelineEnvironmentListInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineEnvironmentListInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineEnvironmentList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineEnvironmentListInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineEnvironmentListInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineEnvironmentListQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineEnvironmentListQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineEnvironmentList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineEnvironmentList(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineEnvironmentListQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineEnvironmentListSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineEnvironmentListQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineEnvironmentList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetReleasePipelineEnvironmentListSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineEnvironmentListSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getReleasePipelineTargetList = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/target-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetReleasePipelineTargetListInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/target-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineTargetListQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/target-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineTargetListInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTargetListInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTargetList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineTargetListInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTargetListInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineTargetListQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTargetListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTargetList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineTargetList(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTargetListQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineTargetListSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTargetListQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTargetList({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetReleasePipelineTargetListSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTargetListSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getReleasePipelineTargetAuthors = (param, params, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/target-authors"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetReleasePipelineTargetAuthorsInfiniteQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/target-authors"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineTargetAuthorsQueryKey = (param, params)=>{
    let { organization, project, application } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/target-authors"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetReleasePipelineTargetAuthorsInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTargetAuthorsInfiniteQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTargetAuthors({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineTargetAuthorsInfinite(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTargetAuthorsInfiniteQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineTargetAuthorsQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTargetAuthorsQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTargetAuthors({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetReleasePipelineTargetAuthors(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTargetAuthorsQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetReleasePipelineTargetAuthorsSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetReleasePipelineTargetAuthorsQueryKey({
        organization,
        project,
        application
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getReleasePipelineTargetAuthors({
            organization,
            project,
            application
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetReleasePipelineTargetAuthorsSuspense(param, params, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetReleasePipelineTargetAuthorsSuspenseQueryOptions({
        organization,
        project,
        application
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const createReleaseCandidate = (param, createReleaseCandidateBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/create-release-candidate"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createReleaseCandidateBody,
        signal
    }, options);
};
const getCreateReleaseCandidateMutationOptions = (options)=>{
    const mutationKey = [
        'createReleaseCandidate'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return createReleaseCandidate(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateReleaseCandidate = (options, queryClient)=>useMutation(getCreateReleaseCandidateMutationOptions(options), queryClient);
const promoteReleaseCandidate = (param, promoteReleaseCandidateBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/promote-release-candidate"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: promoteReleaseCandidateBody,
        signal
    }, options);
};
const getPromoteReleaseCandidateMutationOptions = (options)=>{
    const mutationKey = [
        'promoteReleaseCandidate'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return promoteReleaseCandidate(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const usePromoteReleaseCandidate = (options, queryClient)=>useMutation(getPromoteReleaseCandidateMutationOptions(options), queryClient);
const deployTagToEnvironment = (param, deployTagToEnvironmentBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/deploy-tag-to-environment"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deployTagToEnvironmentBody,
        signal
    }, options);
};
const getDeployTagToEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'deployTagToEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return deployTagToEnvironment(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeployTagToEnvironment = (options, queryClient)=>useMutation(getDeployTagToEnvironmentMutationOptions(options), queryClient);
const deleteReleaseCandidate = (param, options, signal)=>{
    let { organization, project, application, id } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/release-candidate/").concat(encodeURIComponent(String(id)), "/delete"),
        method: 'POST',
        signal
    }, options);
};
const getDeleteReleaseCandidateMutationOptions = (options)=>{
    const mutationKey = [
        'deleteReleaseCandidate'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteReleaseCandidate(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteReleaseCandidate = (options, queryClient)=>useMutation(getDeleteReleaseCandidateMutationOptions(options), queryClient);
const setEnvironmentOrder = (param, setEnvironmentOrderItem, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/set-environment-order"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: setEnvironmentOrderItem,
        signal
    }, options);
};
const getSetEnvironmentOrderMutationOptions = (options)=>{
    const mutationKey = [
        'setEnvironmentOrder'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return setEnvironmentOrder(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetEnvironmentOrder = (options, queryClient)=>useMutation(getSetEnvironmentOrderMutationOptions(options), queryClient);
const rollbackEnvironment = (param, rollbackEnvironmentBody, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/rollback-environment"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: rollbackEnvironmentBody,
        signal
    }, options);
};
const getRollbackEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'rollbackEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return rollbackEnvironment(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRollbackEnvironment = (options, queryClient)=>useMutation(getRollbackEnvironmentMutationOptions(options), queryClient);
const getTargetHistory = (param, params, options, signal)=>{
    let { organization, project, application, target } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(target)), "/history"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetTargetHistoryInfiniteQueryKey = (param, params)=>{
    let { organization, project, application, target } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(target, "/history"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTargetHistoryQueryKey = (param, params)=>{
    let { organization, project, application, target } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(target, "/history"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTargetHistoryInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application, target } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTargetHistoryInfiniteQueryKey({
        organization,
        project,
        application,
        target
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTargetHistory({
            organization,
            project,
            application,
            target
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && target)
    }, queryOptions);
};
function useGetTargetHistoryInfinite(param, params, options, queryClient) {
    let { organization, project, application, target } = param;
    const queryOptions = getGetTargetHistoryInfiniteQueryOptions({
        organization,
        project,
        application,
        target
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTargetHistoryQueryOptions = (param, params, options)=>{
    let { organization, project, application, target } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTargetHistoryQueryKey({
        organization,
        project,
        application,
        target
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTargetHistory({
            organization,
            project,
            application,
            target
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && target)
    }, queryOptions);
};
function useGetTargetHistory(param, params, options, queryClient) {
    let { organization, project, application, target } = param;
    const queryOptions = getGetTargetHistoryQueryOptions({
        organization,
        project,
        application,
        target
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTargetHistorySuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application, target } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTargetHistoryQueryKey({
        organization,
        project,
        application,
        target
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTargetHistory({
            organization,
            project,
            application,
            target
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetTargetHistorySuspense(param, params, options, queryClient) {
    let { organization, project, application, target } = param;
    const queryOptions = getGetTargetHistorySuspenseQueryOptions({
        organization,
        project,
        application,
        target
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEnvironmentDeploymentLog = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/pipeline/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/environment-deployment-log"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnvironmentDeploymentLogInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/environment-deployment-log")
    ];
};
const getGetEnvironmentDeploymentLogQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/pipeline/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/environment-deployment-log")
    ];
};
const getGetEnvironmentDeploymentLogInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDeploymentLogInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDeploymentLog({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentDeploymentLogInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDeploymentLogInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentDeploymentLogQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDeploymentLogQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDeploymentLog({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentDeploymentLog(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDeploymentLogQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentDeploymentLogSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDeploymentLogQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDeploymentLog({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentDeploymentLogSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDeploymentLogSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUniqueTeamName = (param, options, signal)=>{
    let { organizationName, displayName } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organizationName)), "/unique-project-name/").concat(encodeURIComponent(String(displayName))),
        method: 'GET',
        signal
    }, options);
};
const getGetUniqueTeamNameInfiniteQueryKey = (param)=>{
    let { organizationName, displayName } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organizationName, "/unique-project-name/").concat(displayName)
    ];
};
const getGetUniqueTeamNameQueryKey = (param)=>{
    let { organizationName, displayName } = param;
    return [
        "/v2/organization/".concat(organizationName, "/unique-project-name/").concat(displayName)
    ];
};
const getGetUniqueTeamNameInfiniteQueryOptions = (param, options)=>{
    let { organizationName, displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueTeamNameInfiniteQueryKey({
        organizationName,
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueTeamName({
            organizationName,
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && displayName)
    }, queryOptions);
};
function useGetUniqueTeamNameInfinite(param, options, queryClient) {
    let { organizationName, displayName } = param;
    const queryOptions = getGetUniqueTeamNameInfiniteQueryOptions({
        organizationName,
        displayName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUniqueTeamNameQueryOptions = (param, options)=>{
    let { organizationName, displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueTeamNameQueryKey({
        organizationName,
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueTeamName({
            organizationName,
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && displayName)
    }, queryOptions);
};
function useGetUniqueTeamName(param, options, queryClient) {
    let { organizationName, displayName } = param;
    const queryOptions = getGetUniqueTeamNameQueryOptions({
        organizationName,
        displayName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUniqueTeamNameSuspenseQueryOptions = (param, options)=>{
    let { organizationName, displayName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUniqueTeamNameQueryKey({
        organizationName,
        displayName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUniqueTeamName({
            organizationName,
            displayName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUniqueTeamNameSuspense(param, options, queryClient) {
    let { organizationName, displayName } = param;
    const queryOptions = getGetUniqueTeamNameSuspenseQueryOptions({
        organizationName,
        displayName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_createTeam = (param, createTeam, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organizationName)), "/team"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createTeam,
        signal
    }, options);
};
const getCreateTeamMutationOptions = (options)=>{
    const mutationKey = [
        'createTeam'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_createTeam(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateTeam = (options, queryClient)=>useMutation(getCreateTeamMutationOptions(options), queryClient);
const getTeamList = (param, params, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organizationName)), "/team-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetTeamListInfiniteQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organizationName, "/team-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTeamListQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        "/v2/organization/".concat(organizationName, "/team-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTeamListInfiniteQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamListInfiniteQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamList({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetTeamListInfinite(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetTeamListInfiniteQueryOptions({
        organizationName
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamListQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamListQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamList({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetTeamList(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetTeamListQueryOptions({
        organizationName
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamListSuspenseQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamListQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamList({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetTeamListSuspense(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetTeamListSuspenseQueryOptions({
        organizationName
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getTeam = (param, options, signal)=>{
    let { teamId } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(teamId))),
        method: 'GET',
        signal
    }, options);
};
const getGetTeamInfiniteQueryKey = (param)=>{
    let { teamId } = param;
    return [
        'infinite',
        "/v2/team/".concat(teamId)
    ];
};
const getGetTeamQueryKey = (param)=>{
    let { teamId } = param;
    return [
        "/v2/team/".concat(teamId)
    ];
};
const getGetTeamInfiniteQueryOptions = (param, options)=>{
    let { teamId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamInfiniteQueryKey({
        teamId
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeam({
            teamId
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!teamId
    }, queryOptions);
};
function useGetTeamInfinite(param, options, queryClient) {
    let { teamId } = param;
    const queryOptions = getGetTeamInfiniteQueryOptions({
        teamId
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamQueryOptions = (param, options)=>{
    let { teamId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamQueryKey({
        teamId
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeam({
            teamId
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!teamId
    }, queryOptions);
};
function useGetTeam(param, options, queryClient) {
    let { teamId } = param;
    const queryOptions = getGetTeamQueryOptions({
        teamId
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamSuspenseQueryOptions = (param, options)=>{
    let { teamId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamQueryKey({
        teamId
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeam({
            teamId
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetTeamSuspense(param, options, queryClient) {
    let { teamId } = param;
    const queryOptions = getGetTeamSuspenseQueryOptions({
        teamId
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_updateTeam = (param, updateTeam, options, signal)=>{
    let { teamId } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(teamId))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateTeam,
        signal
    }, options);
};
const getUpdateTeamMutationOptions = (options)=>{
    const mutationKey = [
        'updateTeam'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_updateTeam(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateTeam = (options, queryClient)=>useMutation(getUpdateTeamMutationOptions(options), queryClient);
const deleteTeam = (param, options, signal)=>{
    let { teamId } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(teamId))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteTeamMutationOptions = (options)=>{
    const mutationKey = [
        'deleteTeam'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteTeam(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteTeam = (options, queryClient)=>useMutation(getDeleteTeamMutationOptions(options), queryClient);
const getTeamMembers = (param, params, options, signal)=>{
    let { teamId } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(teamId)), "/members"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetTeamMembersInfiniteQueryKey = (param, params)=>{
    let { teamId } = param;
    return [
        'infinite',
        "/v2/team/".concat(teamId, "/members"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTeamMembersQueryKey = (param, params)=>{
    let { teamId } = param;
    return [
        "/v2/team/".concat(teamId, "/members"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetTeamMembersInfiniteQueryOptions = (param, params, options)=>{
    let { teamId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamMembersInfiniteQueryKey({
        teamId
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamMembers({
            teamId
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!teamId
    }, queryOptions);
};
function useGetTeamMembersInfinite(param, params, options, queryClient) {
    let { teamId } = param;
    const queryOptions = getGetTeamMembersInfiniteQueryOptions({
        teamId
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamMembersQueryOptions = (param, params, options)=>{
    let { teamId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamMembersQueryKey({
        teamId
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamMembers({
            teamId
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!teamId
    }, queryOptions);
};
function useGetTeamMembers(param, params, options, queryClient) {
    let { teamId } = param;
    const queryOptions = getGetTeamMembersQueryOptions({
        teamId
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamMembersSuspenseQueryOptions = (param, params, options)=>{
    let { teamId } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamMembersQueryKey({
        teamId
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamMembers({
            teamId
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetTeamMembersSuspense(param, params, options, queryClient) {
    let { teamId } = param;
    const queryOptions = getGetTeamMembersSuspenseQueryOptions({
        teamId
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getTeamByName = (param, options, signal)=>{
    let { organizationName, teamName } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(organizationName)), "/team/").concat(encodeURIComponent(String(teamName))),
        method: 'GET',
        signal
    }, options);
};
const getGetTeamByNameInfiniteQueryKey = (param)=>{
    let { organizationName, teamName } = param;
    return [
        'infinite',
        "/v2/team/".concat(organizationName, "/team/").concat(teamName)
    ];
};
const getGetTeamByNameQueryKey = (param)=>{
    let { organizationName, teamName } = param;
    return [
        "/v2/team/".concat(organizationName, "/team/").concat(teamName)
    ];
};
const getGetTeamByNameInfiniteQueryOptions = (param, options)=>{
    let { organizationName, teamName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamByNameInfiniteQueryKey({
        organizationName,
        teamName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamByName({
            organizationName,
            teamName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && teamName)
    }, queryOptions);
};
function useGetTeamByNameInfinite(param, options, queryClient) {
    let { organizationName, teamName } = param;
    const queryOptions = getGetTeamByNameInfiniteQueryOptions({
        organizationName,
        teamName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamByNameQueryOptions = (param, options)=>{
    let { organizationName, teamName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamByNameQueryKey({
        organizationName,
        teamName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamByName({
            organizationName,
            teamName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && teamName)
    }, queryOptions);
};
function useGetTeamByName(param, options, queryClient) {
    let { organizationName, teamName } = param;
    const queryOptions = getGetTeamByNameQueryOptions({
        organizationName,
        teamName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetTeamByNameSuspenseQueryOptions = (param, options)=>{
    let { organizationName, teamName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetTeamByNameQueryKey({
        organizationName,
        teamName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getTeamByName({
            organizationName,
            teamName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetTeamByNameSuspense(param, options, queryClient) {
    let { organizationName, teamName } = param;
    const queryOptions = getGetTeamByNameSuspenseQueryOptions({
        organizationName,
        teamName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_addTeamMembers = (param, addTeamMembers, options, signal)=>{
    let { teamId } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(teamId)), "/member"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: addTeamMembers,
        signal
    }, options);
};
const getAddTeamMembersMutationOptions = (options)=>{
    const mutationKey = [
        'addTeamMembers'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_addTeamMembers(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAddTeamMembers = (options, queryClient)=>useMutation(getAddTeamMembersMutationOptions(options), queryClient);
const updateTeamMemberRole = (param, updateMemberRole, options, signal)=>{
    let { teamId, memberId } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(teamId)), "/member/").concat(encodeURIComponent(String(memberId))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateMemberRole,
        signal
    }, options);
};
const getUpdateTeamMemberRoleMutationOptions = (options)=>{
    const mutationKey = [
        'updateTeamMemberRole'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateTeamMemberRole(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateTeamMemberRole = (options, queryClient)=>useMutation(getUpdateTeamMemberRoleMutationOptions(options), queryClient);
const removeTeamMember = (param, options, signal)=>{
    let { teamId, memberId } = param;
    return mutator({
        url: "/v2/team/".concat(encodeURIComponent(String(teamId)), "/member/").concat(encodeURIComponent(String(memberId))),
        method: 'DELETE',
        signal
    }, options);
};
const getRemoveTeamMemberMutationOptions = (options)=>{
    const mutationKey = [
        'removeTeamMember'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return removeTeamMember(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveTeamMember = (options, queryClient)=>useMutation(getRemoveTeamMemberMutationOptions(options), queryClient);
const getSubscription = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/".concat(encodeURIComponent(String(organizationName))),
        method: 'GET',
        signal
    }, options);
};
const getGetSubscriptionInfiniteQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/".concat(organizationName)
    ];
};
const getGetSubscriptionQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/".concat(organizationName)
    ];
};
const getGetSubscriptionInfiniteQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSubscriptionInfiniteQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getSubscription({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetSubscriptionInfinite(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetSubscriptionInfiniteQueryOptions({
        organizationName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSubscriptionQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSubscriptionQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getSubscription({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetSubscription(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetSubscriptionQueryOptions({
        organizationName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSubscriptionSuspenseQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSubscriptionQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getSubscription({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSubscriptionSuspense(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetSubscriptionSuspenseQueryOptions({
        organizationName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const changeSubscription = (param, changeSubscriptionRequest, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/".concat(encodeURIComponent(String(organizationName)), "/change"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: changeSubscriptionRequest,
        signal
    }, options);
};
const getChangeSubscriptionMutationOptions = (options)=>{
    const mutationKey = [
        "changeSubscription"
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return changeSubscription(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useChangeSubscription = (options, queryClient)=>useMutation(getChangeSubscriptionMutationOptions(options), queryClient);
const cancelSubscriptionSchedule = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/".concat(encodeURIComponent(String(organizationName)), "/schedule/downgrade"),
        method: 'DELETE',
        signal
    }, options);
};
const getCancelSubscriptionScheduleMutationOptions = (options)=>{
    const mutationKey = [
        "cancelSubscriptionSchedule"
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return cancelSubscriptionSchedule(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCancelSubscriptionSchedule = (options, queryClient)=>useMutation(getCancelSubscriptionScheduleMutationOptions(options), queryClient);
const advanceSubscriptionSchedule = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/".concat(encodeURIComponent(String(organizationName)), "/schedule/advance"),
        method: 'DELETE',
        signal
    }, options);
};
const getAdvanceSubscriptionScheduleMutationOptions = (options)=>{
    const mutationKey = [
        "advanceSubscriptionSchedule"
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return advanceSubscriptionSchedule(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAdvanceSubscriptionSchedule = (options, queryClient)=>useMutation(getAdvanceSubscriptionScheduleMutationOptions(options), queryClient);
const listQuotas = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/quotas/".concat(encodeURIComponent(String(organizationName))),
        method: 'GET',
        signal
    }, options);
};
const getListQuotasInfiniteQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/quotas/".concat(organizationName)
    ];
};
const getListQuotasQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/quotas/".concat(organizationName)
    ];
};
const getListQuotasInfiniteQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListQuotasInfiniteQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listQuotas({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListQuotasInfinite(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListQuotasInfiniteQueryOptions({
        organizationName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListQuotasQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListQuotasQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listQuotas({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListQuotas(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListQuotasQueryOptions({
        organizationName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListQuotasSuspenseQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListQuotasQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listQuotas({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListQuotasSuspense(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListQuotasSuspenseQueryOptions({
        organizationName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateRecurringQuota = (param, updateRecurringQuotaBody, options, signal)=>{
    let { organizationName, metric } = param;
    return mutator({
        url: "/v3/subscriptions/quotas/".concat(encodeURIComponent(String(organizationName)), "/").concat(encodeURIComponent(String(metric)), "/recurring"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateRecurringQuotaBody,
        signal
    }, options);
};
const getUpdateRecurringQuotaMutationOptions = (options)=>{
    const mutationKey = [
        'updateRecurringQuota'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateRecurringQuota(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateRecurringQuota = (options, queryClient)=>useMutation(getUpdateRecurringQuotaMutationOptions(options), queryClient);
const updateNonRecurringQuota = (param, updateNonRecurringQuotaBody, options, signal)=>{
    let { organizationName, metric } = param;
    return mutator({
        url: "/v3/subscriptions/quotas/".concat(encodeURIComponent(String(organizationName)), "/").concat(encodeURIComponent(String(metric)), "/non-recurring"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateNonRecurringQuotaBody,
        signal
    }, options);
};
const getUpdateNonRecurringQuotaMutationOptions = (options)=>{
    const mutationKey = [
        'updateNonRecurringQuota'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateNonRecurringQuota(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateNonRecurringQuota = (options, queryClient)=>useMutation(getUpdateNonRecurringQuotaMutationOptions(options), queryClient);
const listCurrentUsage = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/metrics/".concat(encodeURIComponent(String(organizationName)), "/current-usage"),
        method: 'GET',
        signal
    }, options);
};
const getListCurrentUsageInfiniteQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/metrics/".concat(organizationName, "/current-usage")
    ];
};
const getListCurrentUsageQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/metrics/".concat(organizationName, "/current-usage")
    ];
};
const getListCurrentUsageInfiniteQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListCurrentUsageInfiniteQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listCurrentUsage({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListCurrentUsageInfinite(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListCurrentUsageInfiniteQueryOptions({
        organizationName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListCurrentUsageQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListCurrentUsageQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listCurrentUsage({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListCurrentUsage(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListCurrentUsageQueryOptions({
        organizationName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListCurrentUsageSuspenseQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListCurrentUsageQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listCurrentUsage({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListCurrentUsageSuspense(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListCurrentUsageSuspenseQueryOptions({
        organizationName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const listCurrentMetricUsage = (param, options, signal)=>{
    let { organizationName, metric } = param;
    return mutator({
        url: "/v3/subscriptions/metrics/".concat(encodeURIComponent(String(organizationName)), "/current-usage/").concat(encodeURIComponent(String(metric))),
        method: 'GET',
        signal
    }, options);
};
const getListCurrentMetricUsageInfiniteQueryKey = (param)=>{
    let { organizationName, metric } = param;
    return [
        'infinite',
        "/v3/subscriptions/metrics/".concat(organizationName, "/current-usage/").concat(metric)
    ];
};
const getListCurrentMetricUsageQueryKey = (param)=>{
    let { organizationName, metric } = param;
    return [
        "/v3/subscriptions/metrics/".concat(organizationName, "/current-usage/").concat(metric)
    ];
};
const getListCurrentMetricUsageInfiniteQueryOptions = (param, options)=>{
    let { organizationName, metric } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListCurrentMetricUsageInfiniteQueryKey({
        organizationName,
        metric
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listCurrentMetricUsage({
            organizationName,
            metric
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && metric)
    }, queryOptions);
};
function useListCurrentMetricUsageInfinite(param, options, queryClient) {
    let { organizationName, metric } = param;
    const queryOptions = getListCurrentMetricUsageInfiniteQueryOptions({
        organizationName,
        metric
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListCurrentMetricUsageQueryOptions = (param, options)=>{
    let { organizationName, metric } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListCurrentMetricUsageQueryKey({
        organizationName,
        metric
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listCurrentMetricUsage({
            organizationName,
            metric
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && metric)
    }, queryOptions);
};
function useListCurrentMetricUsage(param, options, queryClient) {
    let { organizationName, metric } = param;
    const queryOptions = getListCurrentMetricUsageQueryOptions({
        organizationName,
        metric
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListCurrentMetricUsageSuspenseQueryOptions = (param, options)=>{
    let { organizationName, metric } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListCurrentMetricUsageQueryKey({
        organizationName,
        metric
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listCurrentMetricUsage({
            organizationName,
            metric
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListCurrentMetricUsageSuspense(param, options, queryClient) {
    let { organizationName, metric } = param;
    const queryOptions = getListCurrentMetricUsageSuspenseQueryOptions({
        organizationName,
        metric
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const graphCurrentUsage = (param, graphMetricBodyDto, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/metrics/".concat(encodeURIComponent(String(organizationName)), "/current-usage-graph"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: graphMetricBodyDto,
        signal
    }, options);
};
const getGraphCurrentUsageMutationOptions = (options)=>{
    const mutationKey = [
        'graphCurrentUsage'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return graphCurrentUsage(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useGraphCurrentUsage = (options, queryClient)=>useMutation(getGraphCurrentUsageMutationOptions(options), queryClient);
const listChildOrganizations = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/multiorgs/".concat(encodeURIComponent(String(organizationName)), "/children"),
        method: 'GET',
        signal
    }, options);
};
const getListChildOrganizationsInfiniteQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/multiorgs/".concat(organizationName, "/children")
    ];
};
const getListChildOrganizationsQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/multiorgs/".concat(organizationName, "/children")
    ];
};
const getListChildOrganizationsInfiniteQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListChildOrganizationsInfiniteQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listChildOrganizations({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListChildOrganizationsInfinite(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListChildOrganizationsInfiniteQueryOptions({
        organizationName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListChildOrganizationsQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListChildOrganizationsQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listChildOrganizations({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListChildOrganizations(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListChildOrganizationsQueryOptions({
        organizationName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListChildOrganizationsSuspenseQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListChildOrganizationsQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return listChildOrganizations({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListChildOrganizationsSuspense(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListChildOrganizationsSuspenseQueryOptions({
        organizationName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const inviteChildOrganization = (param, inviteChildOrganizationDto, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/multiorgs/".concat(encodeURIComponent(String(organizationName)), "/children/invite"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: inviteChildOrganizationDto,
        signal
    }, options);
};
const getInviteChildOrganizationMutationOptions = (options)=>{
    const mutationKey = [
        'inviteChildOrganization'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return inviteChildOrganization(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useInviteChildOrganization = (options, queryClient)=>useMutation(getInviteChildOrganizationMutationOptions(options), queryClient);
const checkCanJoinAsChild = (param, inviteChildOrganizationDto, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/multiorgs/".concat(encodeURIComponent(String(organizationName)), "/children/check"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: inviteChildOrganizationDto,
        signal
    }, options);
};
const getCheckCanJoinAsChildMutationOptions = (options)=>{
    const mutationKey = [
        'checkCanJoinAsChild'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return checkCanJoinAsChild(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCheckCanJoinAsChild = (options, queryClient)=>useMutation(getCheckCanJoinAsChildMutationOptions(options), queryClient);
const deleteInviteChildOrganization = (param, options, signal)=>{
    let { organizationName, childOrgId } = param;
    return mutator({
        url: "/v3/subscriptions/multiorgs/".concat(encodeURIComponent(String(organizationName)), "/children/invite/").concat(encodeURIComponent(String(childOrgId))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteInviteChildOrganizationMutationOptions = (options)=>{
    const mutationKey = [
        'deleteInviteChildOrganization'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteInviteChildOrganization(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteInviteChildOrganization = (options, queryClient)=>useMutation(getDeleteInviteChildOrganizationMutationOptions(options), queryClient);
const getInviteInformation = (param, options, signal)=>{
    let { organizationName, inviteOrgName } = param;
    return mutator({
        url: "/v3/subscriptions/multiorgs/".concat(encodeURIComponent(String(organizationName)), "/invite/").concat(encodeURIComponent(String(inviteOrgName))),
        method: 'GET',
        signal
    }, options);
};
const getGetInviteInformationInfiniteQueryKey = (param)=>{
    let { organizationName, inviteOrgName } = param;
    return [
        'infinite',
        "/v3/subscriptions/multiorgs/".concat(organizationName, "/invite/").concat(inviteOrgName)
    ];
};
const getGetInviteInformationQueryKey = (param)=>{
    let { organizationName, inviteOrgName } = param;
    return [
        "/v3/subscriptions/multiorgs/".concat(organizationName, "/invite/").concat(inviteOrgName)
    ];
};
const getGetInviteInformationInfiniteQueryOptions = (param, options)=>{
    let { organizationName, inviteOrgName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetInviteInformationInfiniteQueryKey({
        organizationName,
        inviteOrgName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getInviteInformation({
            organizationName,
            inviteOrgName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && inviteOrgName)
    }, queryOptions);
};
function useGetInviteInformationInfinite(param, options, queryClient) {
    let { organizationName, inviteOrgName } = param;
    const queryOptions = getGetInviteInformationInfiniteQueryOptions({
        organizationName,
        inviteOrgName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetInviteInformationQueryOptions = (param, options)=>{
    let { organizationName, inviteOrgName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetInviteInformationQueryKey({
        organizationName,
        inviteOrgName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getInviteInformation({
            organizationName,
            inviteOrgName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && inviteOrgName)
    }, queryOptions);
};
function useGetInviteInformation(param, options, queryClient) {
    let { organizationName, inviteOrgName } = param;
    const queryOptions = getGetInviteInformationQueryOptions({
        organizationName,
        inviteOrgName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetInviteInformationSuspenseQueryOptions = (param, options)=>{
    let { organizationName, inviteOrgName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetInviteInformationQueryKey({
        organizationName,
        inviteOrgName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getInviteInformation({
            organizationName,
            inviteOrgName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetInviteInformationSuspense(param, options, queryClient) {
    let { organizationName, inviteOrgName } = param;
    const queryOptions = getGetInviteInformationSuspenseQueryOptions({
        organizationName,
        inviteOrgName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const rejectChildOrganizationInvite = (param, options, signal)=>{
    let { organizationName, inviteOrgName } = param;
    return mutator({
        url: "/v3/subscriptions/multiorgs/".concat(encodeURIComponent(String(organizationName)), "/invite/").concat(encodeURIComponent(String(inviteOrgName))),
        method: 'DELETE',
        signal
    }, options);
};
const getRejectChildOrganizationInviteMutationOptions = (options)=>{
    const mutationKey = [
        'rejectChildOrganizationInvite'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return rejectChildOrganizationInvite(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRejectChildOrganizationInvite = (options, queryClient)=>useMutation(getRejectChildOrganizationInviteMutationOptions(options), queryClient);
const acceptChildOrganizationInvite = (param, options, signal)=>{
    let { organizationName, inviteOrgName } = param;
    return mutator({
        url: "/v3/subscriptions/multiorgs/".concat(encodeURIComponent(String(organizationName)), "/invite/").concat(encodeURIComponent(String(inviteOrgName)), "/accept"),
        method: 'POST',
        signal
    }, options);
};
const getAcceptChildOrganizationInviteMutationOptions = (options)=>{
    const mutationKey = [
        'acceptChildOrganizationInvite'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return acceptChildOrganizationInvite(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAcceptChildOrganizationInvite = (options, queryClient)=>useMutation(getAcceptChildOrganizationInviteMutationOptions(options), queryClient);
const listInvoices = (param, params, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/invoices/".concat(encodeURIComponent(String(organizationName)), "/invoices"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getListInvoicesInfiniteQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/invoices/".concat(organizationName, "/invoices"),
        ...params ? [
            params
        ] : []
    ];
};
const getListInvoicesQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/invoices/".concat(organizationName, "/invoices"),
        ...params ? [
            params
        ] : []
    ];
};
const getListInvoicesInfiniteQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListInvoicesInfiniteQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listInvoices({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListInvoicesInfinite(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListInvoicesInfiniteQueryOptions({
        organizationName
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListInvoicesQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListInvoicesQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listInvoices({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListInvoices(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListInvoicesQueryOptions({
        organizationName
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListInvoicesSuspenseQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListInvoicesQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listInvoices({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListInvoicesSuspense(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListInvoicesSuspenseQueryOptions({
        organizationName
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUpcomingInvoice = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/invoices/".concat(encodeURIComponent(String(organizationName)), "/invoices/upcoming"),
        method: 'GET',
        signal
    }, options);
};
const getGetUpcomingInvoiceInfiniteQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/invoices/".concat(organizationName, "/invoices/upcoming")
    ];
};
const getGetUpcomingInvoiceQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/invoices/".concat(organizationName, "/invoices/upcoming")
    ];
};
const getGetUpcomingInvoiceInfiniteQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUpcomingInvoiceInfiniteQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUpcomingInvoice({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetUpcomingInvoiceInfinite(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetUpcomingInvoiceInfiniteQueryOptions({
        organizationName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUpcomingInvoiceQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUpcomingInvoiceQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUpcomingInvoice({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetUpcomingInvoice(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetUpcomingInvoiceQueryOptions({
        organizationName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUpcomingInvoiceSuspenseQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUpcomingInvoiceQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUpcomingInvoice({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUpcomingInvoiceSuspense(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetUpcomingInvoiceSuspenseQueryOptions({
        organizationName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const listPaymentMethods = (param, params, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/payment-methods/".concat(encodeURIComponent(String(organizationName))),
        method: 'GET',
        params,
        signal
    }, options);
};
const getListPaymentMethodsInfiniteQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/payment-methods/".concat(organizationName),
        ...params ? [
            params
        ] : []
    ];
};
const getListPaymentMethodsQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/payment-methods/".concat(organizationName),
        ...params ? [
            params
        ] : []
    ];
};
const getListPaymentMethodsInfiniteQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListPaymentMethodsInfiniteQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listPaymentMethods({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListPaymentMethodsInfinite(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListPaymentMethodsInfiniteQueryOptions({
        organizationName
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListPaymentMethodsQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListPaymentMethodsQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listPaymentMethods({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useListPaymentMethods(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListPaymentMethodsQueryOptions({
        organizationName
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListPaymentMethodsSuspenseQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListPaymentMethodsQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return listPaymentMethods({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListPaymentMethodsSuspense(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getListPaymentMethodsSuspenseQueryOptions({
        organizationName
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const attachPaymentMethod = (param, params, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/payment-methods/".concat(encodeURIComponent(String(organizationName)), "/attach"),
        method: 'POST',
        params,
        signal
    }, options);
};
const getAttachPaymentMethodMutationOptions = (options)=>{
    const mutationKey = [
        'attachPaymentMethod'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, params } = props !== null && props !== void 0 ? props : {};
        return attachPaymentMethod(pathParams, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAttachPaymentMethod = (options, queryClient)=>useMutation(getAttachPaymentMethodMutationOptions(options), queryClient);
const detachPaymentMethod = (param, params, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/payment-methods/".concat(encodeURIComponent(String(organizationName)), "/detach"),
        method: 'POST',
        params,
        signal
    }, options);
};
const getDetachPaymentMethodMutationOptions = (options)=>{
    const mutationKey = [
        'detachPaymentMethod'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, params } = props !== null && props !== void 0 ? props : {};
        return detachPaymentMethod(pathParams, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDetachPaymentMethod = (options, queryClient)=>useMutation(getDetachPaymentMethodMutationOptions(options), queryClient);
const setDefaultPaymentMethod = (param, params, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/payment-methods/".concat(encodeURIComponent(String(organizationName)), "/default"),
        method: 'PUT',
        params,
        signal
    }, options);
};
const getSetDefaultPaymentMethodMutationOptions = (options)=>{
    const mutationKey = [
        'setDefaultPaymentMethod'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, params } = props !== null && props !== void 0 ? props : {};
        return setDefaultPaymentMethod(pathParams, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetDefaultPaymentMethod = (options, queryClient)=>useMutation(getSetDefaultPaymentMethodMutationOptions(options), queryClient);
const getDefaultPaymentMethod = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/payment-methods/".concat(encodeURIComponent(String(organizationName)), "/default"),
        method: 'GET',
        signal
    }, options);
};
const getGetDefaultPaymentMethodInfiniteQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/payment-methods/".concat(organizationName, "/default")
    ];
};
const getGetDefaultPaymentMethodQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/payment-methods/".concat(organizationName, "/default")
    ];
};
const getGetDefaultPaymentMethodInfiniteQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDefaultPaymentMethodInfiniteQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDefaultPaymentMethod({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetDefaultPaymentMethodInfinite(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetDefaultPaymentMethodInfiniteQueryOptions({
        organizationName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDefaultPaymentMethodQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDefaultPaymentMethodQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDefaultPaymentMethod({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetDefaultPaymentMethod(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetDefaultPaymentMethodQueryOptions({
        organizationName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDefaultPaymentMethodSuspenseQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDefaultPaymentMethodQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDefaultPaymentMethod({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetDefaultPaymentMethodSuspense(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetDefaultPaymentMethodSuspenseQueryOptions({
        organizationName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const listAllStripePrices = (options, signal)=>mutator({
        url: "/v3/subscriptions/stripe/prices/all",
        method: 'GET',
        signal
    }, options);
const getListAllStripePricesInfiniteQueryKey = ()=>[
        'infinite',
        "/v3/subscriptions/stripe/prices/all"
    ];
const getListAllStripePricesQueryKey = ()=>[
        "/v3/subscriptions/stripe/prices/all"
    ];
const getListAllStripePricesInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListAllStripePricesInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return listAllStripePrices(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListAllStripePricesInfinite(options, queryClient) {
    const queryOptions = getListAllStripePricesInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListAllStripePricesQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListAllStripePricesQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return listAllStripePrices(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListAllStripePrices(options, queryClient) {
    const queryOptions = getListAllStripePricesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListAllStripePricesSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListAllStripePricesQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return listAllStripePrices(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListAllStripePricesSuspense(options, queryClient) {
    const queryOptions = getListAllStripePricesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getStripeSubscriptionItems = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/stripe/subscription/".concat(encodeURIComponent(String(organizationName)), "/items"),
        method: 'GET',
        signal
    }, options);
};
const getGetStripeSubscriptionItemsInfiniteQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v3/subscriptions/stripe/subscription/".concat(organizationName, "/items")
    ];
};
const getGetStripeSubscriptionItemsQueryKey = (param)=>{
    let { organizationName } = param;
    return [
        "/v3/subscriptions/stripe/subscription/".concat(organizationName, "/items")
    ];
};
const getGetStripeSubscriptionItemsInfiniteQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetStripeSubscriptionItemsInfiniteQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getStripeSubscriptionItems({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetStripeSubscriptionItemsInfinite(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetStripeSubscriptionItemsInfiniteQueryOptions({
        organizationName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetStripeSubscriptionItemsQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetStripeSubscriptionItemsQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getStripeSubscriptionItems({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetStripeSubscriptionItems(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetStripeSubscriptionItemsQueryOptions({
        organizationName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetStripeSubscriptionItemsSuspenseQueryOptions = (param, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetStripeSubscriptionItemsQueryKey({
        organizationName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getStripeSubscriptionItems({
            organizationName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetStripeSubscriptionItemsSuspense(param, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetStripeSubscriptionItemsSuspenseQueryOptions({
        organizationName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCoupon = (param, options, signal)=>{
    let { organizationName, coupon } = param;
    return mutator({
        url: "/v3/subscriptions/".concat(encodeURIComponent(String(organizationName)), "/coupons/").concat(encodeURIComponent(String(coupon))),
        method: 'GET',
        signal
    }, options);
};
const getGetCouponInfiniteQueryKey = (param)=>{
    let { organizationName, coupon } = param;
    return [
        'infinite',
        "/v3/subscriptions/".concat(organizationName, "/coupons/").concat(coupon)
    ];
};
const getGetCouponQueryKey = (param)=>{
    let { organizationName, coupon } = param;
    return [
        "/v3/subscriptions/".concat(organizationName, "/coupons/").concat(coupon)
    ];
};
const getGetCouponInfiniteQueryOptions = (param, options)=>{
    let { organizationName, coupon } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCouponInfiniteQueryKey({
        organizationName,
        coupon
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getCoupon({
            organizationName,
            coupon
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && coupon)
    }, queryOptions);
};
function useGetCouponInfinite(param, options, queryClient) {
    let { organizationName, coupon } = param;
    const queryOptions = getGetCouponInfiniteQueryOptions({
        organizationName,
        coupon
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCouponQueryOptions = (param, options)=>{
    let { organizationName, coupon } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCouponQueryKey({
        organizationName,
        coupon
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getCoupon({
            organizationName,
            coupon
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organizationName && coupon)
    }, queryOptions);
};
function useGetCoupon(param, options, queryClient) {
    let { organizationName, coupon } = param;
    const queryOptions = getGetCouponQueryOptions({
        organizationName,
        coupon
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetCouponSuspenseQueryOptions = (param, options)=>{
    let { organizationName, coupon } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetCouponQueryKey({
        organizationName,
        coupon
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getCoupon({
            organizationName,
            coupon
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetCouponSuspense(param, options, queryClient) {
    let { organizationName, coupon } = param;
    const queryOptions = getGetCouponSuspenseQueryOptions({
        organizationName,
        coupon
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const removeCoupon = (param, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v3/subscriptions/".concat(encodeURIComponent(String(organizationName)), "/coupons"),
        method: 'DELETE',
        signal
    }, options);
};
const getRemoveCouponMutationOptions = (options)=>{
    const mutationKey = [
        'removeCoupon'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return removeCoupon(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveCoupon = (options, queryClient)=>useMutation(getRemoveCouponMutationOptions(options), queryClient);
const getSidePanelApplicationList = (options, signal)=>mutator({
        url: "/v2/side-panel/application-list",
        method: 'GET',
        signal
    }, options);
const getGetSidePanelApplicationListInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/side-panel/application-list"
    ];
const getGetSidePanelApplicationListQueryKey = ()=>[
        "/v2/side-panel/application-list"
    ];
const getGetSidePanelApplicationListInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationListInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationListInfinite(options, queryClient) {
    const queryOptions = getGetSidePanelApplicationListInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationListQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationListQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationList(options, queryClient) {
    const queryOptions = getGetSidePanelApplicationListQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationListSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationListQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationListSuspense(options, queryClient) {
    const queryOptions = getGetSidePanelApplicationListSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSidePanelApplicationEnvironmentList = (params, options, signal)=>mutator({
        url: "/v2/side-panel/application-environment-list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSidePanelApplicationEnvironmentListInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/side-panel/application-environment-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationEnvironmentListQueryKey = (params)=>[
        "/v2/side-panel/application-environment-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationEnvironmentListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationEnvironmentListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationEnvironmentList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationEnvironmentListInfinite(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationEnvironmentListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationEnvironmentListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationEnvironmentListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationEnvironmentList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationEnvironmentList(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationEnvironmentListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationEnvironmentListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationEnvironmentListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationEnvironmentList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationEnvironmentListSuspense(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationEnvironmentListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSidePanelApplicationTagList = (params, options, signal)=>mutator({
        url: "/v2/side-panel/application-tag-list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSidePanelApplicationTagListInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/side-panel/application-tag-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationTagListQueryKey = (params)=>[
        "/v2/side-panel/application-tag-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationTagListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationTagListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationTagList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationTagListInfinite(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationTagListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationTagListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationTagListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationTagList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationTagList(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationTagListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationTagListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationTagListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationTagList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationTagListSuspense(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationTagListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSidePanelApplicationVersionList = (params, options, signal)=>mutator({
        url: "/v2/side-panel/application-version-list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSidePanelApplicationVersionListInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/side-panel/application-version-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationVersionListQueryKey = (params)=>[
        "/v2/side-panel/application-version-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationVersionListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationVersionListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationVersionList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationVersionListInfinite(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationVersionListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationVersionListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationVersionListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationVersionList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationVersionList(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationVersionListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationVersionListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationVersionListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationVersionList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationVersionListSuspense(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationVersionListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSidePanelApplicationRemoteVersions = (params, options, signal)=>mutator({
        url: "/v2/side-panel/application-remote-versions",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSidePanelApplicationRemoteVersionsInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/side-panel/application-remote-versions",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationRemoteVersionsQueryKey = (params)=>[
        "/v2/side-panel/application-remote-versions",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelApplicationRemoteVersionsInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationRemoteVersionsInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationRemoteVersions(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationRemoteVersionsInfinite(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationRemoteVersionsInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationRemoteVersionsQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationRemoteVersionsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationRemoteVersions(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationRemoteVersions(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationRemoteVersionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelApplicationRemoteVersionsSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelApplicationRemoteVersionsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelApplicationRemoteVersions(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelApplicationRemoteVersionsSuspense(params, options, queryClient) {
    const queryOptions = getGetSidePanelApplicationRemoteVersionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const deploySidePanelVersion = (deployVersionBody, params, options, signal)=>mutator({
        url: "/v2/side-panel/version-deploy",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deployVersionBody,
        params,
        signal
    }, options);
const getDeploySidePanelVersionMutationOptions = (options)=>{
    const mutationKey = [
        'deploySidePanelVersion'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data, params } = props !== null && props !== void 0 ? props : {};
        return deploySidePanelVersion(data, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeploySidePanelVersion = (options, queryClient)=>useMutation(getDeploySidePanelVersionMutationOptions(options), queryClient);
const getSidePanelDeployedVersionsList = (params, options, signal)=>mutator({
        url: "/v2/side-panel/version-deploy/list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSidePanelDeployedVersionsListInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/side-panel/version-deploy/list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelDeployedVersionsListQueryKey = (params)=>[
        "/v2/side-panel/version-deploy/list",
        ...params ? [
            params
        ] : []
    ];
const getGetSidePanelDeployedVersionsListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelDeployedVersionsListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelDeployedVersionsList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelDeployedVersionsListInfinite(params, options, queryClient) {
    const queryOptions = getGetSidePanelDeployedVersionsListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelDeployedVersionsListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelDeployedVersionsListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelDeployedVersionsList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelDeployedVersionsList(params, options, queryClient) {
    const queryOptions = getGetSidePanelDeployedVersionsListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSidePanelDeployedVersionsListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSidePanelDeployedVersionsListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSidePanelDeployedVersionsList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSidePanelDeployedVersionsListSuspense(params, options, queryClient) {
    const queryOptions = getGetSidePanelDeployedVersionsListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSpApplicationList = (options, signal)=>mutator({
        url: "/sp-app-list",
        method: 'GET',
        signal
    }, options);
const getGetSpApplicationListInfiniteQueryKey = ()=>[
        'infinite',
        "/sp-app-list"
    ];
const getGetSpApplicationListQueryKey = ()=>[
        "/sp-app-list"
    ];
const getGetSpApplicationListInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpApplicationListInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpApplicationList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpApplicationListInfinite(options, queryClient) {
    const queryOptions = getGetSpApplicationListInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpApplicationListQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpApplicationListQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpApplicationList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpApplicationList(options, queryClient) {
    const queryOptions = getGetSpApplicationListQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpApplicationListSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpApplicationListQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpApplicationList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpApplicationListSuspense(options, queryClient) {
    const queryOptions = getGetSpApplicationListSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSpAppEnvironment = (params, options, signal)=>mutator({
        url: "/sp-app-environment",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSpAppEnvironmentInfiniteQueryKey = (params)=>[
        'infinite',
        "/sp-app-environment",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppEnvironmentQueryKey = (params)=>[
        "/sp-app-environment",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppEnvironmentInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppEnvironmentInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppEnvironment(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppEnvironmentInfinite(params, options, queryClient) {
    const queryOptions = getGetSpAppEnvironmentInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppEnvironmentQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppEnvironmentQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppEnvironment(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppEnvironment(params, options, queryClient) {
    const queryOptions = getGetSpAppEnvironmentQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppEnvironmentSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppEnvironmentQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppEnvironment(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppEnvironmentSuspense(params, options, queryClient) {
    const queryOptions = getGetSpAppEnvironmentSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSpAppTagList = (params, options, signal)=>mutator({
        url: "/sp-app-tag-list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSpAppTagListInfiniteQueryKey = (params)=>[
        'infinite',
        "/sp-app-tag-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppTagListQueryKey = (params)=>[
        "/sp-app-tag-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppTagListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppTagListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppTagList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppTagListInfinite(params, options, queryClient) {
    const queryOptions = getGetSpAppTagListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppTagListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppTagListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppTagList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppTagList(params, options, queryClient) {
    const queryOptions = getGetSpAppTagListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppTagListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppTagListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppTagList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppTagListSuspense(params, options, queryClient) {
    const queryOptions = getGetSpAppTagListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSpAppVersionList = (params, options, signal)=>mutator({
        url: "/sp-app-version-list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSpAppVersionListInfiniteQueryKey = (params)=>[
        'infinite',
        "/sp-app-version-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppVersionListQueryKey = (params)=>[
        "/sp-app-version-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppVersionListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppVersionListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppVersionList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppVersionListInfinite(params, options, queryClient) {
    const queryOptions = getGetSpAppVersionListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppVersionListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppVersionListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppVersionList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppVersionList(params, options, queryClient) {
    const queryOptions = getGetSpAppVersionListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppVersionListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppVersionListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppVersionList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppVersionListSuspense(params, options, queryClient) {
    const queryOptions = getGetSpAppVersionListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getSpAppVersion = (params, options, signal)=>mutator({
        url: "/sp-app-version",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSpAppVersionInfiniteQueryKey = (params)=>[
        'infinite',
        "/sp-app-version",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppVersionQueryKey = (params)=>[
        "/sp-app-version",
        ...params ? [
            params
        ] : []
    ];
const getGetSpAppVersionInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppVersionInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppVersion(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppVersionInfinite(params, options, queryClient) {
    const queryOptions = getGetSpAppVersionInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppVersionQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppVersionQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppVersion(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppVersion(params, options, queryClient) {
    const queryOptions = getGetSpAppVersionQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpAppVersionSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpAppVersionQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpAppVersion(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpAppVersionSuspense(params, options, queryClient) {
    const queryOptions = getGetSpAppVersionSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const postSpVersionDeploy = (deployVersionBody, params, options, signal)=>mutator({
        url: "/sp-version-deploy",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deployVersionBody,
        params,
        signal
    }, options);
const getPostSpVersionDeployMutationOptions = (options)=>{
    const mutationKey = [
        'postSpVersionDeploy'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data, params } = props !== null && props !== void 0 ? props : {};
        return postSpVersionDeploy(data, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const usePostSpVersionDeploy = (options, queryClient)=>useMutation(getPostSpVersionDeployMutationOptions(options), queryClient);
const getSpVersionDeployList = (params, options, signal)=>mutator({
        url: "/sp-version-deploy-list",
        method: 'GET',
        params,
        signal
    }, options);
const getGetSpVersionDeployListInfiniteQueryKey = (params)=>[
        'infinite',
        "/sp-version-deploy-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSpVersionDeployListQueryKey = (params)=>[
        "/sp-version-deploy-list",
        ...params ? [
            params
        ] : []
    ];
const getGetSpVersionDeployListInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpVersionDeployListInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpVersionDeployList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpVersionDeployListInfinite(params, options, queryClient) {
    const queryOptions = getGetSpVersionDeployListInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpVersionDeployListQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpVersionDeployListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpVersionDeployList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpVersionDeployList(params, options, queryClient) {
    const queryOptions = getGetSpVersionDeployListQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetSpVersionDeployListSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetSpVersionDeployListQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getSpVersionDeployList(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetSpVersionDeployListSuspense(params, options, queryClient) {
    const queryOptions = getGetSpVersionDeployListSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getOrgNavigationItems = (params, options, signal)=>mutator({
        url: "/v2/user-navigation/org-items",
        method: 'GET',
        params,
        signal
    }, options);
const getGetOrgNavigationItemsInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/user-navigation/org-items",
        ...params ? [
            params
        ] : []
    ];
const getGetOrgNavigationItemsQueryKey = (params)=>[
        "/v2/user-navigation/org-items",
        ...params ? [
            params
        ] : []
    ];
const getGetOrgNavigationItemsInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrgNavigationItemsInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrgNavigationItems(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetOrgNavigationItemsInfinite(params, options, queryClient) {
    const queryOptions = getGetOrgNavigationItemsInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrgNavigationItemsQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrgNavigationItemsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrgNavigationItems(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetOrgNavigationItems(params, options, queryClient) {
    const queryOptions = getGetOrgNavigationItemsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetOrgNavigationItemsSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetOrgNavigationItemsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getOrgNavigationItems(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetOrgNavigationItemsSuspense(params, options, queryClient) {
    const queryOptions = getGetOrgNavigationItemsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjNavigationItems = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/user-navigation/".concat(encodeURIComponent(String(organization)), "/proj-items"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetProjNavigationItemsInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/user-navigation/".concat(organization, "/proj-items"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjNavigationItemsQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/user-navigation/".concat(organization, "/proj-items"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetProjNavigationItemsInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjNavigationItemsInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjNavigationItems({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetProjNavigationItemsInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetProjNavigationItemsInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjNavigationItemsQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjNavigationItemsQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjNavigationItems({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetProjNavigationItems(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetProjNavigationItemsQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjNavigationItemsSuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjNavigationItemsQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjNavigationItems({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjNavigationItemsSuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetProjNavigationItemsSuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAppNavigationItems = (param, params, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/user-navigation/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/app-items"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetAppNavigationItemsInfiniteQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/user-navigation/".concat(organization, "/").concat(project, "/app-items"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetAppNavigationItemsQueryKey = (param, params)=>{
    let { organization, project } = param;
    return [
        "/v2/user-navigation/".concat(organization, "/").concat(project, "/app-items"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetAppNavigationItemsInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAppNavigationItemsInfiniteQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAppNavigationItems({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetAppNavigationItemsInfinite(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetAppNavigationItemsInfiniteQueryOptions({
        organization,
        project
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAppNavigationItemsQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAppNavigationItemsQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAppNavigationItems({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetAppNavigationItems(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetAppNavigationItemsQueryOptions({
        organization,
        project
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAppNavigationItemsSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAppNavigationItemsQueryKey({
        organization,
        project
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAppNavigationItems({
            organization,
            project
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAppNavigationItemsSuspense(param, params, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetAppNavigationItemsSuspenseQueryOptions({
        organization,
        project
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const pinNavigationItem = (pinNavigationBody, options, signal)=>mutator({
        url: "/v2/user-navigation/pin",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: pinNavigationBody,
        signal
    }, options);
const getPinNavigationItemMutationOptions = (options)=>{
    const mutationKey = [
        'pinNavigationItem'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return pinNavigationItem(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const usePinNavigationItem = (options, queryClient)=>useMutation(getPinNavigationItemMutationOptions(options), queryClient);
const unpinNavigationItem = (unpinNavigationBody, options, signal)=>mutator({
        url: "/v2/user-navigation/unpin",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: unpinNavigationBody,
        signal
    }, options);
const getUnpinNavigationItemMutationOptions = (options)=>{
    const mutationKey = [
        'unpinNavigationItem'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return unpinNavigationItem(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUnpinNavigationItem = (options, queryClient)=>useMutation(getUnpinNavigationItemMutationOptions(options), queryClient);
const cliTest = (options, signal)=>mutator({
        url: "/v2/cli/test",
        method: 'GET',
        signal
    }, options);
const getCliTestInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/cli/test"
    ];
const getCliTestQueryKey = ()=>[
        "/v2/cli/test"
    ];
const getCliTestInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCliTestInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return cliTest(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCliTestInfinite(options, queryClient) {
    const queryOptions = getCliTestInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCliTestQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCliTestQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return cliTest(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCliTest(options, queryClient) {
    const queryOptions = getCliTestQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCliTestSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCliTestQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return cliTest(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCliTestSuspense(options, queryClient) {
    const queryOptions = getCliTestSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const generateUserAuthToken = (createUserTokenRequest, options, signal)=>mutator({
        url: "/v2/user/auth-token/generate",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createUserTokenRequest,
        signal
    }, options);
const getGenerateUserAuthTokenMutationOptions = (options)=>{
    const mutationKey = [
        'generateUserAuthToken'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return generateUserAuthToken(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useGenerateUserAuthToken = (options, queryClient)=>useMutation(getGenerateUserAuthTokenMutationOptions(options), queryClient);
const listUserAuthTokens = (options, signal)=>mutator({
        url: "/v2/user/auth-token/list",
        method: 'GET',
        signal
    }, options);
const getListUserAuthTokensInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/user/auth-token/list"
    ];
const getListUserAuthTokensQueryKey = ()=>[
        "/v2/user/auth-token/list"
    ];
const getListUserAuthTokensInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListUserAuthTokensInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return listUserAuthTokens(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListUserAuthTokensInfinite(options, queryClient) {
    const queryOptions = getListUserAuthTokensInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListUserAuthTokensQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListUserAuthTokensQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return listUserAuthTokens(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListUserAuthTokens(options, queryClient) {
    const queryOptions = getListUserAuthTokensQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getListUserAuthTokensSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getListUserAuthTokensQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return listUserAuthTokens(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useListUserAuthTokensSuspense(options, queryClient) {
    const queryOptions = getListUserAuthTokensSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUserAuthToken = (param, options, signal)=>{
    let { tokenName } = param;
    return mutator({
        url: "/v2/user/auth-token/".concat(encodeURIComponent(String(tokenName))),
        method: 'GET',
        signal
    }, options);
};
const getGetUserAuthTokenInfiniteQueryKey = (param)=>{
    let { tokenName } = param;
    return [
        'infinite',
        "/v2/user/auth-token/".concat(tokenName)
    ];
};
const getGetUserAuthTokenQueryKey = (param)=>{
    let { tokenName } = param;
    return [
        "/v2/user/auth-token/".concat(tokenName)
    ];
};
const getGetUserAuthTokenInfiniteQueryOptions = (param, options)=>{
    let { tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserAuthTokenInfiniteQueryKey({
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserAuthToken({
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!tokenName
    }, queryOptions);
};
function useGetUserAuthTokenInfinite(param, options, queryClient) {
    let { tokenName } = param;
    const queryOptions = getGetUserAuthTokenInfiniteQueryOptions({
        tokenName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserAuthTokenQueryOptions = (param, options)=>{
    let { tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserAuthTokenQueryKey({
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserAuthToken({
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!tokenName
    }, queryOptions);
};
function useGetUserAuthToken(param, options, queryClient) {
    let { tokenName } = param;
    const queryOptions = getGetUserAuthTokenQueryOptions({
        tokenName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserAuthTokenSuspenseQueryOptions = (param, options)=>{
    let { tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserAuthTokenQueryKey({
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserAuthToken({
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserAuthTokenSuspense(param, options, queryClient) {
    let { tokenName } = param;
    const queryOptions = getGetUserAuthTokenSuspenseQueryOptions({
        tokenName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const editUserAuthToken = (param, updateUserTokenRequest, options, signal)=>{
    let { tokenName } = param;
    return mutator({
        url: "/v2/user/auth-token/".concat(encodeURIComponent(String(tokenName))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateUserTokenRequest,
        signal
    }, options);
};
const getEditUserAuthTokenMutationOptions = (options)=>{
    const mutationKey = [
        'editUserAuthToken'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return editUserAuthToken(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useEditUserAuthToken = (options, queryClient)=>useMutation(getEditUserAuthTokenMutationOptions(options), queryClient);
const deleteUserAuthToken = (param, options, signal)=>{
    let { tokenName } = param;
    return mutator({
        url: "/v2/user/auth-token/".concat(encodeURIComponent(String(tokenName))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteUserAuthTokenMutationOptions = (options)=>{
    const mutationKey = [
        'deleteUserAuthToken'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteUserAuthToken(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteUserAuthToken = (options, queryClient)=>useMutation(getDeleteUserAuthTokenMutationOptions(options), queryClient);
const updateUserAuthTokenName = (param, updateUserTokenNameRequest, options, signal)=>{
    let { tokenName } = param;
    return mutator({
        url: "/v2/user/auth-token/".concat(encodeURIComponent(String(tokenName)), "/name"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateUserTokenNameRequest,
        signal
    }, options);
};
const getUpdateUserAuthTokenNameMutationOptions = (options)=>{
    const mutationKey = [
        'updateUserAuthTokenName'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateUserAuthTokenName(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateUserAuthTokenName = (options, queryClient)=>useMutation(getUpdateUserAuthTokenNameMutationOptions(options), queryClient);
const isUserAuthTokenNameUnique = (param, options, signal)=>{
    let { tokenName } = param;
    return mutator({
        url: "/v2/user/auth-token/".concat(encodeURIComponent(String(tokenName)), "/is-token-name-unique"),
        method: 'GET',
        signal
    }, options);
};
const getIsUserAuthTokenNameUniqueInfiniteQueryKey = (param)=>{
    let { tokenName } = param;
    return [
        'infinite',
        "/v2/user/auth-token/".concat(tokenName, "/is-token-name-unique")
    ];
};
const getIsUserAuthTokenNameUniqueQueryKey = (param)=>{
    let { tokenName } = param;
    return [
        "/v2/user/auth-token/".concat(tokenName, "/is-token-name-unique")
    ];
};
const getIsUserAuthTokenNameUniqueInfiniteQueryOptions = (param, options)=>{
    let { tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUserAuthTokenNameUniqueInfiniteQueryKey({
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUserAuthTokenNameUnique({
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!tokenName
    }, queryOptions);
};
function useIsUserAuthTokenNameUniqueInfinite(param, options, queryClient) {
    let { tokenName } = param;
    const queryOptions = getIsUserAuthTokenNameUniqueInfiniteQueryOptions({
        tokenName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUserAuthTokenNameUniqueQueryOptions = (param, options)=>{
    let { tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUserAuthTokenNameUniqueQueryKey({
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUserAuthTokenNameUnique({
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!tokenName
    }, queryOptions);
};
function useIsUserAuthTokenNameUnique(param, options, queryClient) {
    let { tokenName } = param;
    const queryOptions = getIsUserAuthTokenNameUniqueQueryOptions({
        tokenName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUserAuthTokenNameUniqueSuspenseQueryOptions = (param, options)=>{
    let { tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUserAuthTokenNameUniqueQueryKey({
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isUserAuthTokenNameUnique({
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useIsUserAuthTokenNameUniqueSuspense(param, options, queryClient) {
    let { tokenName } = param;
    const queryOptions = getIsUserAuthTokenNameUniqueSuspenseQueryOptions({
        tokenName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getServerAuthTokenList = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/server-auth-token/".concat(encodeURIComponent(String(organization))),
        method: 'GET',
        signal
    }, options);
};
const getGetServerAuthTokenListInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/server-auth-token/".concat(organization)
    ];
};
const getGetServerAuthTokenListQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/server-auth-token/".concat(organization)
    ];
};
const getGetServerAuthTokenListInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetServerAuthTokenListInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getServerAuthTokenList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetServerAuthTokenListInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetServerAuthTokenListInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetServerAuthTokenListQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetServerAuthTokenListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getServerAuthTokenList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetServerAuthTokenList(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetServerAuthTokenListQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetServerAuthTokenListSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetServerAuthTokenListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getServerAuthTokenList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetServerAuthTokenListSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetServerAuthTokenListSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const createServerAuthToken = (param, createServerAuthTokenDto, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/server-auth-token/".concat(encodeURIComponent(String(organization))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createServerAuthTokenDto,
        signal
    }, options);
};
const getCreateServerAuthTokenMutationOptions = (options)=>{
    const mutationKey = [
        'createServerAuthToken'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return createServerAuthToken(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateServerAuthToken = (options, queryClient)=>useMutation(getCreateServerAuthTokenMutationOptions(options), queryClient);
const getServerAuthToken = (param, options, signal)=>{
    let { organization, tokenName } = param;
    return mutator({
        url: "/v2/server-auth-token/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(tokenName))),
        method: 'GET',
        signal
    }, options);
};
const getGetServerAuthTokenInfiniteQueryKey = (param)=>{
    let { organization, tokenName } = param;
    return [
        'infinite',
        "/v2/server-auth-token/".concat(organization, "/").concat(tokenName)
    ];
};
const getGetServerAuthTokenQueryKey = (param)=>{
    let { organization, tokenName } = param;
    return [
        "/v2/server-auth-token/".concat(organization, "/").concat(tokenName)
    ];
};
const getGetServerAuthTokenInfiniteQueryOptions = (param, options)=>{
    let { organization, tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetServerAuthTokenInfiniteQueryKey({
        organization,
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getServerAuthToken({
            organization,
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && tokenName)
    }, queryOptions);
};
function useGetServerAuthTokenInfinite(param, options, queryClient) {
    let { organization, tokenName } = param;
    const queryOptions = getGetServerAuthTokenInfiniteQueryOptions({
        organization,
        tokenName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetServerAuthTokenQueryOptions = (param, options)=>{
    let { organization, tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetServerAuthTokenQueryKey({
        organization,
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getServerAuthToken({
            organization,
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && tokenName)
    }, queryOptions);
};
function useGetServerAuthToken(param, options, queryClient) {
    let { organization, tokenName } = param;
    const queryOptions = getGetServerAuthTokenQueryOptions({
        organization,
        tokenName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetServerAuthTokenSuspenseQueryOptions = (param, options)=>{
    let { organization, tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetServerAuthTokenQueryKey({
        organization,
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getServerAuthToken({
            organization,
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetServerAuthTokenSuspense(param, options, queryClient) {
    let { organization, tokenName } = param;
    const queryOptions = getGetServerAuthTokenSuspenseQueryOptions({
        organization,
        tokenName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateServerAuthToken = (param, updateServerAuthTokenDto, options, signal)=>{
    let { organization, tokenName } = param;
    return mutator({
        url: "/v2/server-auth-token/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(tokenName))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateServerAuthTokenDto,
        signal
    }, options);
};
const getUpdateServerAuthTokenMutationOptions = (options)=>{
    const mutationKey = [
        'updateServerAuthToken'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateServerAuthToken(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateServerAuthToken = (options, queryClient)=>useMutation(getUpdateServerAuthTokenMutationOptions(options), queryClient);
const deleteServerAuthToken = (param, options, signal)=>{
    let { organization, tokenName } = param;
    return mutator({
        url: "/v2/server-auth-token/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(tokenName))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteServerAuthTokenMutationOptions = (options)=>{
    const mutationKey = [
        'deleteServerAuthToken'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deleteServerAuthToken(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeleteServerAuthToken = (options, queryClient)=>useMutation(getDeleteServerAuthTokenMutationOptions(options), queryClient);
const isServerAuthTokenNameUnique = (param, options, signal)=>{
    let { organization, tokenName } = param;
    return mutator({
        url: "/v2/server-auth-token/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(tokenName)), "/is-name-unique"),
        method: 'GET',
        signal
    }, options);
};
const getIsServerAuthTokenNameUniqueInfiniteQueryKey = (param)=>{
    let { organization, tokenName } = param;
    return [
        'infinite',
        "/v2/server-auth-token/".concat(organization, "/").concat(tokenName, "/is-name-unique")
    ];
};
const getIsServerAuthTokenNameUniqueQueryKey = (param)=>{
    let { organization, tokenName } = param;
    return [
        "/v2/server-auth-token/".concat(organization, "/").concat(tokenName, "/is-name-unique")
    ];
};
const getIsServerAuthTokenNameUniqueInfiniteQueryOptions = (param, options)=>{
    let { organization, tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsServerAuthTokenNameUniqueInfiniteQueryKey({
        organization,
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isServerAuthTokenNameUnique({
            organization,
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && tokenName)
    }, queryOptions);
};
function useIsServerAuthTokenNameUniqueInfinite(param, options, queryClient) {
    let { organization, tokenName } = param;
    const queryOptions = getIsServerAuthTokenNameUniqueInfiniteQueryOptions({
        organization,
        tokenName
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsServerAuthTokenNameUniqueQueryOptions = (param, options)=>{
    let { organization, tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsServerAuthTokenNameUniqueQueryKey({
        organization,
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isServerAuthTokenNameUnique({
            organization,
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && tokenName)
    }, queryOptions);
};
function useIsServerAuthTokenNameUnique(param, options, queryClient) {
    let { organization, tokenName } = param;
    const queryOptions = getIsServerAuthTokenNameUniqueQueryOptions({
        organization,
        tokenName
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsServerAuthTokenNameUniqueSuspenseQueryOptions = (param, options)=>{
    let { organization, tokenName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsServerAuthTokenNameUniqueQueryKey({
        organization,
        tokenName
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return isServerAuthTokenNameUnique({
            organization,
            tokenName
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useIsServerAuthTokenNameUniqueSuspense(param, options, queryClient) {
    let { organization, tokenName } = param;
    const queryOptions = getIsServerAuthTokenNameUniqueSuspenseQueryOptions({
        organization,
        tokenName
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const create = (param, createDeploymentIntegration, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createDeploymentIntegration,
        signal
    }, options);
};
const getCreateMutationOptions = (options)=>{
    const mutationKey = [
        'create'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return create(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreate = (options, queryClient)=>useMutation(getCreateMutationOptions(options), queryClient);
const getList = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/list"),
        method: 'GET',
        signal
    }, options);
};
const getGetListInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/deployment-integration/list")
    ];
};
const getGetListQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/deployment-integration/list")
    ];
};
const getGetListInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetListInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetListInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetListInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetListQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetList(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetListQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetListSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetListSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetListSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEnabledList = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/list/enabled"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnabledListInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/deployment-integration/list/enabled")
    ];
};
const getGetEnabledListQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/deployment-integration/list/enabled")
    ];
};
const getGetEnabledListInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnabledListInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnabledList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEnabledListInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEnabledListInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnabledListQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnabledListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnabledList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEnabledList(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEnabledListQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnabledListSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnabledListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnabledList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnabledListSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEnabledListSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getDeploymentIntegration = (param, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration))),
        method: 'GET',
        signal
    }, options);
};
const getGetDeploymentIntegrationInfiniteQueryKey = (param)=>{
    let { organization, integration } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/deployment-integration/").concat(integration)
    ];
};
const getGetDeploymentIntegrationQueryKey = (param)=>{
    let { organization, integration } = param;
    return [
        "/v2/organization/".concat(organization, "/deployment-integration/").concat(integration)
    ];
};
const getGetDeploymentIntegrationInfiniteQueryOptions = (param, options)=>{
    let { organization, integration } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeploymentIntegrationInfiniteQueryKey({
        organization,
        integration
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeploymentIntegration({
            organization,
            integration
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && integration)
    }, queryOptions);
};
function useGetDeploymentIntegrationInfinite(param, options, queryClient) {
    let { organization, integration } = param;
    const queryOptions = getGetDeploymentIntegrationInfiniteQueryOptions({
        organization,
        integration
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeploymentIntegrationQueryOptions = (param, options)=>{
    let { organization, integration } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeploymentIntegrationQueryKey({
        organization,
        integration
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeploymentIntegration({
            organization,
            integration
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && integration)
    }, queryOptions);
};
function useGetDeploymentIntegration(param, options, queryClient) {
    let { organization, integration } = param;
    const queryOptions = getGetDeploymentIntegrationQueryOptions({
        organization,
        integration
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeploymentIntegrationSuspenseQueryOptions = (param, options)=>{
    let { organization, integration } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeploymentIntegrationQueryKey({
        organization,
        integration
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeploymentIntegration({
            organization,
            integration
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetDeploymentIntegrationSuspense(param, options, queryClient) {
    let { organization, integration } = param;
    const queryOptions = getGetDeploymentIntegrationSuspenseQueryOptions({
        organization,
        integration
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateOrganizationDeploymentIntegration = (param, updateDeploymentIntegration, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateDeploymentIntegration,
        signal
    }, options);
};
const getUpdateOrganizationDeploymentIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'updateOrganizationDeploymentIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateOrganizationDeploymentIntegration(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateOrganizationDeploymentIntegration = (options, queryClient)=>useMutation(getUpdateOrganizationDeploymentIntegrationMutationOptions(options), queryClient);
const _delete = (param, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeleteMutationOptions = (options)=>{
    const mutationKey = [
        '_delete'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return _delete(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDelete = (options, queryClient)=>useMutation(getDeleteMutationOptions(options), queryClient);
const updateWorker = (param, updateWorkerVersion, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/worker"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateWorkerVersion,
        signal
    }, options);
};
const getUpdateWorkerMutationOptions = (options)=>{
    const mutationKey = [
        'updateWorker'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return updateWorker(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateWorker = (options, queryClient)=>useMutation(getUpdateWorkerMutationOptions(options), queryClient);
const createMultiCdn = (param, multiCdnConfig, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/multi-cdn"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: multiCdnConfig,
        signal
    }, options);
};
const getCreateMultiCdnMutationOptions = (options)=>{
    const mutationKey = [
        'createMultiCdn'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return createMultiCdn(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCreateMultiCdn = (options, queryClient)=>useMutation(getCreateMultiCdnMutationOptions(options), queryClient);
const getMultiCdnList = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/multi-cdn/list"),
        method: 'GET',
        signal
    }, options);
};
const getGetMultiCdnListInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/deployment-integration/multi-cdn/list")
    ];
};
const getGetMultiCdnListQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/deployment-integration/multi-cdn/list")
    ];
};
const getGetMultiCdnListInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetMultiCdnListInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getMultiCdnList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetMultiCdnListInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetMultiCdnListInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetMultiCdnListQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetMultiCdnListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getMultiCdnList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetMultiCdnList(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetMultiCdnListQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetMultiCdnListSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetMultiCdnListQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getMultiCdnList({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetMultiCdnListSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetMultiCdnListSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const setDefault = (param, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/default"),
        method: 'POST',
        signal
    }, options);
};
const getSetDefaultMutationOptions = (options)=>{
    const mutationKey = [
        'setDefault'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setDefault(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetDefault = (options, queryClient)=>useMutation(getSetDefaultMutationOptions(options), queryClient);
const unsetDefault = (param, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/default"),
        method: 'DELETE',
        signal
    }, options);
};
const getUnsetDefaultMutationOptions = (options)=>{
    const mutationKey = [
        'unsetDefault'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return unsetDefault(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUnsetDefault = (options, queryClient)=>useMutation(getUnsetDefaultMutationOptions(options), queryClient);
const toggleEnabled = (param, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/enabled"),
        method: 'POST',
        signal
    }, options);
};
const getToggleEnabledMutationOptions = (options)=>{
    const mutationKey = [
        'toggleEnabled'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return toggleEnabled(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useToggleEnabled = (options, queryClient)=>useMutation(getToggleEnabledMutationOptions(options), queryClient);
const setZephyrAsDefault = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/zephyr/set-as-default"),
        method: 'POST',
        signal
    }, options);
};
const getSetZephyrAsDefaultMutationOptions = (options)=>{
    const mutationKey = [
        'setZephyrAsDefault'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setZephyrAsDefault(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetZephyrAsDefault = (options, queryClient)=>useMutation(getSetZephyrAsDefaultMutationOptions(options), queryClient);
const isUserZephyrTeam = (options, signal)=>mutator({
        url: "/v2/organization/deployment-integration/permission/is-user-zephyr-team",
        method: 'GET',
        signal
    }, options);
const getIsUserZephyrTeamInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/organization/deployment-integration/permission/is-user-zephyr-team"
    ];
const getIsUserZephyrTeamQueryKey = ()=>[
        "/v2/organization/deployment-integration/permission/is-user-zephyr-team"
    ];
const getIsUserZephyrTeamInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUserZephyrTeamInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return isUserZephyrTeam(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useIsUserZephyrTeamInfinite(options, queryClient) {
    const queryOptions = getIsUserZephyrTeamInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUserZephyrTeamQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUserZephyrTeamQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return isUserZephyrTeam(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useIsUserZephyrTeam(options, queryClient) {
    const queryOptions = getIsUserZephyrTeamQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getIsUserZephyrTeamSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getIsUserZephyrTeamQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return isUserZephyrTeam(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useIsUserZephyrTeamSuspense(options, queryClient) {
    const queryOptions = getIsUserZephyrTeamSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const retry = (param, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/retry"),
        method: 'POST',
        signal
    }, options);
};
const getRetryMutationOptions = (options)=>{
    const mutationKey = [
        'retry'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return retry(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRetry = (options, queryClient)=>useMutation(getRetryMutationOptions(options), queryClient);
const changeOrganizationDeploymentIntegrationName = (param, changeIntegrationNameRequest, options, signal)=>{
    let { organization, integration } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/change-name"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: changeIntegrationNameRequest,
        signal
    }, options);
};
const getChangeOrganizationDeploymentIntegrationNameMutationOptions = (options)=>{
    const mutationKey = [
        'changeOrganizationDeploymentIntegrationName'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return changeOrganizationDeploymentIntegrationName(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useChangeOrganizationDeploymentIntegrationName = (options, queryClient)=>useMutation(getChangeOrganizationDeploymentIntegrationNameMutationOptions(options), queryClient);
const setDefaultProjectIntegration = (param, options, signal)=>{
    let { organization, project, integration } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/default"),
        method: 'POST',
        signal
    }, options);
};
const getSetDefaultProjectIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'setDefaultProjectIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setDefaultProjectIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetDefaultProjectIntegration = (options, queryClient)=>useMutation(getSetDefaultProjectIntegrationMutationOptions(options), queryClient);
const unsetDefaultProjectIntegration = (param, options, signal)=>{
    let { organization, project, integration } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/deployment-integration/").concat(encodeURIComponent(String(integration)), "/default"),
        method: 'DELETE',
        signal
    }, options);
};
const getUnsetDefaultProjectIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'unsetDefaultProjectIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return unsetDefaultProjectIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUnsetDefaultProjectIntegration = (options, queryClient)=>useMutation(getUnsetDefaultProjectIntegrationMutationOptions(options), queryClient);
const getProjectIntegrationList = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/deployment-integration/list"),
        method: 'GET',
        signal
    }, options);
};
const getGetProjectIntegrationListInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/deployment-integration/list")
    ];
};
const getGetProjectIntegrationListQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/deployment-integration/list")
    ];
};
const getGetProjectIntegrationListInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectIntegrationListInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectIntegrationList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectIntegrationListInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectIntegrationListInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectIntegrationListQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectIntegrationListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectIntegrationList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectIntegrationList(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectIntegrationListQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectIntegrationListSuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectIntegrationListQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectIntegrationList({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectIntegrationListSuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectIntegrationListSuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getProjectDeploymentIntegrationApps = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/deployment-integration/apps"),
        method: 'GET',
        signal
    }, options);
};
const getGetProjectDeploymentIntegrationAppsInfiniteQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        'infinite',
        "/v2/project/".concat(organization, "/").concat(project, "/deployment-integration/apps")
    ];
};
const getGetProjectDeploymentIntegrationAppsQueryKey = (param)=>{
    let { organization, project } = param;
    return [
        "/v2/project/".concat(organization, "/").concat(project, "/deployment-integration/apps")
    ];
};
const getGetProjectDeploymentIntegrationAppsInfiniteQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectDeploymentIntegrationAppsInfiniteQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectDeploymentIntegrationApps({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectDeploymentIntegrationAppsInfinite(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectDeploymentIntegrationAppsInfiniteQueryOptions({
        organization,
        project
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectDeploymentIntegrationAppsQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectDeploymentIntegrationAppsQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectDeploymentIntegrationApps({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project)
    }, queryOptions);
};
function useGetProjectDeploymentIntegrationApps(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectDeploymentIntegrationAppsQueryOptions({
        organization,
        project
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetProjectDeploymentIntegrationAppsSuspenseQueryOptions = (param, options)=>{
    let { organization, project } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetProjectDeploymentIntegrationAppsQueryKey({
        organization,
        project
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getProjectDeploymentIntegrationApps({
            organization,
            project
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetProjectDeploymentIntegrationAppsSuspense(param, options, queryClient) {
    let { organization, project } = param;
    const queryOptions = getGetProjectDeploymentIntegrationAppsSuspenseQueryOptions({
        organization,
        project
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const setDeploymentIntegrationAllAppsToProjectDefault = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/deployment-integration/set-all-apps-to-project-default"),
        method: 'POST',
        signal
    }, options);
};
const getSetDeploymentIntegrationAllAppsToProjectDefaultMutationOptions = (options)=>{
    const mutationKey = [
        'setDeploymentIntegrationAllAppsToProjectDefault'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setDeploymentIntegrationAllAppsToProjectDefault(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetDeploymentIntegrationAllAppsToProjectDefault = (options, queryClient)=>useMutation(getSetDeploymentIntegrationAllAppsToProjectDefaultMutationOptions(options), queryClient);
const setZephyrAsDefaultProjectIntegration = (param, options, signal)=>{
    let { organization, project } = param;
    return mutator({
        url: "/v2/project/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/deployment-integration/set-zephyr-as-default"),
        method: 'POST',
        signal
    }, options);
};
const getSetZephyrAsDefaultProjectIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'setZephyrAsDefaultProjectIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setZephyrAsDefaultProjectIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetZephyrAsDefaultProjectIntegration = (options, queryClient)=>useMutation(getSetZephyrAsDefaultProjectIntegrationMutationOptions(options), queryClient);
const setDefaultApplicationIntegration = (param, options, signal)=>{
    let { organization, project, application, integration } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/deployment-integrations/").concat(encodeURIComponent(String(integration))),
        method: 'POST',
        signal
    }, options);
};
const getSetDefaultApplicationIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'setDefaultApplicationIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setDefaultApplicationIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetDefaultApplicationIntegration = (options, queryClient)=>useMutation(getSetDefaultApplicationIntegrationMutationOptions(options), queryClient);
const unsetDefaultApplicationIntegration = (param, options, signal)=>{
    let { organization, project, application, integration } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/deployment-integrations/").concat(encodeURIComponent(String(integration)), "/unset-default"),
        method: 'POST',
        signal
    }, options);
};
const getUnsetDefaultApplicationIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'unsetDefaultApplicationIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return unsetDefaultApplicationIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUnsetDefaultApplicationIntegration = (options, queryClient)=>useMutation(getUnsetDefaultApplicationIntegrationMutationOptions(options), queryClient);
const getApplicationIntegrationList = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/deployment-integrations"),
        method: 'GET',
        signal
    }, options);
};
const getGetApplicationIntegrationListInfiniteQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/deployment-integrations")
    ];
};
const getGetApplicationIntegrationListQueryKey = (param)=>{
    let { organization, project, application } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/deployment-integrations")
    ];
};
const getGetApplicationIntegrationListInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationIntegrationListInfiniteQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationIntegrationList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationIntegrationListInfinite(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationIntegrationListInfiniteQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationIntegrationListQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationIntegrationListQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationIntegrationList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application)
    }, queryOptions);
};
function useGetApplicationIntegrationList(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationIntegrationListQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationIntegrationListSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationIntegrationListQueryKey({
        organization,
        project,
        application
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationIntegrationList({
            organization,
            project,
            application
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationIntegrationListSuspense(param, options, queryClient) {
    let { organization, project, application } = param;
    const queryOptions = getGetApplicationIntegrationListSuspenseQueryOptions({
        organization,
        project,
        application
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const setZephyrAsDefaultApplicationIntegration = (param, options, signal)=>{
    let { organization, project, application } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/deployment-integrations/zephyr/set-as-default"),
        method: 'POST',
        signal
    }, options);
};
const getSetZephyrAsDefaultApplicationIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'setZephyrAsDefaultApplicationIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setZephyrAsDefaultApplicationIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetZephyrAsDefaultApplicationIntegration = (options, queryClient)=>useMutation(getSetZephyrAsDefaultApplicationIntegrationMutationOptions(options), queryClient);
const getEnvironmentDeploymentIntegrationList = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/list"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnvironmentDeploymentIntegrationListInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/deployment-integration/list")
    ];
};
const getGetEnvironmentDeploymentIntegrationListQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/deployment-integration/list")
    ];
};
const getGetEnvironmentDeploymentIntegrationListInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDeploymentIntegrationListInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDeploymentIntegrationList({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentDeploymentIntegrationListInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDeploymentIntegrationListInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentDeploymentIntegrationListQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDeploymentIntegrationListQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDeploymentIntegrationList({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentDeploymentIntegrationList(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDeploymentIntegrationListQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentDeploymentIntegrationListSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentDeploymentIntegrationListQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentDeploymentIntegrationList({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentDeploymentIntegrationListSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentDeploymentIntegrationListSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const setEnvironmentDeploymentIntegration = (param, options, signal)=>{
    let { organization, project, application, environment, deploymentIntegration } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/").concat(encodeURIComponent(String(deploymentIntegration)), "/set"),
        method: 'POST',
        signal
    }, options);
};
const getSetEnvironmentDeploymentIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'setEnvironmentDeploymentIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setEnvironmentDeploymentIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetEnvironmentDeploymentIntegration = (options, queryClient)=>useMutation(getSetEnvironmentDeploymentIntegrationMutationOptions(options), queryClient);
const unsetEnvironmentDeploymentIntegration = (param, options, signal)=>{
    let { organization, project, application, environment, deploymentIntegration } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/").concat(encodeURIComponent(String(deploymentIntegration)), "/unset"),
        method: 'DELETE',
        signal
    }, options);
};
const getUnsetEnvironmentDeploymentIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'unsetEnvironmentDeploymentIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return unsetEnvironmentDeploymentIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUnsetEnvironmentDeploymentIntegration = (options, queryClient)=>useMutation(getUnsetEnvironmentDeploymentIntegrationMutationOptions(options), queryClient);
const setZephyrAsDefaultEnvironmentIntegration = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/set/zephyr-as-default"),
        method: 'POST',
        signal
    }, options);
};
const getSetZephyrAsDefaultEnvironmentIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'setZephyrAsDefaultEnvironmentIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setZephyrAsDefaultEnvironmentIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetZephyrAsDefaultEnvironmentIntegration = (options, queryClient)=>useMutation(getSetZephyrAsDefaultEnvironmentIntegrationMutationOptions(options), queryClient);
const getEnvironmentIntegrations = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/poly-cloud/integrations"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnvironmentIntegrationsInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/deployment-integration/poly-cloud/integrations")
    ];
};
const getGetEnvironmentIntegrationsQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/deployment-integration/poly-cloud/integrations")
    ];
};
const getGetEnvironmentIntegrationsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentIntegrationsInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentIntegrations({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentIntegrationsInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentIntegrationsInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentIntegrationsQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentIntegrationsQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentIntegrations({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentIntegrations(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentIntegrationsQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentIntegrationsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentIntegrationsQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentIntegrations({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentIntegrationsSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentIntegrationsSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const addIntegrationToEnvironment = (param, addIntegrationToEnvironmentBody, options, signal)=>{
    let { organization, project, application, environment, deploymentIntegration } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/poly-cloud/integrations/").concat(encodeURIComponent(String(deploymentIntegration)), "/add"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: addIntegrationToEnvironmentBody,
        signal
    }, options);
};
const getAddIntegrationToEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'addIntegrationToEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return addIntegrationToEnvironment(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useAddIntegrationToEnvironment = (options, queryClient)=>useMutation(getAddIntegrationToEnvironmentMutationOptions(options), queryClient);
const setPrimaryIntegration = (param, options, signal)=>{
    let { organization, project, application, environment, deploymentIntegration } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/poly-cloud/integrations/").concat(encodeURIComponent(String(deploymentIntegration)), "/primary"),
        method: 'PUT',
        signal
    }, options);
};
const getSetPrimaryIntegrationMutationOptions = (options)=>{
    const mutationKey = [
        'setPrimaryIntegration'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return setPrimaryIntegration(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSetPrimaryIntegration = (options, queryClient)=>useMutation(getSetPrimaryIntegrationMutationOptions(options), queryClient);
const removeIntegrationFromEnvironment = (param, options, signal)=>{
    let { organization, project, application, environment, deploymentIntegration } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/poly-cloud/integrations/").concat(encodeURIComponent(String(deploymentIntegration)), "/remove"),
        method: 'DELETE',
        signal
    }, options);
};
const getRemoveIntegrationFromEnvironmentMutationOptions = (options)=>{
    const mutationKey = [
        'removeIntegrationFromEnvironment'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return removeIntegrationFromEnvironment(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useRemoveIntegrationFromEnvironment = (options, queryClient)=>useMutation(getRemoveIntegrationFromEnvironmentMutationOptions(options), queryClient);
const getDeploymentStatus = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/application/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/deployment-integration/poly-cloud/deployment-status"),
        method: 'GET',
        signal
    }, options);
};
const getGetDeploymentStatusInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/deployment-integration/poly-cloud/deployment-status")
    ];
};
const getGetDeploymentStatusQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/application/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/deployment-integration/poly-cloud/deployment-status")
    ];
};
const getGetDeploymentStatusInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeploymentStatusInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeploymentStatus({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetDeploymentStatusInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetDeploymentStatusInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeploymentStatusQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeploymentStatusQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeploymentStatus({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetDeploymentStatus(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetDeploymentStatusQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeploymentStatusSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeploymentStatusQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeploymentStatus({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetDeploymentStatusSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetDeploymentStatusSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getUserProfileSettings = (options, signal)=>mutator({
        url: "/v2/user-profile-settings",
        method: 'GET',
        signal
    }, options);
const getGetUserProfileSettingsInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/user-profile-settings"
    ];
const getGetUserProfileSettingsQueryKey = ()=>[
        "/v2/user-profile-settings"
    ];
const getGetUserProfileSettingsInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserProfileSettingsInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserProfileSettings(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserProfileSettingsInfinite(options, queryClient) {
    const queryOptions = getGetUserProfileSettingsInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserProfileSettingsQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserProfileSettingsQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserProfileSettings(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserProfileSettings(options, queryClient) {
    const queryOptions = getGetUserProfileSettingsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserProfileSettingsSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserProfileSettingsQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserProfileSettings(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserProfileSettingsSuspense(options, queryClient) {
    const queryOptions = getGetUserProfileSettingsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateUserProfileSettings = (updateProfileSettings, options, signal)=>mutator({
        url: "/v2/user-profile-settings",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateProfileSettings,
        signal
    }, options);
const getUpdateUserProfileSettingsMutationOptions = (options)=>{
    const mutationKey = [
        'updateUserProfileSettings'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return updateUserProfileSettings(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateUserProfileSettings = (options, queryClient)=>useMutation(getUpdateUserProfileSettingsMutationOptions(options), queryClient);
const getUserEmailOptions = (options, signal)=>mutator({
        url: "/v2/user-profile-settings/email-options",
        method: 'GET',
        signal
    }, options);
const getGetUserEmailOptionsInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/user-profile-settings/email-options"
    ];
const getGetUserEmailOptionsQueryKey = ()=>[
        "/v2/user-profile-settings/email-options"
    ];
const getGetUserEmailOptionsInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserEmailOptionsInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserEmailOptions(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserEmailOptionsInfinite(options, queryClient) {
    const queryOptions = getGetUserEmailOptionsInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserEmailOptionsQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserEmailOptionsQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserEmailOptions(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserEmailOptions(options, queryClient) {
    const queryOptions = getGetUserEmailOptionsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetUserEmailOptionsSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetUserEmailOptionsQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getUserEmailOptions(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetUserEmailOptionsSuspense(options, queryClient) {
    const queryOptions = getGetUserEmailOptionsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const updateUserEmailOptions = (updateEmailOptions, options, signal)=>mutator({
        url: "/v2/user-profile-settings/email-options",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateEmailOptions,
        signal
    }, options);
const getUpdateUserEmailOptionsMutationOptions = (options)=>{
    const mutationKey = [
        'updateUserEmailOptions'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return updateUserEmailOptions(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateUserEmailOptions = (options, queryClient)=>useMutation(getUpdateUserEmailOptionsMutationOptions(options), queryClient);
const zephyr_changePassword = (changePassword, options, signal)=>mutator({
        url: "/v2/user-password-change",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: changePassword,
        signal
    }, options);
const getChangePasswordMutationOptions = (options)=>{
    const mutationKey = [
        'changePassword'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return zephyr_changePassword(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useChangePassword = (options, queryClient)=>useMutation(getChangePasswordMutationOptions(options), queryClient);
const resendVerificationEmail = (options, signal)=>mutator({
        url: "/v2/user/resend-verification-email",
        method: 'POST',
        signal
    }, options);
const getResendVerificationEmailMutationOptions = (options)=>{
    const mutationKey = [
        'resendVerificationEmail'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = ()=>resendVerificationEmail(requestOptions);
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useResendVerificationEmail = (options, queryClient)=>useMutation(getResendVerificationEmailMutationOptions(options), queryClient);
const deactivateUserAccount = (options, signal)=>mutator({
        url: "/v2/user-profile-settings/deactivate",
        method: 'DELETE',
        signal
    }, options);
const getDeactivateUserAccountMutationOptions = (options)=>{
    const mutationKey = [
        'deactivateUserAccount'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = ()=>deactivateUserAccount(requestOptions);
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeactivateUserAccount = (options, queryClient)=>useMutation(getDeactivateUserAccountMutationOptions(options), queryClient);
const getEnvironmentAuditLog = (param, params, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/pipeline/audit-log/environment/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/log"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetEnvironmentAuditLogInfiniteQueryKey = (param, params)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/pipeline/audit-log/environment/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/log"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentAuditLogQueryKey = (param, params)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/pipeline/audit-log/environment/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/log"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEnvironmentAuditLogInfiniteQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentAuditLogInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentAuditLog({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentAuditLogInfinite(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentAuditLogInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentAuditLogQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentAuditLogQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentAuditLog({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentAuditLog(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentAuditLogQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentAuditLogSuspenseQueryOptions = (param, params, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentAuditLogQueryKey({
        organization,
        project,
        application,
        environment
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentAuditLog({
            organization,
            project,
            application,
            environment
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentAuditLogSuspense(param, params, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentAuditLogSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEnvironmentAuthors = (param, options, signal)=>{
    let { organization, project, application, environment } = param;
    return mutator({
        url: "/v2/pipeline/audit-log/environment/".concat(encodeURIComponent(String(organization)), "/").concat(encodeURIComponent(String(project)), "/").concat(encodeURIComponent(String(application)), "/").concat(encodeURIComponent(String(environment)), "/authors"),
        method: 'GET',
        signal
    }, options);
};
const getGetEnvironmentAuthorsInfiniteQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        'infinite',
        "/v2/pipeline/audit-log/environment/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/authors")
    ];
};
const getGetEnvironmentAuthorsQueryKey = (param)=>{
    let { organization, project, application, environment } = param;
    return [
        "/v2/pipeline/audit-log/environment/".concat(organization, "/").concat(project, "/").concat(application, "/").concat(environment, "/authors")
    ];
};
const getGetEnvironmentAuthorsInfiniteQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentAuthorsInfiniteQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentAuthors({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentAuthorsInfinite(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentAuthorsInfiniteQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentAuthorsQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentAuthorsQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentAuthors({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!(organization && project && application && environment)
    }, queryOptions);
};
function useGetEnvironmentAuthors(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentAuthorsQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEnvironmentAuthorsSuspenseQueryOptions = (param, options)=>{
    let { organization, project, application, environment } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEnvironmentAuthorsQueryKey({
        organization,
        project,
        application,
        environment
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEnvironmentAuthors({
            organization,
            project,
            application,
            environment
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEnvironmentAuthorsSuspense(param, options, queryClient) {
    let { organization, project, application, environment } = param;
    const queryOptions = getGetEnvironmentAuthorsSuspenseQueryOptions({
        organization,
        project,
        application,
        environment
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_updatePeople = (param, updatePeople, options, signal)=>{
    let { organizationId, peopleId } = param;
    return mutator({
        url: "/v2/people/".concat(encodeURIComponent(String(organizationId)), "/").concat(encodeURIComponent(String(peopleId))),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updatePeople,
        signal
    }, options);
};
const getUpdatePeopleMutationOptions = (options)=>{
    const mutationKey = [
        'updatePeople'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return zephyr_updatePeople(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdatePeople = (options, queryClient)=>useMutation(getUpdatePeopleMutationOptions(options), queryClient);
const deletePeople = (param, options, signal)=>{
    let { organizationId, peopleId } = param;
    return mutator({
        url: "/v2/people/".concat(encodeURIComponent(String(organizationId)), "/").concat(encodeURIComponent(String(peopleId))),
        method: 'DELETE',
        signal
    }, options);
};
const getDeletePeopleMutationOptions = (options)=>{
    const mutationKey = [
        'deletePeople'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return deletePeople(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useDeletePeople = (options, queryClient)=>useMutation(getDeletePeopleMutationOptions(options), queryClient);
const invitePeople = (param, newPeople, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organizationName)), "/invite"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: newPeople,
        signal
    }, options);
};
const getInvitePeopleMutationOptions = (options)=>{
    const mutationKey = [
        'invitePeople'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return invitePeople(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useInvitePeople = (options, queryClient)=>useMutation(getInvitePeopleMutationOptions(options), queryClient);
const getPeopleList = (param, params, options, signal)=>{
    let { organizationName } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organizationName)), "/people-list"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetPeopleListInfiniteQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organizationName, "/people-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetPeopleListQueryKey = (param, params)=>{
    let { organizationName } = param;
    return [
        "/v2/organization/".concat(organizationName, "/people-list"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetPeopleListInfiniteQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetPeopleListInfiniteQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getPeopleList({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetPeopleListInfinite(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetPeopleListInfiniteQueryOptions({
        organizationName
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetPeopleListQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetPeopleListQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getPeopleList({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organizationName
    }, queryOptions);
};
function useGetPeopleList(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetPeopleListQueryOptions({
        organizationName
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetPeopleListSuspenseQueryOptions = (param, params, options)=>{
    let { organizationName } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetPeopleListQueryKey({
        organizationName
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getPeopleList({
            organizationName
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetPeopleListSuspense(param, params, options, queryClient) {
    let { organizationName } = param;
    const queryOptions = getGetPeopleListSuspenseQueryOptions({
        organizationName
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const validateAuthToken = (options, signal)=>mutator({
        url: "/v2/validate-authn-token",
        method: 'GET',
        signal
    }, options);
const getValidateAuthTokenInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/validate-authn-token"
    ];
const getValidateAuthTokenQueryKey = ()=>[
        "/v2/validate-authn-token"
    ];
const getValidateAuthTokenInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getValidateAuthTokenInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return validateAuthToken(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useValidateAuthTokenInfinite(options, queryClient) {
    const queryOptions = getValidateAuthTokenInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getValidateAuthTokenQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getValidateAuthTokenQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return validateAuthToken(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useValidateAuthToken(options, queryClient) {
    const queryOptions = getValidateAuthTokenQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getValidateAuthTokenSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getValidateAuthTokenQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return validateAuthToken(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useValidateAuthTokenSuspense(options, queryClient) {
    const queryOptions = getValidateAuthTokenSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const authLogin = (params, options, signal)=>mutator({
        url: "/v2/auth/login",
        method: 'GET',
        params,
        signal
    }, options);
const getAuthLoginInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/auth/login",
        ...params ? [
            params
        ] : []
    ];
const getAuthLoginQueryKey = (params)=>[
        "/v2/auth/login",
        ...params ? [
            params
        ] : []
    ];
const getAuthLoginInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getAuthLoginInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return authLogin(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useAuthLoginInfinite(params, options, queryClient) {
    const queryOptions = getAuthLoginInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAuthLoginQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getAuthLoginQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return authLogin(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useAuthLogin(params, options, queryClient) {
    const queryOptions = getAuthLoginQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAuthLoginSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getAuthLoginQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return authLogin(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useAuthLoginSuspense(params, options, queryClient) {
    const queryOptions = getAuthLoginSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAuthorizeLink = (params, options, signal)=>mutator({
        url: "/v2/authorize-link",
        method: 'GET',
        params,
        signal
    }, options);
const getGetAuthorizeLinkInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/authorize-link",
        ...params ? [
            params
        ] : []
    ];
const getGetAuthorizeLinkQueryKey = (params)=>[
        "/v2/authorize-link",
        ...params ? [
            params
        ] : []
    ];
const getGetAuthorizeLinkInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAuthorizeLinkInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAuthorizeLink(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAuthorizeLinkInfinite(params, options, queryClient) {
    const queryOptions = getGetAuthorizeLinkInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAuthorizeLinkQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAuthorizeLinkQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAuthorizeLink(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAuthorizeLink(params, options, queryClient) {
    const queryOptions = getGetAuthorizeLinkQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAuthorizeLinkSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAuthorizeLinkQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAuthorizeLink(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAuthorizeLinkSuspense(params, options, queryClient) {
    const queryOptions = getGetAuthorizeLinkSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAuthorizeWithUserInfo = (params, options, signal)=>mutator({
        url: "/v2/authorize-with-user-info",
        method: 'GET',
        params,
        signal
    }, options);
const getGetAuthorizeWithUserInfoInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/authorize-with-user-info",
        ...params ? [
            params
        ] : []
    ];
const getGetAuthorizeWithUserInfoQueryKey = (params)=>[
        "/v2/authorize-with-user-info",
        ...params ? [
            params
        ] : []
    ];
const getGetAuthorizeWithUserInfoInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAuthorizeWithUserInfoInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAuthorizeWithUserInfo(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAuthorizeWithUserInfoInfinite(params, options, queryClient) {
    const queryOptions = getGetAuthorizeWithUserInfoInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAuthorizeWithUserInfoQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAuthorizeWithUserInfoQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAuthorizeWithUserInfo(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAuthorizeWithUserInfo(params, options, queryClient) {
    const queryOptions = getGetAuthorizeWithUserInfoQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetAuthorizeWithUserInfoSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetAuthorizeWithUserInfoQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getAuthorizeWithUserInfo(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetAuthorizeWithUserInfoSuspense(params, options, queryClient) {
    const queryOptions = getGetAuthorizeWithUserInfoSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const authorizeCallback = (params, options, signal)=>mutator({
        url: "/v2/authorize",
        method: 'GET',
        params,
        signal
    }, options);
const getAuthorizeCallbackInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/authorize",
        ...params ? [
            params
        ] : []
    ];
const getAuthorizeCallbackQueryKey = (params)=>[
        "/v2/authorize",
        ...params ? [
            params
        ] : []
    ];
const getAuthorizeCallbackInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getAuthorizeCallbackInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return authorizeCallback(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useAuthorizeCallbackInfinite(params, options, queryClient) {
    const queryOptions = getAuthorizeCallbackInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAuthorizeCallbackQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getAuthorizeCallbackQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return authorizeCallback(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useAuthorizeCallback(params, options, queryClient) {
    const queryOptions = getAuthorizeCallbackQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getAuthorizeCallbackSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getAuthorizeCallbackQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return authorizeCallback(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useAuthorizeCallbackSuspense(params, options, queryClient) {
    const queryOptions = getAuthorizeCallbackSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEmailPreferences = (options, signal)=>mutator({
        url: "/email/preferences",
        method: 'GET',
        signal
    }, options);
const getGetEmailPreferencesInfiniteQueryKey = ()=>[
        'infinite',
        "/email/preferences"
    ];
const getGetEmailPreferencesQueryKey = ()=>[
        "/email/preferences"
    ];
const getGetEmailPreferencesInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEmailPreferencesInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getEmailPreferences(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEmailPreferencesInfinite(options, queryClient) {
    const queryOptions = getGetEmailPreferencesInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEmailPreferencesQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEmailPreferencesQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getEmailPreferences(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEmailPreferences(options, queryClient) {
    const queryOptions = getGetEmailPreferencesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEmailPreferencesSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEmailPreferencesQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getEmailPreferences(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEmailPreferencesSuspense(options, queryClient) {
    const queryOptions = getGetEmailPreferencesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const zephyr_updateEmailPreferences = (updateEmailPreferences, options, signal)=>mutator({
        url: "/email/preferences",
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateEmailPreferences,
        signal
    }, options);
const getUpdateEmailPreferencesMutationOptions = (options)=>{
    const mutationKey = [
        'updateEmailPreferences'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return zephyr_updateEmailPreferences(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUpdateEmailPreferences = (options, queryClient)=>useMutation(getUpdateEmailPreferencesMutationOptions(options), queryClient);
const checkDomain = (params, options, signal)=>mutator({
        url: "/dns/check",
        method: 'GET',
        params,
        signal
    }, options);
const getCheckDomainInfiniteQueryKey = (params)=>[
        'infinite',
        "/dns/check",
        ...params ? [
            params
        ] : []
    ];
const getCheckDomainQueryKey = (params)=>[
        "/dns/check",
        ...params ? [
            params
        ] : []
    ];
const getCheckDomainInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCheckDomainInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return checkDomain(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCheckDomainInfinite(params, options, queryClient) {
    const queryOptions = getCheckDomainInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCheckDomainQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCheckDomainQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return checkDomain(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCheckDomain(params, options, queryClient) {
    const queryOptions = getCheckDomainQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getCheckDomainSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getCheckDomainQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return checkDomain(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useCheckDomainSuspense(params, options, queryClient) {
    const queryOptions = getCheckDomainSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEntriConfig = (param, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/entri/config"),
        method: 'GET',
        signal
    }, options);
};
const getGetEntriConfigInfiniteQueryKey = (param)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/deployment-integration/entri/config")
    ];
};
const getGetEntriConfigQueryKey = (param)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/deployment-integration/entri/config")
    ];
};
const getGetEntriConfigInfiniteQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriConfigInfiniteQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriConfig({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEntriConfigInfinite(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriConfigInfiniteQueryOptions({
        organization
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEntriConfigQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriConfigQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriConfig({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEntriConfig(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriConfigQueryOptions({
        organization
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEntriConfigSuspenseQueryOptions = (param, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriConfigQueryKey({
        organization
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriConfig({
            organization
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEntriConfigSuspense(param, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriConfigSuspenseQueryOptions({
        organization
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEntriConnectUrl = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/entri/connect-url"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetEntriConnectUrlInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/deployment-integration/entri/connect-url"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEntriConnectUrlQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/deployment-integration/entri/connect-url"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEntriConnectUrlInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriConnectUrlInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriConnectUrl({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEntriConnectUrlInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriConnectUrlInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEntriConnectUrlQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriConnectUrlQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriConnectUrl({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEntriConnectUrl(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriConnectUrlQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEntriConnectUrlSuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriConnectUrlQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriConnectUrl({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEntriConnectUrlSuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriConnectUrlSuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getEntriDomainEligibility = (param, params, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/entri/domain-eligibility"),
        method: 'GET',
        params,
        signal
    }, options);
};
const getGetEntriDomainEligibilityInfiniteQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        'infinite',
        "/v2/organization/".concat(organization, "/deployment-integration/entri/domain-eligibility"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEntriDomainEligibilityQueryKey = (param, params)=>{
    let { organization } = param;
    return [
        "/v2/organization/".concat(organization, "/deployment-integration/entri/domain-eligibility"),
        ...params ? [
            params
        ] : []
    ];
};
const getGetEntriDomainEligibilityInfiniteQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriDomainEligibilityInfiniteQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriDomainEligibility({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEntriDomainEligibilityInfinite(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriDomainEligibilityInfiniteQueryOptions({
        organization
    }, params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEntriDomainEligibilityQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriDomainEligibilityQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriDomainEligibility({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!organization
    }, queryOptions);
};
function useGetEntriDomainEligibility(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriDomainEligibilityQueryOptions({
        organization
    }, params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetEntriDomainEligibilitySuspenseQueryOptions = (param, params, options)=>{
    let { organization } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetEntriDomainEligibilityQueryKey({
        organization
    }, params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getEntriDomainEligibility({
            organization
        }, params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetEntriDomainEligibilitySuspense(param, params, options, queryClient) {
    let { organization } = param;
    const queryOptions = getGetEntriDomainEligibilitySuspenseQueryOptions({
        organization
    }, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const entriPowerDomain = (param, entriPowerDomainRequest, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/entri/power-domain"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: entriPowerDomainRequest,
        signal
    }, options);
};
const getEntriPowerDomainMutationOptions = (options)=>{
    const mutationKey = [
        'entriPowerDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return entriPowerDomain(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useEntriPowerDomain = (options, queryClient)=>useMutation(getEntriPowerDomainMutationOptions(options), queryClient);
const entriUpdatePoweredDomain = (param, entriPowerDomainRequest, options, signal)=>{
    let { organization } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/entri/update-powered-domain"),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: entriPowerDomainRequest,
        signal
    }, options);
};
const getEntriUpdatePoweredDomainMutationOptions = (options)=>{
    const mutationKey = [
        'entriUpdatePoweredDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, data } = props !== null && props !== void 0 ? props : {};
        return entriUpdatePoweredDomain(pathParams, data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useEntriUpdatePoweredDomain = (options, queryClient)=>useMutation(getEntriUpdatePoweredDomainMutationOptions(options), queryClient);
const entriRemovePoweredDomain = (param, options, signal)=>{
    let { organization, domain } = param;
    return mutator({
        url: "/v2/organization/".concat(encodeURIComponent(String(organization)), "/deployment-integration/entri/power-domain/").concat(encodeURIComponent(String(domain))),
        method: 'DELETE',
        signal
    }, options);
};
const getEntriRemovePoweredDomainMutationOptions = (options)=>{
    const mutationKey = [
        'entriRemovePoweredDomain'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return entriRemovePoweredDomain(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useEntriRemovePoweredDomain = (options, queryClient)=>useMutation(getEntriRemovePoweredDomainMutationOptions(options), queryClient);
const getWorkerVersionList = (options, signal)=>mutator({
        url: "/v2/worker-version/list",
        method: 'GET',
        signal
    }, options);
const getGetWorkerVersionListInfiniteQueryKey = ()=>[
        'infinite',
        "/v2/worker-version/list"
    ];
const getGetWorkerVersionListQueryKey = ()=>[
        "/v2/worker-version/list"
    ];
const getGetWorkerVersionListInfiniteQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetWorkerVersionListInfiniteQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getWorkerVersionList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetWorkerVersionListInfinite(options, queryClient) {
    const queryOptions = getGetWorkerVersionListInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetWorkerVersionListQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetWorkerVersionListQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getWorkerVersionList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetWorkerVersionList(options, queryClient) {
    const queryOptions = getGetWorkerVersionListQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetWorkerVersionListSuspenseQueryOptions = (options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetWorkerVersionListQueryKey();
    const queryFn = (param)=>{
        let { signal } = param;
        return getWorkerVersionList(requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetWorkerVersionListSuspense(options, queryClient) {
    const queryOptions = getGetWorkerVersionListSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getFdr = (param, options, signal)=>{
    let { appUid } = param;
    return mutator({
        url: "/fdr/".concat(encodeURIComponent(String(appUid))),
        method: 'GET',
        signal
    }, options);
};
const getGetFdrInfiniteQueryKey = (param)=>{
    let { appUid } = param;
    return [
        'infinite',
        "/fdr/".concat(appUid)
    ];
};
const getGetFdrQueryKey = (param)=>{
    let { appUid } = param;
    return [
        "/fdr/".concat(appUid)
    ];
};
const getGetFdrInfiniteQueryOptions = (param, options)=>{
    let { appUid } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetFdrInfiniteQueryKey({
        appUid
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getFdr({
            appUid
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!appUid
    }, queryOptions);
};
function useGetFdrInfinite(param, options, queryClient) {
    let { appUid } = param;
    const queryOptions = getGetFdrInfiniteQueryOptions({
        appUid
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetFdrQueryOptions = (param, options)=>{
    let { appUid } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetFdrQueryKey({
        appUid
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getFdr({
            appUid
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!appUid
    }, queryOptions);
};
function useGetFdr(param, options, queryClient) {
    let { appUid } = param;
    const queryOptions = getGetFdrQueryOptions({
        appUid
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetFdrSuspenseQueryOptions = (param, options)=>{
    let { appUid } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetFdrQueryKey({
        appUid
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getFdr({
            appUid
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetFdrSuspense(param, options, queryClient) {
    let { appUid } = param;
    const queryOptions = getGetFdrSuspenseQueryOptions({
        appUid
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const resolveDependency = (params, options, signal)=>mutator({
        url: "/v2/builder-public-api/resolve",
        method: 'GET',
        params,
        signal
    }, options);
const getResolveDependencyInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/builder-public-api/resolve",
        ...params ? [
            params
        ] : []
    ];
const getResolveDependencyQueryKey = (params)=>[
        "/v2/builder-public-api/resolve",
        ...params ? [
            params
        ] : []
    ];
const getResolveDependencyInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getResolveDependencyInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return resolveDependency(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useResolveDependencyInfinite(params, options, queryClient) {
    const queryOptions = getResolveDependencyInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getResolveDependencyQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getResolveDependencyQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return resolveDependency(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useResolveDependency(params, options, queryClient) {
    const queryOptions = getResolveDependencyQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getResolveDependencySuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getResolveDependencyQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return resolveDependency(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useResolveDependencySuspense(params, options, queryClient) {
    const queryOptions = getResolveDependencySuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationConfig = (params, options, signal)=>mutator({
        url: "/v2/builder-packages-api/application-config",
        method: 'GET',
        params,
        signal
    }, options);
const getGetApplicationConfigInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/builder-packages-api/application-config",
        ...params ? [
            params
        ] : []
    ];
const getGetApplicationConfigQueryKey = (params)=>[
        "/v2/builder-packages-api/application-config",
        ...params ? [
            params
        ] : []
    ];
const getGetApplicationConfigInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConfigInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConfig(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationConfigInfinite(params, options, queryClient) {
    const queryOptions = getGetApplicationConfigInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationConfigQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConfigQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConfig(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationConfig(params, options, queryClient) {
    const queryOptions = getGetApplicationConfigQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationConfigSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConfigQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConfig(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationConfigSuspense(params, options, queryClient) {
    const queryOptions = getGetApplicationConfigSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getApplicationConfigs = (params, options, signal)=>mutator({
        url: "/v2/builder-packages-api/application-configs",
        method: 'GET',
        params,
        signal
    }, options);
const getGetApplicationConfigsInfiniteQueryKey = (params)=>[
        'infinite',
        "/v2/builder-packages-api/application-configs",
        ...params ? [
            params
        ] : []
    ];
const getGetApplicationConfigsQueryKey = (params)=>[
        "/v2/builder-packages-api/application-configs",
        ...params ? [
            params
        ] : []
    ];
const getGetApplicationConfigsInfiniteQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConfigsInfiniteQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConfigs(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationConfigsInfinite(params, options, queryClient) {
    const queryOptions = getGetApplicationConfigsInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationConfigsQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConfigsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConfigs(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationConfigs(params, options, queryClient) {
    const queryOptions = getGetApplicationConfigsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetApplicationConfigsSuspenseQueryOptions = (params, options)=>{
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetApplicationConfigsQueryKey(params);
    const queryFn = (param)=>{
        let { signal } = param;
        return getApplicationConfigs(params, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetApplicationConfigsSuspense(params, options, queryClient) {
    const queryOptions = getGetApplicationConfigsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getDeployedTags = (param, options, signal)=>{
    let { applicationUid } = param;
    return mutator({
        url: "/v2/builder-packages-api/deployed-tags/".concat(encodeURIComponent(String(applicationUid))),
        method: 'GET',
        signal
    }, options);
};
const getGetDeployedTagsInfiniteQueryKey = (param)=>{
    let { applicationUid } = param;
    return [
        'infinite',
        "/v2/builder-packages-api/deployed-tags/".concat(applicationUid)
    ];
};
const getGetDeployedTagsQueryKey = (param)=>{
    let { applicationUid } = param;
    return [
        "/v2/builder-packages-api/deployed-tags/".concat(applicationUid)
    ];
};
const getGetDeployedTagsInfiniteQueryOptions = (param, options)=>{
    let { applicationUid } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployedTagsInfiniteQueryKey({
        applicationUid
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployedTags({
            applicationUid
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!applicationUid
    }, queryOptions);
};
function useGetDeployedTagsInfinite(param, options, queryClient) {
    let { applicationUid } = param;
    const queryOptions = getGetDeployedTagsInfiniteQueryOptions({
        applicationUid
    }, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployedTagsQueryOptions = (param, options)=>{
    let { applicationUid } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployedTagsQueryKey({
        applicationUid
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployedTags({
            applicationUid
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn,
        enabled: !!applicationUid
    }, queryOptions);
};
function useGetDeployedTags(param, options, queryClient) {
    let { applicationUid } = param;
    const queryOptions = getGetDeployedTagsQueryOptions({
        applicationUid
    }, options);
    const query = useQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const getGetDeployedTagsSuspenseQueryOptions = (param, options)=>{
    let { applicationUid } = param;
    var _ref;
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _ref !== void 0 ? _ref : getGetDeployedTagsQueryKey({
        applicationUid
    });
    const queryFn = (param)=>{
        let { signal } = param;
        return getDeployedTags({
            applicationUid
        }, requestOptions, signal);
    };
    return _object_spread({
        queryKey,
        queryFn
    }, queryOptions);
};
function useGetDeployedTagsSuspense(param, options, queryClient) {
    let { applicationUid } = param;
    const queryOptions = getGetDeployedTagsSuspenseQueryOptions({
        applicationUid
    }, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return _object_spread_props(_object_spread({}, query), {
        queryKey: queryOptions.queryKey
    });
}
const cleanupTests = (param, options, signal)=>{
    let { applicationUid } = param;
    return mutator({
        url: "/v2/builder-packages-api/cleanup-tests/".concat(encodeURIComponent(String(applicationUid))),
        method: 'POST',
        signal
    }, options);
};
const getCleanupTestsMutationOptions = (options)=>{
    const mutationKey = [
        'cleanupTests'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams } = props !== null && props !== void 0 ? props : {};
        return cleanupTests(pathParams, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useCleanupTests = (options, queryClient)=>useMutation(getCleanupTestsMutationOptions(options), queryClient);
const seedTestVersions = (seedTestVersionsBody, options, signal)=>mutator({
        url: "/v2/builder-packages-api/seed-test-versions",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: seedTestVersionsBody,
        signal
    }, options);
const getSeedTestVersionsMutationOptions = (options)=>{
    const mutationKey = [
        'seedTestVersions'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return seedTestVersions(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useSeedTestVersions = (options, queryClient)=>useMutation(getSeedTestVersionsMutationOptions(options), queryClient);
const markVersionAsFailed = (param, params, options, signal)=>{
    let { snapshotId } = param;
    return mutator({
        url: "/v2/builder-packages-api/mark-as-failed/".concat(encodeURIComponent(String(snapshotId))),
        method: 'POST',
        params,
        signal
    }, options);
};
const getMarkVersionAsFailedMutationOptions = (options)=>{
    const mutationKey = [
        'markVersionAsFailed'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, params } = props !== null && props !== void 0 ? props : {};
        return markVersionAsFailed(pathParams, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useMarkVersionAsFailed = (options, queryClient)=>useMutation(getMarkVersionAsFailedMutationOptions(options), queryClient);
const markVersionAsUnavailable = (param, params, options, signal)=>{
    let { snapshotId } = param;
    return mutator({
        url: "/v2/builder-packages-api/mark-as-unavailable/".concat(encodeURIComponent(String(snapshotId))),
        method: 'POST',
        params,
        signal
    }, options);
};
const getMarkVersionAsUnavailableMutationOptions = (options)=>{
    const mutationKey = [
        'markVersionAsUnavailable'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, params } = props !== null && props !== void 0 ? props : {};
        return markVersionAsUnavailable(pathParams, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useMarkVersionAsUnavailable = (options, queryClient)=>useMutation(getMarkVersionAsUnavailableMutationOptions(options), queryClient);
const markVersionAsDeprecated = (param, params, options, signal)=>{
    let { snapshotId } = param;
    return mutator({
        url: "/v2/builder-packages-api/mark-as-deprecated/".concat(encodeURIComponent(String(snapshotId))),
        method: 'POST',
        params,
        signal
    }, options);
};
const getMarkVersionAsDeprecatedMutationOptions = (options)=>{
    const mutationKey = [
        'markVersionAsDeprecated'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { pathParams, params } = props !== null && props !== void 0 ? props : {};
        return markVersionAsDeprecated(pathParams, params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useMarkVersionAsDeprecated = (options, queryClient)=>useMutation(getMarkVersionAsDeprecatedMutationOptions(options), queryClient);
const markDeployFailed = (params, options, signal)=>mutator({
        url: "/v2/builder-packages-api/mark-deploy-failed",
        method: 'POST',
        params,
        signal
    }, options);
const getMarkDeployFailedMutationOptions = (options)=>{
    const mutationKey = [
        'markDeployFailed'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { params } = props !== null && props !== void 0 ? props : {};
        return markDeployFailed(params, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useMarkDeployFailed = (options, queryClient)=>useMutation(getMarkDeployFailedMutationOptions(options), queryClient);
const uploadFromDashboardPlugin = (uploadFromDashboardPluginBody, options, signal)=>mutator({
        url: "/v2/builder-packages-api/upload-from-dashboard-plugin",
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: uploadFromDashboardPluginBody,
        signal
    }, options);
const getUploadFromDashboardPluginMutationOptions = (options)=>{
    const mutationKey = [
        'uploadFromDashboardPlugin'
    ];
    const { mutation: mutationOptions, request: requestOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : _object_spread_props(_object_spread({}, options), {
        mutation: _object_spread_props(_object_spread({}, options.mutation), {
            mutationKey
        })
    }) : {
        mutation: {
            mutationKey
        },
        request: void 0
    };
    const mutationFn = (props)=>{
        const { data } = props !== null && props !== void 0 ? props : {};
        return uploadFromDashboardPlugin(data, requestOptions);
    };
    return _object_spread({
        mutationFn
    }, mutationOptions);
};
const useUploadFromDashboardPlugin = (options, queryClient)=>useMutation(getUploadFromDashboardPluginMutationOptions(options), queryClient);
export { _delete, acceptChildOrganizationInvite, addEnvironmentCustomDomain, addEnvironmentMembers, addIntegrationToEnvironment, addProjectContributors, zephyr_addTeamMembers as addTeamMembers, advanceSubscriptionSchedule, attachPaymentMethod, authLogin, authorizeCallback, cancelSubscriptionSchedule, changeOrganizationDeploymentIntegrationName, zephyr_changePassword as changePassword, changeSubscription, checkCanJoinAsChild, checkDevopsFeature, checkDomain, cleanupTests, cliTest, create, createApplication, createApplicationEnvironment, createApplicationTag, createMultiCdn, zephyr_createOrganization as createOrganization, createProject, createReleaseCandidate, createServerAuthToken, zephyr_createTeam as createTeam, deactivateCurrentUser, deactivateUserAccount, deleteApplicationEnvironment, deleteApplicationSingular, deleteApplicationTag, deleteInviteChildOrganization, deleteOrganization, deleteOrganizationMembershipDomain, deletePeople, deleteProject, deleteProjectById, deleteReleaseCandidate, deleteServerAuthToken, deleteTeam, deleteUserAuthToken, deployApplicationVersion, deploySidePanelVersion, deployTagToEnvironment, deployVersion, detachPaymentMethod, editUserAuthToken, entriPowerDomain, entriRemovePoweredDomain, entriUpdatePoweredDomain, generateUserAuthToken, getAcceptChildOrganizationInviteMutationOptions, getAccountsAssociated, getAddEnvironmentCustomDomainMutationOptions, getAddEnvironmentMemberOptions, getAddEnvironmentMembersMutationOptions, getAddIntegrationToEnvironmentMutationOptions, getAddProjectContributorsMutationOptions, getAddTeamMembersMutationOptions, getAdvanceSubscriptionScheduleMutationOptions, getAppNavigationItems, getApplication, getApplicationActivityOverTime, getApplicationAuditLog, getApplicationAuditLogAuthors, getApplicationConfig, getApplicationConfigs, getApplicationConsumers, getApplicationContributors, getApplicationContributorsWithVersionCount, getApplicationCounters, getApplicationEnvironment, getApplicationGraph, getApplicationIntegrationList, getApplicationListByProject, getApplicationModule, getApplicationOverview, getApplicationSettings, getApplicationSidebarList, getApplicationSummary, getApplicationTag, getApplicationTagConditionOptions, getApplicationTagConditionOptionsUsers, getApplicationTagConditionOptionsVersions, getApplicationTagConditionVersion, getApplicationTagQueryOpts, getApplicationUmlSidebar, getApplicationVersionDeployTargetList, getApplicationVersionDetail, getApplicationVersionList, getApplicationVersionQueryOpts, getAttachPaymentMethodMutationOptions, getAuthLoginInfiniteQueryKey, getAuthLoginInfiniteQueryOptions, getAuthLoginQueryKey, getAuthLoginQueryOptions, getAuthLoginSuspenseQueryOptions, getAuthorizeCallbackInfiniteQueryKey, getAuthorizeCallbackInfiniteQueryOptions, getAuthorizeCallbackQueryKey, getAuthorizeCallbackQueryOptions, getAuthorizeCallbackSuspenseQueryOptions, getAuthorizeLink, getAuthorizeWithUserInfo, getBuildVersionDetail, getBuildVersionList, getCancelSubscriptionScheduleMutationOptions, getChangeOrganizationDeploymentIntegrationNameMutationOptions, getChangePasswordMutationOptions, getChangeSubscriptionMutationOptions, getCheckCanJoinAsChildMutationOptions, getCheckDevopsFeatureInfiniteQueryKey, getCheckDevopsFeatureInfiniteQueryOptions, getCheckDevopsFeatureQueryKey, getCheckDevopsFeatureQueryOptions, getCheckDevopsFeatureSuspenseQueryOptions, getCheckDomainInfiniteQueryKey, getCheckDomainInfiniteQueryOptions, getCheckDomainQueryKey, getCheckDomainQueryOptions, getCheckDomainSuspenseQueryOptions, getCleanupTestsMutationOptions, getCliTestInfiniteQueryKey, getCliTestInfiniteQueryOptions, getCliTestQueryKey, getCliTestQueryOptions, getCliTestSuspenseQueryOptions, getCoupon, getCreateApplicationEnvironmentMutationOptions, getCreateApplicationMutationOptions, getCreateApplicationTagMutationOptions, getCreateMultiCdnMutationOptions, getCreateMutationOptions, getCreateOrganizationMutationOptions, getCreateProjectMutationOptions, getCreateReleaseCandidateMutationOptions, getCreateServerAuthTokenMutationOptions, getCreateTeamMutationOptions, getCurrentUser, getCurrentUserOrganizationList, getCurrentUserProfile, getDeactivateCurrentUserMutationOptions, getDeactivateUserAccountMutationOptions, getDefaultPaymentMethod, getDeleteApplicationEnvironmentMutationOptions, getDeleteApplicationSingularMutationOptions, getDeleteApplicationTagMutationOptions, getDeleteInviteChildOrganizationMutationOptions, getDeleteMutationOptions, getDeleteOrganizationMembershipDomainMutationOptions, getDeleteOrganizationMutationOptions, getDeletePeopleMutationOptions, getDeleteProjectByIdMutationOptions, getDeleteProjectMutationOptions, getDeleteReleaseCandidateMutationOptions, getDeleteServerAuthTokenMutationOptions, getDeleteTeamMutationOptions, getDeleteUserAuthTokenMutationOptions, getDeployApplicationVersionList, getDeployApplicationVersionMutationOptions, getDeploySidePanelVersionMutationOptions, getDeployTagToEnvironmentMutationOptions, getDeployTargets, getDeployVersionMutationOptions, getDeployedTags, getDeployedVersions, getDeploymentIntegration, getDeploymentStatus, getDetachPaymentMethodMutationOptions, getEditUserAuthTokenMutationOptions, getEmailPreferences, getEnabledList, getEntriConfig, getEntriConnectUrl, getEntriDomainEligibility, getEntriPowerDomainMutationOptions, getEntriRemovePoweredDomainMutationOptions, getEntriUpdatePoweredDomainMutationOptions, getEnvironmentAuditLog, getEnvironmentAuthors, getEnvironmentConditionOptions, getEnvironmentConditionVersion, getEnvironmentDependencies, getEnvironmentDeploymentIntegrationList, getEnvironmentDeploymentLog, getEnvironmentEnvVarSet, getEnvironmentIntegrations, getEnvironmentList, getEnvironmentMembers, getFdr, getGenerateUserAuthTokenMutationOptions, getGetAccountsAssociatedInfiniteQueryKey, getGetAccountsAssociatedInfiniteQueryOptions, getGetAccountsAssociatedQueryKey, getGetAccountsAssociatedQueryOptions, getGetAccountsAssociatedSuspenseQueryOptions, getGetAddEnvironmentMemberOptionsInfiniteQueryKey, getGetAddEnvironmentMemberOptionsInfiniteQueryOptions, getGetAddEnvironmentMemberOptionsQueryKey, getGetAddEnvironmentMemberOptionsQueryOptions, getGetAddEnvironmentMemberOptionsSuspenseQueryOptions, getGetAppNavigationItemsInfiniteQueryKey, getGetAppNavigationItemsInfiniteQueryOptions, getGetAppNavigationItemsQueryKey, getGetAppNavigationItemsQueryOptions, getGetAppNavigationItemsSuspenseQueryOptions, getGetApplicationActivityOverTimeInfiniteQueryKey, getGetApplicationActivityOverTimeInfiniteQueryOptions, getGetApplicationActivityOverTimeQueryKey, getGetApplicationActivityOverTimeQueryOptions, getGetApplicationActivityOverTimeSuspenseQueryOptions, getGetApplicationAuditLogAuthorsInfiniteQueryKey, getGetApplicationAuditLogAuthorsInfiniteQueryOptions, getGetApplicationAuditLogAuthorsQueryKey, getGetApplicationAuditLogAuthorsQueryOptions, getGetApplicationAuditLogAuthorsSuspenseQueryOptions, getGetApplicationAuditLogInfiniteQueryKey, getGetApplicationAuditLogInfiniteQueryOptions, getGetApplicationAuditLogQueryKey, getGetApplicationAuditLogQueryOptions, getGetApplicationAuditLogSuspenseQueryOptions, getGetApplicationConfigInfiniteQueryKey, getGetApplicationConfigInfiniteQueryOptions, getGetApplicationConfigQueryKey, getGetApplicationConfigQueryOptions, getGetApplicationConfigSuspenseQueryOptions, getGetApplicationConfigsInfiniteQueryKey, getGetApplicationConfigsInfiniteQueryOptions, getGetApplicationConfigsQueryKey, getGetApplicationConfigsQueryOptions, getGetApplicationConfigsSuspenseQueryOptions, getGetApplicationConsumersInfiniteQueryKey, getGetApplicationConsumersInfiniteQueryOptions, getGetApplicationConsumersQueryKey, getGetApplicationConsumersQueryOptions, getGetApplicationConsumersSuspenseQueryOptions, getGetApplicationContributorsInfiniteQueryKey, getGetApplicationContributorsInfiniteQueryOptions, getGetApplicationContributorsQueryKey, getGetApplicationContributorsQueryOptions, getGetApplicationContributorsSuspenseQueryOptions, getGetApplicationContributorsWithVersionCountInfiniteQueryKey, getGetApplicationContributorsWithVersionCountInfiniteQueryOptions, getGetApplicationContributorsWithVersionCountQueryKey, getGetApplicationContributorsWithVersionCountQueryOptions, getGetApplicationContributorsWithVersionCountSuspenseQueryOptions, getGetApplicationCountersInfiniteQueryKey, getGetApplicationCountersInfiniteQueryOptions, getGetApplicationCountersQueryKey, getGetApplicationCountersQueryOptions, getGetApplicationCountersSuspenseQueryOptions, getGetApplicationEnvironmentInfiniteQueryKey, getGetApplicationEnvironmentInfiniteQueryOptions, getGetApplicationEnvironmentQueryKey, getGetApplicationEnvironmentQueryOptions, getGetApplicationEnvironmentSuspenseQueryOptions, getGetApplicationGraphInfiniteQueryKey, getGetApplicationGraphInfiniteQueryOptions, getGetApplicationGraphQueryKey, getGetApplicationGraphQueryOptions, getGetApplicationGraphSuspenseQueryOptions, getGetApplicationInfiniteQueryKey, getGetApplicationInfiniteQueryOptions, getGetApplicationIntegrationListInfiniteQueryKey, getGetApplicationIntegrationListInfiniteQueryOptions, getGetApplicationIntegrationListQueryKey, getGetApplicationIntegrationListQueryOptions, getGetApplicationIntegrationListSuspenseQueryOptions, getGetApplicationListByProjectInfiniteQueryKey, getGetApplicationListByProjectInfiniteQueryOptions, getGetApplicationListByProjectQueryKey, getGetApplicationListByProjectQueryOptions, getGetApplicationListByProjectSuspenseQueryOptions, getGetApplicationModuleInfiniteQueryKey, getGetApplicationModuleInfiniteQueryOptions, getGetApplicationModuleQueryKey, getGetApplicationModuleQueryOptions, getGetApplicationModuleSuspenseQueryOptions, getGetApplicationOverviewInfiniteQueryKey, getGetApplicationOverviewInfiniteQueryOptions, getGetApplicationOverviewQueryKey, getGetApplicationOverviewQueryOptions, getGetApplicationOverviewSuspenseQueryOptions, getGetApplicationQueryKey, getGetApplicationQueryOptions, getGetApplicationSettingsInfiniteQueryKey, getGetApplicationSettingsInfiniteQueryOptions, getGetApplicationSettingsQueryKey, getGetApplicationSettingsQueryOptions, getGetApplicationSettingsSuspenseQueryOptions, getGetApplicationSidebarListInfiniteQueryKey, getGetApplicationSidebarListInfiniteQueryOptions, getGetApplicationSidebarListQueryKey, getGetApplicationSidebarListQueryOptions, getGetApplicationSidebarListSuspenseQueryOptions, getGetApplicationSummaryInfiniteQueryKey, getGetApplicationSummaryInfiniteQueryOptions, getGetApplicationSummaryQueryKey, getGetApplicationSummaryQueryOptions, getGetApplicationSummarySuspenseQueryOptions, getGetApplicationSuspenseQueryOptions, getGetApplicationTagConditionOptionsInfiniteQueryKey, getGetApplicationTagConditionOptionsInfiniteQueryOptions, getGetApplicationTagConditionOptionsQueryKey, getGetApplicationTagConditionOptionsQueryOptions, getGetApplicationTagConditionOptionsSuspenseQueryOptions, getGetApplicationTagConditionOptionsUsersInfiniteQueryKey, getGetApplicationTagConditionOptionsUsersInfiniteQueryOptions, getGetApplicationTagConditionOptionsUsersQueryKey, getGetApplicationTagConditionOptionsUsersQueryOptions, getGetApplicationTagConditionOptionsUsersSuspenseQueryOptions, getGetApplicationTagConditionOptionsVersionsInfiniteQueryKey, getGetApplicationTagConditionOptionsVersionsInfiniteQueryOptions, getGetApplicationTagConditionOptionsVersionsQueryKey, getGetApplicationTagConditionOptionsVersionsQueryOptions, getGetApplicationTagConditionOptionsVersionsSuspenseQueryOptions, getGetApplicationTagConditionVersionInfiniteQueryKey, getGetApplicationTagConditionVersionInfiniteQueryOptions, getGetApplicationTagConditionVersionQueryKey, getGetApplicationTagConditionVersionQueryOptions, getGetApplicationTagConditionVersionSuspenseQueryOptions, getGetApplicationTagInfiniteQueryKey, getGetApplicationTagInfiniteQueryOptions, getGetApplicationTagQueryKey, getGetApplicationTagQueryOptions, getGetApplicationTagQueryOptsInfiniteQueryKey, getGetApplicationTagQueryOptsInfiniteQueryOptions, getGetApplicationTagQueryOptsQueryKey, getGetApplicationTagQueryOptsQueryOptions, getGetApplicationTagQueryOptsSuspenseQueryOptions, getGetApplicationTagSuspenseQueryOptions, getGetApplicationUmlSidebarInfiniteQueryKey, getGetApplicationUmlSidebarInfiniteQueryOptions, getGetApplicationUmlSidebarQueryKey, getGetApplicationUmlSidebarQueryOptions, getGetApplicationUmlSidebarSuspenseQueryOptions, getGetApplicationVersionDeployTargetListInfiniteQueryKey, getGetApplicationVersionDeployTargetListInfiniteQueryOptions, getGetApplicationVersionDeployTargetListQueryKey, getGetApplicationVersionDeployTargetListQueryOptions, getGetApplicationVersionDeployTargetListSuspenseQueryOptions, getGetApplicationVersionDetailInfiniteQueryKey, getGetApplicationVersionDetailInfiniteQueryOptions, getGetApplicationVersionDetailQueryKey, getGetApplicationVersionDetailQueryOptions, getGetApplicationVersionDetailSuspenseQueryOptions, getGetApplicationVersionListInfiniteQueryKey, getGetApplicationVersionListInfiniteQueryOptions, getGetApplicationVersionListQueryKey, getGetApplicationVersionListQueryOptions, getGetApplicationVersionListSuspenseQueryOptions, getGetApplicationVersionQueryOptsInfiniteQueryKey, getGetApplicationVersionQueryOptsInfiniteQueryOptions, getGetApplicationVersionQueryOptsQueryKey, getGetApplicationVersionQueryOptsQueryOptions, getGetApplicationVersionQueryOptsSuspenseQueryOptions, getGetAuthorizeLinkInfiniteQueryKey, getGetAuthorizeLinkInfiniteQueryOptions, getGetAuthorizeLinkQueryKey, getGetAuthorizeLinkQueryOptions, getGetAuthorizeLinkSuspenseQueryOptions, getGetAuthorizeWithUserInfoInfiniteQueryKey, getGetAuthorizeWithUserInfoInfiniteQueryOptions, getGetAuthorizeWithUserInfoQueryKey, getGetAuthorizeWithUserInfoQueryOptions, getGetAuthorizeWithUserInfoSuspenseQueryOptions, getGetBuildVersionDetailInfiniteQueryKey, getGetBuildVersionDetailInfiniteQueryOptions, getGetBuildVersionDetailQueryKey, getGetBuildVersionDetailQueryOptions, getGetBuildVersionDetailSuspenseQueryOptions, getGetBuildVersionListInfiniteQueryKey, getGetBuildVersionListInfiniteQueryOptions, getGetBuildVersionListQueryKey, getGetBuildVersionListQueryOptions, getGetBuildVersionListSuspenseQueryOptions, getGetCouponInfiniteQueryKey, getGetCouponInfiniteQueryOptions, getGetCouponQueryKey, getGetCouponQueryOptions, getGetCouponSuspenseQueryOptions, getGetCurrentUserInfiniteQueryKey, getGetCurrentUserInfiniteQueryOptions, getGetCurrentUserOrganizationListInfiniteQueryKey, getGetCurrentUserOrganizationListInfiniteQueryOptions, getGetCurrentUserOrganizationListQueryKey, getGetCurrentUserOrganizationListQueryOptions, getGetCurrentUserOrganizationListSuspenseQueryOptions, getGetCurrentUserProfileInfiniteQueryKey, getGetCurrentUserProfileInfiniteQueryOptions, getGetCurrentUserProfileQueryKey, getGetCurrentUserProfileQueryOptions, getGetCurrentUserProfileSuspenseQueryOptions, getGetCurrentUserQueryKey, getGetCurrentUserQueryOptions, getGetCurrentUserSuspenseQueryOptions, getGetDefaultPaymentMethodInfiniteQueryKey, getGetDefaultPaymentMethodInfiniteQueryOptions, getGetDefaultPaymentMethodQueryKey, getGetDefaultPaymentMethodQueryOptions, getGetDefaultPaymentMethodSuspenseQueryOptions, getGetDeployApplicationVersionListInfiniteQueryKey, getGetDeployApplicationVersionListInfiniteQueryOptions, getGetDeployApplicationVersionListQueryKey, getGetDeployApplicationVersionListQueryOptions, getGetDeployApplicationVersionListSuspenseQueryOptions, getGetDeployTargetsInfiniteQueryKey, getGetDeployTargetsInfiniteQueryOptions, getGetDeployTargetsQueryKey, getGetDeployTargetsQueryOptions, getGetDeployTargetsSuspenseQueryOptions, getGetDeployedTagsInfiniteQueryKey, getGetDeployedTagsInfiniteQueryOptions, getGetDeployedTagsQueryKey, getGetDeployedTagsQueryOptions, getGetDeployedTagsSuspenseQueryOptions, getGetDeployedVersionsInfiniteQueryKey, getGetDeployedVersionsInfiniteQueryOptions, getGetDeployedVersionsQueryKey, getGetDeployedVersionsQueryOptions, getGetDeployedVersionsSuspenseQueryOptions, getGetDeploymentIntegrationInfiniteQueryKey, getGetDeploymentIntegrationInfiniteQueryOptions, getGetDeploymentIntegrationQueryKey, getGetDeploymentIntegrationQueryOptions, getGetDeploymentIntegrationSuspenseQueryOptions, getGetDeploymentStatusInfiniteQueryKey, getGetDeploymentStatusInfiniteQueryOptions, getGetDeploymentStatusQueryKey, getGetDeploymentStatusQueryOptions, getGetDeploymentStatusSuspenseQueryOptions, getGetEmailPreferencesInfiniteQueryKey, getGetEmailPreferencesInfiniteQueryOptions, getGetEmailPreferencesQueryKey, getGetEmailPreferencesQueryOptions, getGetEmailPreferencesSuspenseQueryOptions, getGetEnabledListInfiniteQueryKey, getGetEnabledListInfiniteQueryOptions, getGetEnabledListQueryKey, getGetEnabledListQueryOptions, getGetEnabledListSuspenseQueryOptions, getGetEntriConfigInfiniteQueryKey, getGetEntriConfigInfiniteQueryOptions, getGetEntriConfigQueryKey, getGetEntriConfigQueryOptions, getGetEntriConfigSuspenseQueryOptions, getGetEntriConnectUrlInfiniteQueryKey, getGetEntriConnectUrlInfiniteQueryOptions, getGetEntriConnectUrlQueryKey, getGetEntriConnectUrlQueryOptions, getGetEntriConnectUrlSuspenseQueryOptions, getGetEntriDomainEligibilityInfiniteQueryKey, getGetEntriDomainEligibilityInfiniteQueryOptions, getGetEntriDomainEligibilityQueryKey, getGetEntriDomainEligibilityQueryOptions, getGetEntriDomainEligibilitySuspenseQueryOptions, getGetEnvironmentAuditLogInfiniteQueryKey, getGetEnvironmentAuditLogInfiniteQueryOptions, getGetEnvironmentAuditLogQueryKey, getGetEnvironmentAuditLogQueryOptions, getGetEnvironmentAuditLogSuspenseQueryOptions, getGetEnvironmentAuthorsInfiniteQueryKey, getGetEnvironmentAuthorsInfiniteQueryOptions, getGetEnvironmentAuthorsQueryKey, getGetEnvironmentAuthorsQueryOptions, getGetEnvironmentAuthorsSuspenseQueryOptions, getGetEnvironmentConditionOptionsInfiniteQueryKey, getGetEnvironmentConditionOptionsInfiniteQueryOptions, getGetEnvironmentConditionOptionsQueryKey, getGetEnvironmentConditionOptionsQueryOptions, getGetEnvironmentConditionOptionsSuspenseQueryOptions, getGetEnvironmentConditionVersionInfiniteQueryKey, getGetEnvironmentConditionVersionInfiniteQueryOptions, getGetEnvironmentConditionVersionQueryKey, getGetEnvironmentConditionVersionQueryOptions, getGetEnvironmentConditionVersionSuspenseQueryOptions, getGetEnvironmentDependenciesInfiniteQueryKey, getGetEnvironmentDependenciesInfiniteQueryOptions, getGetEnvironmentDependenciesQueryKey, getGetEnvironmentDependenciesQueryOptions, getGetEnvironmentDependenciesSuspenseQueryOptions, getGetEnvironmentDeploymentIntegrationListInfiniteQueryKey, getGetEnvironmentDeploymentIntegrationListInfiniteQueryOptions, getGetEnvironmentDeploymentIntegrationListQueryKey, getGetEnvironmentDeploymentIntegrationListQueryOptions, getGetEnvironmentDeploymentIntegrationListSuspenseQueryOptions, getGetEnvironmentDeploymentLogInfiniteQueryKey, getGetEnvironmentDeploymentLogInfiniteQueryOptions, getGetEnvironmentDeploymentLogQueryKey, getGetEnvironmentDeploymentLogQueryOptions, getGetEnvironmentDeploymentLogSuspenseQueryOptions, getGetEnvironmentEnvVarSetInfiniteQueryKey, getGetEnvironmentEnvVarSetInfiniteQueryOptions, getGetEnvironmentEnvVarSetQueryKey, getGetEnvironmentEnvVarSetQueryOptions, getGetEnvironmentEnvVarSetSuspenseQueryOptions, getGetEnvironmentIntegrationsInfiniteQueryKey, getGetEnvironmentIntegrationsInfiniteQueryOptions, getGetEnvironmentIntegrationsQueryKey, getGetEnvironmentIntegrationsQueryOptions, getGetEnvironmentIntegrationsSuspenseQueryOptions, getGetEnvironmentListInfiniteQueryKey, getGetEnvironmentListInfiniteQueryOptions, getGetEnvironmentListQueryKey, getGetEnvironmentListQueryOptions, getGetEnvironmentListSuspenseQueryOptions, getGetEnvironmentMembersInfiniteQueryKey, getGetEnvironmentMembersInfiniteQueryOptions, getGetEnvironmentMembersQueryKey, getGetEnvironmentMembersQueryOptions, getGetEnvironmentMembersSuspenseQueryOptions, getGetFdrInfiniteQueryKey, getGetFdrInfiniteQueryOptions, getGetFdrQueryKey, getGetFdrQueryOptions, getGetFdrSuspenseQueryOptions, getGetHealthInfiniteQueryKey, getGetHealthInfiniteQueryOptions, getGetHealthLivenessInfiniteQueryKey, getGetHealthLivenessInfiniteQueryOptions, getGetHealthLivenessQueryKey, getGetHealthLivenessQueryOptions, getGetHealthLivenessSuspenseQueryOptions, getGetHealthQueryKey, getGetHealthQueryOptions, getGetHealthReadinessInfiniteQueryKey, getGetHealthReadinessInfiniteQueryOptions, getGetHealthReadinessQueryKey, getGetHealthReadinessQueryOptions, getGetHealthReadinessSuspenseQueryOptions, getGetHealthSuspenseQueryOptions, getGetInviteInformationInfiniteQueryKey, getGetInviteInformationInfiniteQueryOptions, getGetInviteInformationQueryKey, getGetInviteInformationQueryOptions, getGetInviteInformationSuspenseQueryOptions, getGetListInfiniteQueryKey, getGetListInfiniteQueryOptions, getGetListQueryKey, getGetListQueryOptions, getGetListSuspenseQueryOptions, getGetMultiCdnListInfiniteQueryKey, getGetMultiCdnListInfiniteQueryOptions, getGetMultiCdnListQueryKey, getGetMultiCdnListQueryOptions, getGetMultiCdnListSuspenseQueryOptions, getGetNodeDetailsInfiniteQueryKey, getGetNodeDetailsInfiniteQueryOptions, getGetNodeDetailsQueryKey, getGetNodeDetailsQueryOptions, getGetNodeDetailsSuspenseQueryOptions, getGetOrgNavigationItemsInfiniteQueryKey, getGetOrgNavigationItemsInfiniteQueryOptions, getGetOrgNavigationItemsQueryKey, getGetOrgNavigationItemsQueryOptions, getGetOrgNavigationItemsSuspenseQueryOptions, getGetOrganizationApplicationListInfiniteQueryKey, getGetOrganizationApplicationListInfiniteQueryOptions, getGetOrganizationApplicationListQueryKey, getGetOrganizationApplicationListQueryOptions, getGetOrganizationApplicationListSuspenseQueryOptions, getGetOrganizationCountersInfiniteQueryKey, getGetOrganizationCountersInfiniteQueryOptions, getGetOrganizationCountersQueryKey, getGetOrganizationCountersQueryOptions, getGetOrganizationCountersSuspenseQueryOptions, getGetOrganizationInfiniteQueryKey, getGetOrganizationInfiniteQueryOptions, getGetOrganizationMembershipDomainsInfiniteQueryKey, getGetOrganizationMembershipDomainsInfiniteQueryOptions, getGetOrganizationMembershipDomainsQueryKey, getGetOrganizationMembershipDomainsQueryOptions, getGetOrganizationMembershipDomainsSuspenseQueryOptions, getGetOrganizationQueryKey, getGetOrganizationQueryOptions, getGetOrganizationSuspenseQueryOptions, getGetPeopleListInfiniteQueryKey, getGetPeopleListInfiniteQueryOptions, getGetPeopleListQueryKey, getGetPeopleListQueryOptions, getGetPeopleListSuspenseQueryOptions, getGetProjNavigationItemsInfiniteQueryKey, getGetProjNavigationItemsInfiniteQueryOptions, getGetProjNavigationItemsQueryKey, getGetProjNavigationItemsQueryOptions, getGetProjNavigationItemsSuspenseQueryOptions, getGetProjectApplicationListByProjectNameInfiniteQueryKey, getGetProjectApplicationListByProjectNameInfiniteQueryOptions, getGetProjectApplicationListByProjectNameQueryKey, getGetProjectApplicationListByProjectNameQueryOptions, getGetProjectApplicationListByProjectNameSuspenseQueryOptions, getGetProjectApplicationListInfiniteQueryKey, getGetProjectApplicationListInfiniteQueryOptions, getGetProjectApplicationListQueryKey, getGetProjectApplicationListQueryOptions, getGetProjectApplicationListSuspenseQueryOptions, getGetProjectApplicationSidebarListInfiniteQueryKey, getGetProjectApplicationSidebarListInfiniteQueryOptions, getGetProjectApplicationSidebarListQueryKey, getGetProjectApplicationSidebarListQueryOptions, getGetProjectApplicationSidebarListSuspenseQueryOptions, getGetProjectAuditLogAuthorsInfiniteQueryKey, getGetProjectAuditLogAuthorsInfiniteQueryOptions, getGetProjectAuditLogAuthorsQueryKey, getGetProjectAuditLogAuthorsQueryOptions, getGetProjectAuditLogAuthorsSuspenseQueryOptions, getGetProjectAuditLogInfiniteQueryKey, getGetProjectAuditLogInfiniteQueryOptions, getGetProjectAuditLogQueryKey, getGetProjectAuditLogQueryOptions, getGetProjectAuditLogSuspenseQueryOptions, getGetProjectDeploymentIntegrationAppsInfiniteQueryKey, getGetProjectDeploymentIntegrationAppsInfiniteQueryOptions, getGetProjectDeploymentIntegrationAppsQueryKey, getGetProjectDeploymentIntegrationAppsQueryOptions, getGetProjectDeploymentIntegrationAppsSuspenseQueryOptions, getGetProjectInfiniteQueryKey, getGetProjectInfiniteQueryOptions, getGetProjectIntegrationListInfiniteQueryKey, getGetProjectIntegrationListInfiniteQueryOptions, getGetProjectIntegrationListQueryKey, getGetProjectIntegrationListQueryOptions, getGetProjectIntegrationListSuspenseQueryOptions, getGetProjectQueryKey, getGetProjectQueryOptions, getGetProjectSettingsInfiniteQueryKey, getGetProjectSettingsInfiniteQueryOptions, getGetProjectSettingsQueryKey, getGetProjectSettingsQueryOptions, getGetProjectSettingsSuspenseQueryOptions, getGetProjectSidebarSearchInfiniteQueryKey, getGetProjectSidebarSearchInfiniteQueryOptions, getGetProjectSidebarSearchQueryKey, getGetProjectSidebarSearchQueryOptions, getGetProjectSidebarSearchSuspenseQueryOptions, getGetProjectSummaryInfiniteQueryKey, getGetProjectSummaryInfiniteQueryOptions, getGetProjectSummaryQueryKey, getGetProjectSummaryQueryOptions, getGetProjectSummarySuspenseQueryOptions, getGetProjectSuspenseQueryOptions, getGetReleasePipelineByApplicationListInfiniteQueryKey, getGetReleasePipelineByApplicationListInfiniteQueryOptions, getGetReleasePipelineByApplicationListQueryKey, getGetReleasePipelineByApplicationListQueryOptions, getGetReleasePipelineByApplicationListSuspenseQueryOptions, getGetReleasePipelineByOrgListInfiniteQueryKey, getGetReleasePipelineByOrgListInfiniteQueryOptions, getGetReleasePipelineByOrgListQueryKey, getGetReleasePipelineByOrgListQueryOptions, getGetReleasePipelineByOrgListSuspenseQueryOptions, getGetReleasePipelineByProjectListInfiniteQueryKey, getGetReleasePipelineByProjectListInfiniteQueryOptions, getGetReleasePipelineByProjectListQueryKey, getGetReleasePipelineByProjectListQueryOptions, getGetReleasePipelineByProjectListSuspenseQueryOptions, getGetReleasePipelineEnvironmentListInfiniteQueryKey, getGetReleasePipelineEnvironmentListInfiniteQueryOptions, getGetReleasePipelineEnvironmentListQueryKey, getGetReleasePipelineEnvironmentListQueryOptions, getGetReleasePipelineEnvironmentListSuspenseQueryOptions, getGetReleasePipelineTagListInfiniteQueryKey, getGetReleasePipelineTagListInfiniteQueryOptions, getGetReleasePipelineTagListQueryKey, getGetReleasePipelineTagListQueryOptions, getGetReleasePipelineTagListSuspenseQueryOptions, getGetReleasePipelineTargetAuthorsInfiniteQueryKey, getGetReleasePipelineTargetAuthorsInfiniteQueryOptions, getGetReleasePipelineTargetAuthorsQueryKey, getGetReleasePipelineTargetAuthorsQueryOptions, getGetReleasePipelineTargetAuthorsSuspenseQueryOptions, getGetReleasePipelineTargetListInfiniteQueryKey, getGetReleasePipelineTargetListInfiniteQueryOptions, getGetReleasePipelineTargetListQueryKey, getGetReleasePipelineTargetListQueryOptions, getGetReleasePipelineTargetListSuspenseQueryOptions, getGetRootInfiniteQueryKey, getGetRootInfiniteQueryOptions, getGetRootQueryKey, getGetRootQueryOptions, getGetRootSuspenseQueryOptions, getGetServerAuthTokenInfiniteQueryKey, getGetServerAuthTokenInfiniteQueryOptions, getGetServerAuthTokenListInfiniteQueryKey, getGetServerAuthTokenListInfiniteQueryOptions, getGetServerAuthTokenListQueryKey, getGetServerAuthTokenListQueryOptions, getGetServerAuthTokenListSuspenseQueryOptions, getGetServerAuthTokenQueryKey, getGetServerAuthTokenQueryOptions, getGetServerAuthTokenSuspenseQueryOptions, getGetSidePanelApplicationEnvironmentListInfiniteQueryKey, getGetSidePanelApplicationEnvironmentListInfiniteQueryOptions, getGetSidePanelApplicationEnvironmentListQueryKey, getGetSidePanelApplicationEnvironmentListQueryOptions, getGetSidePanelApplicationEnvironmentListSuspenseQueryOptions, getGetSidePanelApplicationListInfiniteQueryKey, getGetSidePanelApplicationListInfiniteQueryOptions, getGetSidePanelApplicationListQueryKey, getGetSidePanelApplicationListQueryOptions, getGetSidePanelApplicationListSuspenseQueryOptions, getGetSidePanelApplicationRemoteVersionsInfiniteQueryKey, getGetSidePanelApplicationRemoteVersionsInfiniteQueryOptions, getGetSidePanelApplicationRemoteVersionsQueryKey, getGetSidePanelApplicationRemoteVersionsQueryOptions, getGetSidePanelApplicationRemoteVersionsSuspenseQueryOptions, getGetSidePanelApplicationTagListInfiniteQueryKey, getGetSidePanelApplicationTagListInfiniteQueryOptions, getGetSidePanelApplicationTagListQueryKey, getGetSidePanelApplicationTagListQueryOptions, getGetSidePanelApplicationTagListSuspenseQueryOptions, getGetSidePanelApplicationVersionListInfiniteQueryKey, getGetSidePanelApplicationVersionListInfiniteQueryOptions, getGetSidePanelApplicationVersionListQueryKey, getGetSidePanelApplicationVersionListQueryOptions, getGetSidePanelApplicationVersionListSuspenseQueryOptions, getGetSidePanelDeployedVersionsListInfiniteQueryKey, getGetSidePanelDeployedVersionsListInfiniteQueryOptions, getGetSidePanelDeployedVersionsListQueryKey, getGetSidePanelDeployedVersionsListQueryOptions, getGetSidePanelDeployedVersionsListSuspenseQueryOptions, getGetSpAppEnvironmentInfiniteQueryKey, getGetSpAppEnvironmentInfiniteQueryOptions, getGetSpAppEnvironmentQueryKey, getGetSpAppEnvironmentQueryOptions, getGetSpAppEnvironmentSuspenseQueryOptions, getGetSpAppTagListInfiniteQueryKey, getGetSpAppTagListInfiniteQueryOptions, getGetSpAppTagListQueryKey, getGetSpAppTagListQueryOptions, getGetSpAppTagListSuspenseQueryOptions, getGetSpAppVersionInfiniteQueryKey, getGetSpAppVersionInfiniteQueryOptions, getGetSpAppVersionListInfiniteQueryKey, getGetSpAppVersionListInfiniteQueryOptions, getGetSpAppVersionListQueryKey, getGetSpAppVersionListQueryOptions, getGetSpAppVersionListSuspenseQueryOptions, getGetSpAppVersionQueryKey, getGetSpAppVersionQueryOptions, getGetSpAppVersionSuspenseQueryOptions, getGetSpApplicationListInfiniteQueryKey, getGetSpApplicationListInfiniteQueryOptions, getGetSpApplicationListQueryKey, getGetSpApplicationListQueryOptions, getGetSpApplicationListSuspenseQueryOptions, getGetSpVersionDeployListInfiniteQueryKey, getGetSpVersionDeployListInfiniteQueryOptions, getGetSpVersionDeployListQueryKey, getGetSpVersionDeployListQueryOptions, getGetSpVersionDeployListSuspenseQueryOptions, getGetStripeSubscriptionItemsInfiniteQueryKey, getGetStripeSubscriptionItemsInfiniteQueryOptions, getGetStripeSubscriptionItemsQueryKey, getGetStripeSubscriptionItemsQueryOptions, getGetStripeSubscriptionItemsSuspenseQueryOptions, getGetSubscriptionInfiniteQueryKey, getGetSubscriptionInfiniteQueryOptions, getGetSubscriptionQueryKey, getGetSubscriptionQueryOptions, getGetSubscriptionSuspenseQueryOptions, getGetTagListInfiniteQueryKey, getGetTagListInfiniteQueryOptions, getGetTagListQueryKey, getGetTagListQueryOptions, getGetTagListSuspenseQueryOptions, getGetTargetHistoryInfiniteQueryKey, getGetTargetHistoryInfiniteQueryOptions, getGetTargetHistoryQueryKey, getGetTargetHistoryQueryOptions, getGetTargetHistorySuspenseQueryOptions, getGetTeamByNameInfiniteQueryKey, getGetTeamByNameInfiniteQueryOptions, getGetTeamByNameQueryKey, getGetTeamByNameQueryOptions, getGetTeamByNameSuspenseQueryOptions, getGetTeamInfiniteQueryKey, getGetTeamInfiniteQueryOptions, getGetTeamListInfiniteQueryKey, getGetTeamListInfiniteQueryOptions, getGetTeamListQueryKey, getGetTeamListQueryOptions, getGetTeamListSuspenseQueryOptions, getGetTeamMembersInfiniteQueryKey, getGetTeamMembersInfiniteQueryOptions, getGetTeamMembersQueryKey, getGetTeamMembersQueryOptions, getGetTeamMembersSuspenseQueryOptions, getGetTeamQueryKey, getGetTeamQueryOptions, getGetTeamSuspenseQueryOptions, getGetUniqueOrganizationNameInfiniteQueryKey, getGetUniqueOrganizationNameInfiniteQueryOptions, getGetUniqueOrganizationNameQueryKey, getGetUniqueOrganizationNameQueryOptions, getGetUniqueOrganizationNameSuspenseQueryOptions, getGetUniqueProjectNameInfiniteQueryKey, getGetUniqueProjectNameInfiniteQueryOptions, getGetUniqueProjectNameQueryKey, getGetUniqueProjectNameQueryOptions, getGetUniqueProjectNameSuspenseQueryOptions, getGetUniqueTeamNameInfiniteQueryKey, getGetUniqueTeamNameInfiniteQueryOptions, getGetUniqueTeamNameQueryKey, getGetUniqueTeamNameQueryOptions, getGetUniqueTeamNameSuspenseQueryOptions, getGetUpcomingInvoiceInfiniteQueryKey, getGetUpcomingInvoiceInfiniteQueryOptions, getGetUpcomingInvoiceQueryKey, getGetUpcomingInvoiceQueryOptions, getGetUpcomingInvoiceSuspenseQueryOptions, getGetUserApplicationListByEmailInfiniteQueryKey, getGetUserApplicationListByEmailInfiniteQueryOptions, getGetUserApplicationListByEmailQueryKey, getGetUserApplicationListByEmailQueryOptions, getGetUserApplicationListByEmailSuspenseQueryOptions, getGetUserAuthTokenInfiniteQueryKey, getGetUserAuthTokenInfiniteQueryOptions, getGetUserAuthTokenQueryKey, getGetUserAuthTokenQueryOptions, getGetUserAuthTokenSuspenseQueryOptions, getGetUserByUsernameInfiniteQueryKey, getGetUserByUsernameInfiniteQueryOptions, getGetUserByUsernameQueryKey, getGetUserByUsernameQueryOptions, getGetUserByUsernameSuspenseQueryOptions, getGetUserEmailOptionsInfiniteQueryKey, getGetUserEmailOptionsInfiniteQueryOptions, getGetUserEmailOptionsQueryKey, getGetUserEmailOptionsQueryOptions, getGetUserEmailOptionsSuspenseQueryOptions, getGetUserOrganizationListByEmailInfiniteQueryKey, getGetUserOrganizationListByEmailInfiniteQueryOptions, getGetUserOrganizationListByEmailQueryKey, getGetUserOrganizationListByEmailQueryOptions, getGetUserOrganizationListByEmailSuspenseQueryOptions, getGetUserOrganizationsInfiniteQueryKey, getGetUserOrganizationsInfiniteQueryOptions, getGetUserOrganizationsQueryKey, getGetUserOrganizationsQueryOptions, getGetUserOrganizationsSuspenseQueryOptions, getGetUserPinOptionsInfiniteQueryKey, getGetUserPinOptionsInfiniteQueryOptions, getGetUserPinOptionsQueryKey, getGetUserPinOptionsQueryOptions, getGetUserPinOptionsSuspenseQueryOptions, getGetUserPinsInfiniteQueryKey, getGetUserPinsInfiniteQueryOptions, getGetUserPinsQueryKey, getGetUserPinsQueryOptions, getGetUserPinsSuspenseQueryOptions, getGetUserProfileSettingsInfiniteQueryKey, getGetUserProfileSettingsInfiniteQueryOptions, getGetUserProfileSettingsQueryKey, getGetUserProfileSettingsQueryOptions, getGetUserProfileSettingsSuspenseQueryOptions, getGetUserProjectListByEmailInfiniteQueryKey, getGetUserProjectListByEmailInfiniteQueryOptions, getGetUserProjectListByEmailQueryKey, getGetUserProjectListByEmailQueryOptions, getGetUserProjectListByEmailSuspenseQueryOptions, getGetWorkerVersionListInfiniteQueryKey, getGetWorkerVersionListInfiniteQueryOptions, getGetWorkerVersionListQueryKey, getGetWorkerVersionListQueryOptions, getGetWorkerVersionListSuspenseQueryOptions, getGraphCurrentUsageMutationOptions, getHealth, getHealthLiveness, getHealthReadiness, getInviteChildOrganizationMutationOptions, getInviteInformation, getInvitePeopleMutationOptions, getIsServerAuthTokenNameUniqueInfiniteQueryKey, getIsServerAuthTokenNameUniqueInfiniteQueryOptions, getIsServerAuthTokenNameUniqueQueryKey, getIsServerAuthTokenNameUniqueQueryOptions, getIsServerAuthTokenNameUniqueSuspenseQueryOptions, getIsUniqueOrganizationNameInfiniteQueryKey, getIsUniqueOrganizationNameInfiniteQueryOptions, getIsUniqueOrganizationNameQueryKey, getIsUniqueOrganizationNameQueryOptions, getIsUniqueOrganizationNameSuspenseQueryOptions, getIsUniqueUsernameInfiniteQueryKey, getIsUniqueUsernameInfiniteQueryOptions, getIsUniqueUsernameQueryKey, getIsUniqueUsernameQueryOptions, getIsUniqueUsernameSuspenseQueryOptions, getIsUserAuthTokenNameUniqueInfiniteQueryKey, getIsUserAuthTokenNameUniqueInfiniteQueryOptions, getIsUserAuthTokenNameUniqueQueryKey, getIsUserAuthTokenNameUniqueQueryOptions, getIsUserAuthTokenNameUniqueSuspenseQueryOptions, getIsUserZephyrTeamInfiniteQueryKey, getIsUserZephyrTeamInfiniteQueryOptions, getIsUserZephyrTeamQueryKey, getIsUserZephyrTeamQueryOptions, getIsUserZephyrTeamSuspenseQueryOptions, getList, getListAllStripePricesInfiniteQueryKey, getListAllStripePricesInfiniteQueryOptions, getListAllStripePricesQueryKey, getListAllStripePricesQueryOptions, getListAllStripePricesSuspenseQueryOptions, getListChildOrganizationsInfiniteQueryKey, getListChildOrganizationsInfiniteQueryOptions, getListChildOrganizationsQueryKey, getListChildOrganizationsQueryOptions, getListChildOrganizationsSuspenseQueryOptions, getListCurrentMetricUsageInfiniteQueryKey, getListCurrentMetricUsageInfiniteQueryOptions, getListCurrentMetricUsageQueryKey, getListCurrentMetricUsageQueryOptions, getListCurrentMetricUsageSuspenseQueryOptions, getListCurrentUsageInfiniteQueryKey, getListCurrentUsageInfiniteQueryOptions, getListCurrentUsageQueryKey, getListCurrentUsageQueryOptions, getListCurrentUsageSuspenseQueryOptions, getListInvoicesInfiniteQueryKey, getListInvoicesInfiniteQueryOptions, getListInvoicesQueryKey, getListInvoicesQueryOptions, getListInvoicesSuspenseQueryOptions, getListOrganizationMembersInfiniteQueryKey, getListOrganizationMembersInfiniteQueryOptions, getListOrganizationMembersQueryKey, getListOrganizationMembersQueryOptions, getListOrganizationMembersSuspenseQueryOptions, getListOrganizationProjectsInfiniteQueryKey, getListOrganizationProjectsInfiniteQueryOptions, getListOrganizationProjectsQueryKey, getListOrganizationProjectsQueryOptions, getListOrganizationProjectsSuspenseQueryOptions, getListOrganizationsInfiniteQueryKey, getListOrganizationsInfiniteQueryOptions, getListOrganizationsQueryKey, getListOrganizationsQueryOptions, getListOrganizationsSuspenseQueryOptions, getListPaymentMethodsInfiniteQueryKey, getListPaymentMethodsInfiniteQueryOptions, getListPaymentMethodsQueryKey, getListPaymentMethodsQueryOptions, getListPaymentMethodsSuspenseQueryOptions, getListProjectContributorsInfiniteQueryKey, getListProjectContributorsInfiniteQueryOptions, getListProjectContributorsListInfiniteQueryKey, getListProjectContributorsListInfiniteQueryOptions, getListProjectContributorsListQueryKey, getListProjectContributorsListQueryOptions, getListProjectContributorsListSuspenseQueryOptions, getListProjectContributorsQueryKey, getListProjectContributorsQueryOptions, getListProjectContributorsSuspenseQueryOptions, getListQuotasInfiniteQueryKey, getListQuotasInfiniteQueryOptions, getListQuotasQueryKey, getListQuotasQueryOptions, getListQuotasSuspenseQueryOptions, getListUserAuthTokensInfiniteQueryKey, getListUserAuthTokensInfiniteQueryOptions, getListUserAuthTokensQueryKey, getListUserAuthTokensQueryOptions, getListUserAuthTokensSuspenseQueryOptions, getMarkDeployFailedMutationOptions, getMarkVersionAsDeprecatedMutationOptions, getMarkVersionAsFailedMutationOptions, getMarkVersionAsUnavailableMutationOptions, getMultiCdnList, getNodeDetails, getOrgNavigationItems, getOrganization, getOrganizationApplicationList, getOrganizationCounters, getOrganizationMembershipDomains, getPeopleList, getPinNavigationItemMutationOptions, getPostSpVersionDeployMutationOptions, getProjNavigationItems, getProject, getProjectApplicationList, getProjectApplicationListByProjectName, getProjectApplicationSidebarList, getProjectAuditLog, getProjectAuditLogAuthors, getProjectDeploymentIntegrationApps, getProjectIntegrationList, getProjectListInfiniteQueryKey, getProjectListInfiniteQueryOptions, getProjectListQueryKey, getProjectListQueryOptions, getProjectListSuspenseQueryOptions, getProjectSettings, getProjectSidebarSearch, getProjectSummary, getPromoteReleaseCandidateMutationOptions, getRejectChildOrganizationInviteMutationOptions, getReleasePipelineByApplicationList, getReleasePipelineByOrgList, getReleasePipelineByProjectList, getReleasePipelineEnvironmentList, getReleasePipelineTagList, getReleasePipelineTargetAuthors, getReleasePipelineTargetList, getRemoveApplicationVersionProblematicMutationOptions, getRemoveCouponMutationOptions, getRemoveEnvironmentCustomDomainMutationOptions, getRemoveEnvironmentMemberMutationOptions, getRemoveIntegrationFromEnvironmentMutationOptions, getRemoveProjectMemberMutationOptions, getRemoveProjectTeamMutationOptions, getRemoveTeamMemberMutationOptions, getRenameApplicationEnvironmentMutationOptions, getRenameApplicationTagMutationOptions, getResendVerificationEmailMutationOptions, getResolveDependencyInfiniteQueryKey, getResolveDependencyInfiniteQueryOptions, getResolveDependencyQueryKey, getResolveDependencyQueryOptions, getResolveDependencySuspenseQueryOptions, getRestoreProjectMutationOptions, getRetryMutationOptions, getRollbackEnvironmentMutationOptions, getRoot, getSearchOrganizationsInfiniteQueryKey, getSearchOrganizationsInfiniteQueryOptions, getSearchOrganizationsQueryKey, getSearchOrganizationsQueryOptions, getSearchOrganizationsSuspenseQueryOptions, getSeedTestVersionsMutationOptions, getSendOrganizationMembershipDomainCodeMutationOptions, getServerAuthToken, getServerAuthTokenList, getSetApplicationVersionAvailableMutationOptions, getSetApplicationVersionDeprecatedMutationOptions, getSetApplicationVersionFailedMutationOptions, getSetApplicationVersionProblematicMutationOptions, getSetApplicationVersionUnavailableMutationOptions, getSetDefaultApplicationIntegrationMutationOptions, getSetDefaultMutationOptions, getSetDefaultPaymentMethodMutationOptions, getSetDefaultProjectIntegrationMutationOptions, getSetDeploymentIntegrationAllAppsToProjectDefaultMutationOptions, getSetEnvironmentDeploymentIntegrationMutationOptions, getSetEnvironmentOrderMutationOptions, getSetPrimaryAccountMutationOptions, getSetPrimaryIntegrationMutationOptions, getSetZephyrAsDefaultApplicationIntegrationMutationOptions, getSetZephyrAsDefaultEnvironmentIntegrationMutationOptions, getSetZephyrAsDefaultMutationOptions, getSetZephyrAsDefaultProjectIntegrationMutationOptions, getSideBarProjectListInfiniteQueryKey, getSideBarProjectListInfiniteQueryOptions, getSideBarProjectListQueryKey, getSideBarProjectListQueryOptions, getSideBarProjectListSuspenseQueryOptions, getSidePanelApplicationEnvironmentList, getSidePanelApplicationList, getSidePanelApplicationRemoteVersions, getSidePanelApplicationTagList, getSidePanelApplicationVersionList, getSidePanelDeployedVersionsList, getSpAppEnvironment, getSpAppTagList, getSpAppVersion, getSpAppVersionList, getSpApplicationList, getSpVersionDeployList, getStripeSubscriptionItems, getSubscription, getTagList, getTargetHistory, getTeam, getTeamByName, getTeamList, getTeamMembers, getToggleEnabledMutationOptions, getUniqueOrganizationName, getUniqueProjectName, getUniqueTeamName, getUnpinNavigationItemMutationOptions, getUnsetDefaultApplicationIntegrationMutationOptions, getUnsetDefaultMutationOptions, getUnsetDefaultProjectIntegrationMutationOptions, getUnsetEnvironmentDeploymentIntegrationMutationOptions, getUpcomingInvoice, getUpdateApplicationEnvironmentMutationOptions, getUpdateApplicationMutationOptions, getUpdateApplicationNameMutationOptions, getUpdateApplicationSettingsMutationOptions, getUpdateApplicationTagMutationOptions, getUpdateCurrentUserProfileMutationOptions, getUpdateEmailPreferencesMutationOptions, getUpdateEnvironmentDependenciesMutationOptions, getUpdateEnvironmentEnvVarSetMutationOptions, getUpdateNonRecurringQuotaMutationOptions, getUpdateOrganizationDeploymentIntegrationMutationOptions, getUpdateOrganizationMutationOptions, getUpdateOrganizationNameMutationOptions, getUpdateOrganizationSettingsMutationOptions, getUpdatePeopleMutationOptions, getUpdateProjectByIdMutationOptions, getUpdateProjectContributorRoleMutationOptions, getUpdateProjectNameMutationOptions, getUpdateProjectSettingsMutationOptions, getUpdateRecurringQuotaMutationOptions, getUpdateServerAuthTokenMutationOptions, getUpdateTeamMemberRoleMutationOptions, getUpdateTeamMutationOptions, getUpdateUserAuthTokenNameMutationOptions, getUpdateUserEmailOptionsMutationOptions, getUpdateUserMutationOptions, getUpdateUserPinsMutationOptions, getUpdateUserProfileSettingsMutationOptions, getUpdateWorkerMutationOptions, getUploadFromDashboardPluginMutationOptions, getUpsertOrganizationMembershipDomainMutationOptions, getUpsertUserMutationOptions, getUserApplicationListByEmail, getUserAuthToken, getUserByUsername, getUserEmailOptions, getUserOrganizationListByEmail, getUserOrganizations, getUserPinOptions, getUserPins, getUserProfileSettings, getUserProjectListByEmail, getValidateAuthTokenInfiniteQueryKey, getValidateAuthTokenInfiniteQueryOptions, getValidateAuthTokenQueryKey, getValidateAuthTokenQueryOptions, getValidateAuthTokenSuspenseQueryOptions, getValidateEnvVarPromotionInfiniteQueryKey, getValidateEnvVarPromotionInfiniteQueryOptions, getValidateEnvVarPromotionQueryKey, getValidateEnvVarPromotionQueryOptions, getValidateEnvVarPromotionSuspenseQueryOptions, getVerifyOrganizationMembershipDomainMutationOptions, getWorkerVersionList, graphCurrentUsage, inviteChildOrganization, invitePeople, isServerAuthTokenNameUnique, isUniqueOrganizationName, isUniqueUsername, isUserAuthTokenNameUnique, isUserZephyrTeam, listAllStripePrices, listChildOrganizations, listCurrentMetricUsage, listCurrentUsage, listInvoices, listOrganizationMembers, listOrganizationProjects, listOrganizations, listPaymentMethods, listProjectContributors, listProjectContributorsList, listQuotas, listUserAuthTokens, markDeployFailed, markVersionAsDeprecated, markVersionAsFailed, markVersionAsUnavailable, pinNavigationItem, postSpVersionDeploy, projectList, promoteReleaseCandidate, rejectChildOrganizationInvite, removeApplicationVersionProblematic, removeCoupon, removeEnvironmentCustomDomain, removeEnvironmentMember, removeIntegrationFromEnvironment, removeProjectMember, removeProjectTeam, removeTeamMember, renameApplicationEnvironment, renameApplicationTag, resendVerificationEmail, resolveDependency, restoreProject, retry, rollbackEnvironment, searchOrganizations, seedTestVersions, sendOrganizationMembershipDomainCode, setApplicationVersionAvailable, setApplicationVersionDeprecated, setApplicationVersionFailed, setApplicationVersionProblematic, setApplicationVersionUnavailable, setDefault, setDefaultApplicationIntegration, setDefaultPaymentMethod, setDefaultProjectIntegration, setDeploymentIntegrationAllAppsToProjectDefault, setEnvironmentDeploymentIntegration, setEnvironmentOrder, setPrimaryAccount, setPrimaryIntegration, setZephyrAsDefault, setZephyrAsDefaultApplicationIntegration, setZephyrAsDefaultEnvironmentIntegration, setZephyrAsDefaultProjectIntegration, sideBarProjectList, toggleEnabled, unpinNavigationItem, unsetDefault, unsetDefaultApplicationIntegration, unsetDefaultProjectIntegration, unsetEnvironmentDeploymentIntegration, updateApplication, updateApplicationEnvironment, updateApplicationName, updateApplicationSettings, updateApplicationTag, updateCurrentUserProfile, zephyr_updateEmailPreferences as updateEmailPreferences, updateEnvironmentDependencies, updateEnvironmentEnvVarSet, updateNonRecurringQuota, zephyr_updateOrganization as updateOrganization, updateOrganizationDeploymentIntegration, updateOrganizationName, updateOrganizationSettings, zephyr_updatePeople as updatePeople, zephyr_updateProjectById as updateProjectById, updateProjectContributorRole, updateProjectName, updateProjectSettings, updateRecurringQuota, updateServerAuthToken, zephyr_updateTeam as updateTeam, updateTeamMemberRole, updateUser, updateUserAuthTokenName, updateUserEmailOptions, updateUserPins, updateUserProfileSettings, updateWorker, uploadFromDashboardPlugin, zephyr_upsertOrganizationMembershipDomain as upsertOrganizationMembershipDomain, upsertUser, useAcceptChildOrganizationInvite, useAddEnvironmentCustomDomain, useAddEnvironmentMembers, useAddIntegrationToEnvironment, useAddProjectContributors, useAddTeamMembers, useAdvanceSubscriptionSchedule, useAttachPaymentMethod, useAuthLogin, useAuthLoginInfinite, useAuthLoginSuspense, useAuthorizeCallback, useAuthorizeCallbackInfinite, useAuthorizeCallbackSuspense, useCancelSubscriptionSchedule, useChangeOrganizationDeploymentIntegrationName, useChangePassword, useChangeSubscription, useCheckCanJoinAsChild, useCheckDevopsFeature, useCheckDevopsFeatureInfinite, useCheckDevopsFeatureSuspense, useCheckDomain, useCheckDomainInfinite, useCheckDomainSuspense, useCleanupTests, useCliTest, useCliTestInfinite, useCliTestSuspense, useCreate, useCreateApplication, useCreateApplicationEnvironment, useCreateApplicationTag, useCreateMultiCdn, useCreateOrganization, useCreateProject, useCreateReleaseCandidate, useCreateServerAuthToken, useCreateTeam, useDeactivateCurrentUser, useDeactivateUserAccount, useDelete, useDeleteApplicationEnvironment, useDeleteApplicationSingular, useDeleteApplicationTag, useDeleteInviteChildOrganization, useDeleteOrganization, useDeleteOrganizationMembershipDomain, useDeletePeople, useDeleteProject, useDeleteProjectById, useDeleteReleaseCandidate, useDeleteServerAuthToken, useDeleteTeam, useDeleteUserAuthToken, useDeployApplicationVersion, useDeploySidePanelVersion, useDeployTagToEnvironment, useDeployVersion, useDetachPaymentMethod, useEditUserAuthToken, useEntriPowerDomain, useEntriRemovePoweredDomain, useEntriUpdatePoweredDomain, useGenerateUserAuthToken, useGetAccountsAssociated, useGetAccountsAssociatedInfinite, useGetAccountsAssociatedSuspense, useGetAddEnvironmentMemberOptions, useGetAddEnvironmentMemberOptionsInfinite, useGetAddEnvironmentMemberOptionsSuspense, useGetAppNavigationItems, useGetAppNavigationItemsInfinite, useGetAppNavigationItemsSuspense, useGetApplication, useGetApplicationActivityOverTime, useGetApplicationActivityOverTimeInfinite, useGetApplicationActivityOverTimeSuspense, useGetApplicationAuditLog, useGetApplicationAuditLogAuthors, useGetApplicationAuditLogAuthorsInfinite, useGetApplicationAuditLogAuthorsSuspense, useGetApplicationAuditLogInfinite, useGetApplicationAuditLogSuspense, useGetApplicationConfig, useGetApplicationConfigInfinite, useGetApplicationConfigSuspense, useGetApplicationConfigs, useGetApplicationConfigsInfinite, useGetApplicationConfigsSuspense, useGetApplicationConsumers, useGetApplicationConsumersInfinite, useGetApplicationConsumersSuspense, useGetApplicationContributors, useGetApplicationContributorsInfinite, useGetApplicationContributorsSuspense, useGetApplicationContributorsWithVersionCount, useGetApplicationContributorsWithVersionCountInfinite, useGetApplicationContributorsWithVersionCountSuspense, useGetApplicationCounters, useGetApplicationCountersInfinite, useGetApplicationCountersSuspense, useGetApplicationEnvironment, useGetApplicationEnvironmentInfinite, useGetApplicationEnvironmentSuspense, useGetApplicationGraph, useGetApplicationGraphInfinite, useGetApplicationGraphSuspense, useGetApplicationInfinite, useGetApplicationIntegrationList, useGetApplicationIntegrationListInfinite, useGetApplicationIntegrationListSuspense, useGetApplicationListByProject, useGetApplicationListByProjectInfinite, useGetApplicationListByProjectSuspense, useGetApplicationModule, useGetApplicationModuleInfinite, useGetApplicationModuleSuspense, useGetApplicationOverview, useGetApplicationOverviewInfinite, useGetApplicationOverviewSuspense, useGetApplicationSettings, useGetApplicationSettingsInfinite, useGetApplicationSettingsSuspense, useGetApplicationSidebarList, useGetApplicationSidebarListInfinite, useGetApplicationSidebarListSuspense, useGetApplicationSummary, useGetApplicationSummaryInfinite, useGetApplicationSummarySuspense, useGetApplicationSuspense, useGetApplicationTag, useGetApplicationTagConditionOptions, useGetApplicationTagConditionOptionsInfinite, useGetApplicationTagConditionOptionsSuspense, useGetApplicationTagConditionOptionsUsers, useGetApplicationTagConditionOptionsUsersInfinite, useGetApplicationTagConditionOptionsUsersSuspense, useGetApplicationTagConditionOptionsVersions, useGetApplicationTagConditionOptionsVersionsInfinite, useGetApplicationTagConditionOptionsVersionsSuspense, useGetApplicationTagConditionVersion, useGetApplicationTagConditionVersionInfinite, useGetApplicationTagConditionVersionSuspense, useGetApplicationTagInfinite, useGetApplicationTagQueryOpts, useGetApplicationTagQueryOptsInfinite, useGetApplicationTagQueryOptsSuspense, useGetApplicationTagSuspense, useGetApplicationUmlSidebar, useGetApplicationUmlSidebarInfinite, useGetApplicationUmlSidebarSuspense, useGetApplicationVersionDeployTargetList, useGetApplicationVersionDeployTargetListInfinite, useGetApplicationVersionDeployTargetListSuspense, useGetApplicationVersionDetail, useGetApplicationVersionDetailInfinite, useGetApplicationVersionDetailSuspense, useGetApplicationVersionList, useGetApplicationVersionListInfinite, useGetApplicationVersionListSuspense, useGetApplicationVersionQueryOpts, useGetApplicationVersionQueryOptsInfinite, useGetApplicationVersionQueryOptsSuspense, useGetAuthorizeLink, useGetAuthorizeLinkInfinite, useGetAuthorizeLinkSuspense, useGetAuthorizeWithUserInfo, useGetAuthorizeWithUserInfoInfinite, useGetAuthorizeWithUserInfoSuspense, useGetBuildVersionDetail, useGetBuildVersionDetailInfinite, useGetBuildVersionDetailSuspense, useGetBuildVersionList, useGetBuildVersionListInfinite, useGetBuildVersionListSuspense, useGetCoupon, useGetCouponInfinite, useGetCouponSuspense, useGetCurrentUser, useGetCurrentUserInfinite, useGetCurrentUserOrganizationList, useGetCurrentUserOrganizationListInfinite, useGetCurrentUserOrganizationListSuspense, useGetCurrentUserProfile, useGetCurrentUserProfileInfinite, useGetCurrentUserProfileSuspense, useGetCurrentUserSuspense, useGetDefaultPaymentMethod, useGetDefaultPaymentMethodInfinite, useGetDefaultPaymentMethodSuspense, useGetDeployApplicationVersionList, useGetDeployApplicationVersionListInfinite, useGetDeployApplicationVersionListSuspense, useGetDeployTargets, useGetDeployTargetsInfinite, useGetDeployTargetsSuspense, useGetDeployedTags, useGetDeployedTagsInfinite, useGetDeployedTagsSuspense, useGetDeployedVersions, useGetDeployedVersionsInfinite, useGetDeployedVersionsSuspense, useGetDeploymentIntegration, useGetDeploymentIntegrationInfinite, useGetDeploymentIntegrationSuspense, useGetDeploymentStatus, useGetDeploymentStatusInfinite, useGetDeploymentStatusSuspense, useGetEmailPreferences, useGetEmailPreferencesInfinite, useGetEmailPreferencesSuspense, useGetEnabledList, useGetEnabledListInfinite, useGetEnabledListSuspense, useGetEntriConfig, useGetEntriConfigInfinite, useGetEntriConfigSuspense, useGetEntriConnectUrl, useGetEntriConnectUrlInfinite, useGetEntriConnectUrlSuspense, useGetEntriDomainEligibility, useGetEntriDomainEligibilityInfinite, useGetEntriDomainEligibilitySuspense, useGetEnvironmentAuditLog, useGetEnvironmentAuditLogInfinite, useGetEnvironmentAuditLogSuspense, useGetEnvironmentAuthors, useGetEnvironmentAuthorsInfinite, useGetEnvironmentAuthorsSuspense, useGetEnvironmentConditionOptions, useGetEnvironmentConditionOptionsInfinite, useGetEnvironmentConditionOptionsSuspense, useGetEnvironmentConditionVersion, useGetEnvironmentConditionVersionInfinite, useGetEnvironmentConditionVersionSuspense, useGetEnvironmentDependencies, useGetEnvironmentDependenciesInfinite, useGetEnvironmentDependenciesSuspense, useGetEnvironmentDeploymentIntegrationList, useGetEnvironmentDeploymentIntegrationListInfinite, useGetEnvironmentDeploymentIntegrationListSuspense, useGetEnvironmentDeploymentLog, useGetEnvironmentDeploymentLogInfinite, useGetEnvironmentDeploymentLogSuspense, useGetEnvironmentEnvVarSet, useGetEnvironmentEnvVarSetInfinite, useGetEnvironmentEnvVarSetSuspense, useGetEnvironmentIntegrations, useGetEnvironmentIntegrationsInfinite, useGetEnvironmentIntegrationsSuspense, useGetEnvironmentList, useGetEnvironmentListInfinite, useGetEnvironmentListSuspense, useGetEnvironmentMembers, useGetEnvironmentMembersInfinite, useGetEnvironmentMembersSuspense, useGetFdr, useGetFdrInfinite, useGetFdrSuspense, useGetHealth, useGetHealthInfinite, useGetHealthLiveness, useGetHealthLivenessInfinite, useGetHealthLivenessSuspense, useGetHealthReadiness, useGetHealthReadinessInfinite, useGetHealthReadinessSuspense, useGetHealthSuspense, useGetInviteInformation, useGetInviteInformationInfinite, useGetInviteInformationSuspense, useGetList, useGetListInfinite, useGetListSuspense, useGetMultiCdnList, useGetMultiCdnListInfinite, useGetMultiCdnListSuspense, useGetNodeDetails, useGetNodeDetailsInfinite, useGetNodeDetailsSuspense, useGetOrgNavigationItems, useGetOrgNavigationItemsInfinite, useGetOrgNavigationItemsSuspense, useGetOrganization, useGetOrganizationApplicationList, useGetOrganizationApplicationListInfinite, useGetOrganizationApplicationListSuspense, useGetOrganizationCounters, useGetOrganizationCountersInfinite, useGetOrganizationCountersSuspense, useGetOrganizationInfinite, useGetOrganizationMembershipDomains, useGetOrganizationMembershipDomainsInfinite, useGetOrganizationMembershipDomainsSuspense, useGetOrganizationSuspense, useGetPeopleList, useGetPeopleListInfinite, useGetPeopleListSuspense, useGetProjNavigationItems, useGetProjNavigationItemsInfinite, useGetProjNavigationItemsSuspense, useGetProject, useGetProjectApplicationList, useGetProjectApplicationListByProjectName, useGetProjectApplicationListByProjectNameInfinite, useGetProjectApplicationListByProjectNameSuspense, useGetProjectApplicationListInfinite, useGetProjectApplicationListSuspense, useGetProjectApplicationSidebarList, useGetProjectApplicationSidebarListInfinite, useGetProjectApplicationSidebarListSuspense, useGetProjectAuditLog, useGetProjectAuditLogAuthors, useGetProjectAuditLogAuthorsInfinite, useGetProjectAuditLogAuthorsSuspense, useGetProjectAuditLogInfinite, useGetProjectAuditLogSuspense, useGetProjectDeploymentIntegrationApps, useGetProjectDeploymentIntegrationAppsInfinite, useGetProjectDeploymentIntegrationAppsSuspense, useGetProjectInfinite, useGetProjectIntegrationList, useGetProjectIntegrationListInfinite, useGetProjectIntegrationListSuspense, useGetProjectSettings, useGetProjectSettingsInfinite, useGetProjectSettingsSuspense, useGetProjectSidebarSearch, useGetProjectSidebarSearchInfinite, useGetProjectSidebarSearchSuspense, useGetProjectSummary, useGetProjectSummaryInfinite, useGetProjectSummarySuspense, useGetProjectSuspense, useGetReleasePipelineByApplicationList, useGetReleasePipelineByApplicationListInfinite, useGetReleasePipelineByApplicationListSuspense, useGetReleasePipelineByOrgList, useGetReleasePipelineByOrgListInfinite, useGetReleasePipelineByOrgListSuspense, useGetReleasePipelineByProjectList, useGetReleasePipelineByProjectListInfinite, useGetReleasePipelineByProjectListSuspense, useGetReleasePipelineEnvironmentList, useGetReleasePipelineEnvironmentListInfinite, useGetReleasePipelineEnvironmentListSuspense, useGetReleasePipelineTagList, useGetReleasePipelineTagListInfinite, useGetReleasePipelineTagListSuspense, useGetReleasePipelineTargetAuthors, useGetReleasePipelineTargetAuthorsInfinite, useGetReleasePipelineTargetAuthorsSuspense, useGetReleasePipelineTargetList, useGetReleasePipelineTargetListInfinite, useGetReleasePipelineTargetListSuspense, useGetRoot, useGetRootInfinite, useGetRootSuspense, useGetServerAuthToken, useGetServerAuthTokenInfinite, useGetServerAuthTokenList, useGetServerAuthTokenListInfinite, useGetServerAuthTokenListSuspense, useGetServerAuthTokenSuspense, useGetSidePanelApplicationEnvironmentList, useGetSidePanelApplicationEnvironmentListInfinite, useGetSidePanelApplicationEnvironmentListSuspense, useGetSidePanelApplicationList, useGetSidePanelApplicationListInfinite, useGetSidePanelApplicationListSuspense, useGetSidePanelApplicationRemoteVersions, useGetSidePanelApplicationRemoteVersionsInfinite, useGetSidePanelApplicationRemoteVersionsSuspense, useGetSidePanelApplicationTagList, useGetSidePanelApplicationTagListInfinite, useGetSidePanelApplicationTagListSuspense, useGetSidePanelApplicationVersionList, useGetSidePanelApplicationVersionListInfinite, useGetSidePanelApplicationVersionListSuspense, useGetSidePanelDeployedVersionsList, useGetSidePanelDeployedVersionsListInfinite, useGetSidePanelDeployedVersionsListSuspense, useGetSpAppEnvironment, useGetSpAppEnvironmentInfinite, useGetSpAppEnvironmentSuspense, useGetSpAppTagList, useGetSpAppTagListInfinite, useGetSpAppTagListSuspense, useGetSpAppVersion, useGetSpAppVersionInfinite, useGetSpAppVersionList, useGetSpAppVersionListInfinite, useGetSpAppVersionListSuspense, useGetSpAppVersionSuspense, useGetSpApplicationList, useGetSpApplicationListInfinite, useGetSpApplicationListSuspense, useGetSpVersionDeployList, useGetSpVersionDeployListInfinite, useGetSpVersionDeployListSuspense, useGetStripeSubscriptionItems, useGetStripeSubscriptionItemsInfinite, useGetStripeSubscriptionItemsSuspense, useGetSubscription, useGetSubscriptionInfinite, useGetSubscriptionSuspense, useGetTagList, useGetTagListInfinite, useGetTagListSuspense, useGetTargetHistory, useGetTargetHistoryInfinite, useGetTargetHistorySuspense, useGetTeam, useGetTeamByName, useGetTeamByNameInfinite, useGetTeamByNameSuspense, useGetTeamInfinite, useGetTeamList, useGetTeamListInfinite, useGetTeamListSuspense, useGetTeamMembers, useGetTeamMembersInfinite, useGetTeamMembersSuspense, useGetTeamSuspense, useGetUniqueOrganizationName, useGetUniqueOrganizationNameInfinite, useGetUniqueOrganizationNameSuspense, useGetUniqueProjectName, useGetUniqueProjectNameInfinite, useGetUniqueProjectNameSuspense, useGetUniqueTeamName, useGetUniqueTeamNameInfinite, useGetUniqueTeamNameSuspense, useGetUpcomingInvoice, useGetUpcomingInvoiceInfinite, useGetUpcomingInvoiceSuspense, useGetUserApplicationListByEmail, useGetUserApplicationListByEmailInfinite, useGetUserApplicationListByEmailSuspense, useGetUserAuthToken, useGetUserAuthTokenInfinite, useGetUserAuthTokenSuspense, useGetUserByUsername, useGetUserByUsernameInfinite, useGetUserByUsernameSuspense, useGetUserEmailOptions, useGetUserEmailOptionsInfinite, useGetUserEmailOptionsSuspense, useGetUserOrganizationListByEmail, useGetUserOrganizationListByEmailInfinite, useGetUserOrganizationListByEmailSuspense, useGetUserOrganizations, useGetUserOrganizationsInfinite, useGetUserOrganizationsSuspense, useGetUserPinOptions, useGetUserPinOptionsInfinite, useGetUserPinOptionsSuspense, useGetUserPins, useGetUserPinsInfinite, useGetUserPinsSuspense, useGetUserProfileSettings, useGetUserProfileSettingsInfinite, useGetUserProfileSettingsSuspense, useGetUserProjectListByEmail, useGetUserProjectListByEmailInfinite, useGetUserProjectListByEmailSuspense, useGetWorkerVersionList, useGetWorkerVersionListInfinite, useGetWorkerVersionListSuspense, useGraphCurrentUsage, useInviteChildOrganization, useInvitePeople, useIsServerAuthTokenNameUnique, useIsServerAuthTokenNameUniqueInfinite, useIsServerAuthTokenNameUniqueSuspense, useIsUniqueOrganizationName, useIsUniqueOrganizationNameInfinite, useIsUniqueOrganizationNameSuspense, useIsUniqueUsername, useIsUniqueUsernameInfinite, useIsUniqueUsernameSuspense, useIsUserAuthTokenNameUnique, useIsUserAuthTokenNameUniqueInfinite, useIsUserAuthTokenNameUniqueSuspense, useIsUserZephyrTeam, useIsUserZephyrTeamInfinite, useIsUserZephyrTeamSuspense, useListAllStripePrices, useListAllStripePricesInfinite, useListAllStripePricesSuspense, useListChildOrganizations, useListChildOrganizationsInfinite, useListChildOrganizationsSuspense, useListCurrentMetricUsage, useListCurrentMetricUsageInfinite, useListCurrentMetricUsageSuspense, useListCurrentUsage, useListCurrentUsageInfinite, useListCurrentUsageSuspense, useListInvoices, useListInvoicesInfinite, useListInvoicesSuspense, useListOrganizationMembers, useListOrganizationMembersInfinite, useListOrganizationMembersSuspense, useListOrganizationProjects, useListOrganizationProjectsInfinite, useListOrganizationProjectsSuspense, useListOrganizations, useListOrganizationsInfinite, useListOrganizationsSuspense, useListPaymentMethods, useListPaymentMethodsInfinite, useListPaymentMethodsSuspense, useListProjectContributors, useListProjectContributorsInfinite, useListProjectContributorsList, useListProjectContributorsListInfinite, useListProjectContributorsListSuspense, useListProjectContributorsSuspense, useListQuotas, useListQuotasInfinite, useListQuotasSuspense, useListUserAuthTokens, useListUserAuthTokensInfinite, useListUserAuthTokensSuspense, useMarkDeployFailed, useMarkVersionAsDeprecated, useMarkVersionAsFailed, useMarkVersionAsUnavailable, usePinNavigationItem, usePostSpVersionDeploy, useProjectList, useProjectListInfinite, useProjectListSuspense, usePromoteReleaseCandidate, useRejectChildOrganizationInvite, useRemoveApplicationVersionProblematic, useRemoveCoupon, useRemoveEnvironmentCustomDomain, useRemoveEnvironmentMember, useRemoveIntegrationFromEnvironment, useRemoveProjectMember, useRemoveProjectTeam, useRemoveTeamMember, useRenameApplicationEnvironment, useRenameApplicationTag, useResendVerificationEmail, useResolveDependency, useResolveDependencyInfinite, useResolveDependencySuspense, useRestoreProject, useRetry, useRollbackEnvironment, useSearchOrganizations, useSearchOrganizationsInfinite, useSearchOrganizationsSuspense, useSeedTestVersions, useSendOrganizationMembershipDomainCode, useSetApplicationVersionAvailable, useSetApplicationVersionDeprecated, useSetApplicationVersionFailed, useSetApplicationVersionProblematic, useSetApplicationVersionUnavailable, useSetDefault, useSetDefaultApplicationIntegration, useSetDefaultPaymentMethod, useSetDefaultProjectIntegration, useSetDeploymentIntegrationAllAppsToProjectDefault, useSetEnvironmentDeploymentIntegration, useSetEnvironmentOrder, useSetPrimaryAccount, useSetPrimaryIntegration, useSetZephyrAsDefault, useSetZephyrAsDefaultApplicationIntegration, useSetZephyrAsDefaultEnvironmentIntegration, useSetZephyrAsDefaultProjectIntegration, useSideBarProjectList, useSideBarProjectListInfinite, useSideBarProjectListSuspense, useToggleEnabled, useUnpinNavigationItem, useUnsetDefault, useUnsetDefaultApplicationIntegration, useUnsetDefaultProjectIntegration, useUnsetEnvironmentDeploymentIntegration, useUpdateApplication, useUpdateApplicationEnvironment, useUpdateApplicationName, useUpdateApplicationSettings, useUpdateApplicationTag, useUpdateCurrentUserProfile, useUpdateEmailPreferences, useUpdateEnvironmentDependencies, useUpdateEnvironmentEnvVarSet, useUpdateNonRecurringQuota, useUpdateOrganization, useUpdateOrganizationDeploymentIntegration, useUpdateOrganizationName, useUpdateOrganizationSettings, useUpdatePeople, useUpdateProjectById, useUpdateProjectContributorRole, useUpdateProjectName, useUpdateProjectSettings, useUpdateRecurringQuota, useUpdateServerAuthToken, useUpdateTeam, useUpdateTeamMemberRole, useUpdateUser, useUpdateUserAuthTokenName, useUpdateUserEmailOptions, useUpdateUserPins, useUpdateUserProfileSettings, useUpdateWorker, useUploadFromDashboardPlugin, useUpsertOrganizationMembershipDomain, useUpsertUser, useValidateAuthToken, useValidateAuthTokenInfinite, useValidateAuthTokenSuspense, useValidateEnvVarPromotion, useValidateEnvVarPromotionInfinite, useValidateEnvVarPromotionSuspense, useVerifyOrganizationMembershipDomain, validateAuthToken, validateEnvVarPromotion, zephyr_verifyOrganizationMembershipDomain as verifyOrganizationMembershipDomain };
